// i18n file for material compliance module
export const productComplianceI18n = {
  de: {
    productComplianceLogo: "AI",
    productComplianceMaterialTimeline: "Timeline",
    productComplianceSdsHubTitle: "SDB-Compliance-Hub",
    productComplianceSdsHubSubtitle:
      "KI-unterstützte Entscheidungen, nachvollziehbar und exportierbar",
    sdsNavOverview: "Übersicht",
    sdsNavSuppliers: "Lieferanten",
    sdsNavMaterials: "Materialien",
    sdsNavPolicies: "Richtlinien",
    sdsNavReassessments: "Neubewertungen",
    sdsReassessmentDocument: "SDB-Dokument",
    sdsReassessmentPriority: "Priorität",
    sdsReassessmentStatus: "Status",
    sdsReassessmentPolicyVersion: "Richtlinienversion",
    sdsReassessmentControlVersion: "Kontrollprofilversion",
    sdsReassessmentCreated: "Erstellt",
    sdsReassessmentEmpty: "Keine Neubewertungen vorhanden.",
    sdsReassessmentPrioritycritical: "Kritisch",
    sdsReassessmentPriorityhigh: "Hoch",
    sdsReassessmentPrioritynormal: "Normal",
    sdsReassessmentStatusqueued: "Eingeplant",
    sdsReassessmentStatusin_progress: "In Bearbeitung",
    sdsReassessmentStatuscompleted: "Abgeschlossen",
    sdsReassessmentStatussuperseded: "Abgelöst",
    sdsReassessmentStatusfailed: "Fehlgeschlagen",
    sdsReassessmentGovernedState: "Governance-Status",
    sdsReassessmentGovernedStatePending: "Neubewertung ausstehend",
    sdsReassessmentGovernedStatePendingDescription:
      "Eine Neubewertung mit Priorität {priority} ist offen. Diese Revision wird nicht als aktuell regiert dargestellt.",
    sdsReassessmentGovernedStateStale: "Governance nicht aktuell",
    sdsReassessmentGovernedStateStaleDescription:
      "Für diese Revision liegt keine aktuelle wirksame Governance vor.",
    sdsReassessmentGovernedStateUnknown: "Governance unbekannt",
    sdsReassessmentGovernedStateUnknownDescription:
      "Richtlinienanwendbarkeit ist nicht eindeutig oder nicht konfiguriert.",
    sdsReassessmentGovernedStateCurrent: "Aktuell regiert",
    sdsReassessmentGovernedStateCurrentDescription:
      "Diese Revision hat eine wirksame Governance ohne offene Neubewertung.",
    sdsNavActions: "Aktionen",
    sdsNavComparison: "Gegenüberstellung",
    sdsNavNewComparison: "Neue Gegenüberstellung",
    productComplianceLatency: "Latenz 230ms",
    productComplianceAuditStreamingOn: "Audit-Streaming aktiv",
    productComplianceTabDashboard: "Rollenbasiertes Dashboard",
    productComplianceTabWorkspaceDiff: "Workspace Smart Diff",
    productComplianceTabTimelineEvidence: "Timeline + Evidence Pack",
    productComplianceTabSitesVariables: "Standorte & Variablen",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Admin",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "Ausstehende Prüfung",
    productComplianceDashboardSummaryPendingDescription:
      "Dokumente warten auf Validierung",
    productComplianceDashboardSummaryOverdue: "Überfällige Aufgaben",
    productComplianceDashboardSummaryOverdueDescription:
      "Zugewiesene Aktionen außerhalb SLA",
    productComplianceDashboardSummaryReviewTime: "Ø Prüfzeit",
    productComplianceDashboardSummaryReviewTimeDescription:
      "Über letzte 30 Tage",
    productComplianceDashboardSummaryPrioritization: "Priorisierung",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Automatisch voranalysierte Abschnitte",
    productComplianceDashboardLibraryTitle: "Materialbibliothek",
    productComplianceDashboardLibrarySubtitle:
      "Suche, Risiko und direkter Zugriff auf den Workspace",
    productComplianceDashboardUploadDrop: "SDB-Datei hier ablegen oder",
    productComplianceDashboardUploadBrowse: "zum Durchsuchen klicken",
    productComplianceDashboardSearchPlaceholder:
      "Nach Material oder CAS suchen...",
    productComplianceDashboardColumnMaterial: "Material",
    productComplianceDashboardColumnWorkflow: "Workflow",
    productComplianceDashboardColumnRiskScore: "Risikoscore",
    productComplianceDashboardOpenWorkspace: "Workspace öffnen",
    productComplianceDashboardWorkspaceNotificationTitle: "Workspace",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Workspace öffnen: {name}",
    productComplianceDashboardUploadComment:
      "SDB-Upload aus Material-Compliance-Dashboard",
    productComplianceDashboardUploadSingleFileWarning:
      "Nur eine Datei gleichzeitig erlaubt ({fileName}).",
    sdsMaterialListKpiAwaitingReview: "Ausstehende Prüfung",
    sdsMaterialListKpiInProgress: "In Bearbeitung",
    sdsMaterialListKpiParsingIncomplete: "Parsing unvollständig",
    sdsMaterialListFilterAll: "Alle",
    sdsMaterialListFilterPendingReview: "Ausstehend",
    sdsMaterialListFilterInProgress: "In Bearbeitung",
    sdsMaterialListFilterApproved: "Freigegeben",
    sdsMaterialListFilterObsolete: "Veraltet",
    sdsMaterialListImportSds: "SDB importieren",
    sdsMaterialListReviewSds: "SDB prüfen",
    sdsMaterialListOpenMaterial: "Material öffnen",
    sdsMaterialAddButton: "Material anlegen",
    sdsMaterialFieldName: "Handelsname",
    sdsMaterialFieldNumber: "Interner Code",
    sdsMaterialFieldCas: "CAS-Nummer",
    sdsMaterialFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsMaterialFieldUfi: "UFI",
    sdsMaterialFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsMaterialFieldDescription: "Beschreibung",
    sdsMaterialFieldPrimarySupplier: "Primärer Lieferant",
    sdsFeatureRequiresBackend:
      "Diese Funktion benötigt ein Backend-Update und ist aktuell deaktiviert.",
    sdsValidationRequired: "Pflichtfeld",
    sdsMaterialValidationRequired:
      "Bitte Handelsname und internen Code ausfüllen.",
    sdsMaterialListColumnMaterial: "Material",
    sdsMaterialListColumnSupplier: "Lieferant",
    sdsMaterialListColumnSdsStatus: "SDB-Status",
    sdsMaterialListColumnWorkflowStatus: "Prüfstatus",
    sdsMaterialListColumnSections: "Abschnitte",
    sdsMaterialListColumnLastUpdated: "Zuletzt aktualisiert",
    sdsOverviewTitle: "Compliance Übersicht",
    sdsOverviewAwaitingReview: "Ausstehende Prüfung",
    sdsOverviewAwaitingReviewDesc: "Materialien warten auf Freigabe",
    sdsOverviewInProgress: "In Bearbeitung",
    sdsOverviewInProgressDesc: "Aktive Compliance-Prüfungen",
    sdsOverviewOverdue: "Überfällig",
    sdsOverviewOverdueDesc: "Materialien mit ausstehender Prüfung (>14 Tage)",
    sdsOverviewApprovedThisMonth: "Letzte 30 Tage freigegeben",
    sdsOverviewApprovedThisMonthDesc:
      "Freigegebene Materialien (letzte 30 Tage)",
    sdsOverviewPriorityQueue: "Materialien mit Priorität",
    sdsOverviewNothingPending: "Keine offenen Prüfungen.",
    sdsOverviewQuickActions: "Schnellaktionen",
    sdsOverviewExportActions: "Aktionsbericht exportieren",
    sdsOverviewDaysPending: "Tage offen",
    sdsOverviewComingSoon: "In Vorbereitung",
    sdsWorkspaceImportNewVersion: "Neue Version importieren",
    sdsWorkspaceViewHistory: "Verlauf anzeigen",
    sdsWorkspaceCurrentVersion: "Aktuelle Version",
    sdsWorkspaceSectionsDetected: "Erkannte Abschnitte",
    sdsWorkspaceMissingSections: "Fehlende Abschnitte",
    sdsApprovedSourcesTitle: "Freigegebene Quellen",
    sdsApprovedSourcesEmpty: "Keine freigegebenen Quellen verfügbar.",
    sdsWorkspaceCompareTitle: "Versionen vergleichen",
    sdsWorkspaceSelectBaseline: "Baseline auswählen",
    sdsWorkspaceSelectIncoming: "Eingehende Version auswählen",
    sdsWorkspaceSelectPlaceholder: "Version auswählen",
    sdsWorkspaceComparingPreview: "Vergleich: {baseline} vs. {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Aktuell wird nur die neueste Version angezeigt. Vollständiger Versionsverlauf ist nach einem Backend-Update verfügbar.",
    sdsWorkspaceStartComparison: "Vergleich starten",
    sdsFactsTitle: "Extrahierte SDB-Daten",
    sdsFactsOpen: "Daten prüfen",
    sdsFactsBack: "Zum Material",
    sdsFactsStatus: "Extraktionsstatus: {status}",
    sdsFactsMissingSections: "Fehlende Abschnitte: {sections}",
    sdsFactsDurableNotice:
      "Änderungen werden versionsbezogen gespeichert und auditierbar protokolliert.",
    sdsFactsLoadFailed: "Extrahierte SDB-Daten konnten nicht geladen werden.",
    sdsFactsLoadFailedDescription:
      "Prüfen Sie die Verbindung und laden Sie die Daten erneut.",
    sdsFactsSection1: "Abschnitt 1 - Stoff-/Produkt- und Firmenbezeichnung",
    sdsFactsSection2: "Abschnitt 2 - Mögliche Gefahren",
    sdsFactsSection3: "Abschnitt 3 - Zusammensetzung/Angaben zu Bestandteilen",
    sdsFactsSection8:
      "Abschnitt 8 - Expositionsbegrenzung und Schutzausrüstung",
    sdsFactsSection14: "Abschnitt 14 - Angaben zum Transport",
    sdsFactsSection15: "Abschnitt 15 - Rechtsvorschriften",
    sdsFactsMaterialName: "Produktname",
    sdsFactsMaterialNumber: "Materialnummer",
    sdsFactsSupplierName: "Lieferantenname",
    sdsFactsHazardClasses: "Gefahrenklassen",
    sdsFactsHStatements: "H-Sätze",
    sdsFactsSignalWord: "Signalwort",
    sdsFactsSubstances: "Bestandteile",
    sdsFactsAddSubstance: "Bestandteil hinzufügen",
    sdsFactsNoSubstances: "Keine Bestandteile erfasst.",
    sdsFactsSubstanceName: "Stoffname",
    sdsFactsSubstanceCas: "CAS-Nummer",
    sdsFactsConcentrationMin: "Konzentration von",
    sdsFactsConcentrationMax: "Konzentration bis",
    sdsFactsConcentrationUnit: "Einheit",
    sdsFactsSubstanceConfidence: "Konfidenz (0 bis 1)",
    sdsFactsExposureControls: "Expositionsbegrenzung",
    sdsFactsPersonalProtection: "Persönliche Schutzausrüstung",
    sdsFactsExposureLimits: "Arbeitsplatzgrenzwerte",
    sdsFactsUnNumber: "UN-Nummer",
    sdsFactsShippingName: "Richtige Versandbezeichnung",
    sdsFactsTransportClass: "Transportgefahrenklasse",
    sdsFactsPackingGroup: "Verpackungsgruppe",
    sdsFactsNumberInvalid: "{field} muss eine Zahl sein.",
    sdsFactsConfidenceInvalid: "Die Konfidenz muss zwischen 0 und 1 liegen.",
    sdsFactsAuditCount: "{count} manuelle Änderungen protokolliert",
    sdsFactsDiscard: "Änderungen verwerfen",
    sdsFactsSaved: "SDB-Daten wurden gespeichert.",
    sdsWizardBadge: "Assistent",
    sdsWizardStep1Title: "Material wählen",
    sdsWizardStep2Title: "Versionen wählen",
    sdsWizardStep3Title: "Konfigurieren",
    sdsWizardSelectedMaterial: "Ausgewähltes Material",
    sdsWizardVersionsStubNotice:
      "Nur eine Version ist für dieses Material verfügbar. Importieren Sie weitere Versionen oder warten Sie auf den Versionsverlauf-Endpunkt.",
    sdsWizardCrossSupplier: "Lieferantenübergreifender Vergleich",
    sdsWizardCrossSupplierDesc:
      "Wenn aktiviert, können Baseline und Incoming von unterschiedlichen Lieferanten stammen.",
    sdsWizardNoBaselineOptions: "Keine Baseline-Versionen verfügbar.",
    sdsWizardNoIncomingOptions: "Keine eingehenden Versionen verfügbar.",
    sdsWizardComparisonName: "Vergleichsname",
    sdsWizardComparisonNotes: "Notizen",
    sdsWizardBack: "Zurück",
    sdsWizardNext: "Weiter",
    sdsWizardStartComparison: "Vergleich starten",
    sdsComparisonToolbarViewSplit: "Geteilt",
    sdsComparisonToolbarViewUnified: "Vereinheitlicht",
    sdsComparisonToolbarShowChangesOnly: "Nur Änderungen anzeigen",
    sdsComparisonToolbarJumpSection: "Zu Abschnitt springen",
    sdsComparisonDevelopmentModeNotice:
      "Entwicklungsmodus: Mock-Vergleichsdaten werden angezeigt. Verbinden Sie /api/product-compliance/comparisons/:id, sobald verfügbar.",
    sdsReportExportComparison: "SDB-Vergleichsbericht exportieren",
    sdsReportBrand: "SMX Product Compliance",
    sdsReportTitle: "SDB-Vergleichsbericht",
    sdsReportGeneratedOn: "Erstellt am",
    sdsReportMaterial: "Material",
    sdsReportBaseline: "Baseline",
    sdsReportIncoming: "Neue Version",
    sdsReportBy: "Erstellt von",
    sdsReportDate: "Vergleichsdatum",
    sdsReportExecutiveSummary: "Management-Zusammenfassung",
    sdsReportCriticalChanges: "Kritische Änderungen",
    sdsReportHighChanges: "Hohe Änderungen",
    sdsReportActionsAssigned: "Zugewiesene Aktionen",
    sdsReportSections: "Abschnitte",
    sdsReportSectionAnalysis: "Abschnittsanalyse",
    sdsReportNoNote: "Keine Compliance-Notiz vorhanden.",
    sdsReportUnchangedSections: "Unveränderte Abschnitte",
    sdsReportReviewedBy: "Geprüft von",
    sdsReportApprovedBy: "Freigegeben von",
    sdsReportSignature: "Unterschrift",
    sdsReportEvidenceVersionsTitle: "Alle SDB-Versionen",
    sdsReportEvidenceVersionLabel: "Versionsbezeichnung",
    sdsReportEvidenceRevisionDate: "Revisionsdatum",
    sdsReportEvidenceImportDate: "Importdatum",
    sdsReportEvidenceWorkflowStatus: "Workflow-Status",
    sdsReportEvidenceSectionsDetected: "Erkannte Abschnitte",
    sdsReportEvidenceComparisonsTitle: "Vergleichshistorie",
    sdsReportEvidenceNoComparisons: "Keine abgeschlossenen Vergleiche erfasst.",
    sdsReportEvidenceOpenActionsTitle: "Zusammenfassung offener Aktionen",
    sdsReportEvidenceActionCount: "Anzahl",
    sdsReportEvidenceNoOpenActions: "Keine offenen Aktionen vorhanden.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "Kein Inhalt vorhanden",
    sdsComparisonUnchangedHidden: "unveränderte Abschnitte ausgeblendet",
    sdsComparisonShowAllSections: "Alle anzeigen",
    sdsComparisonSectionCriticalChange: "Kritische Änderung",
    sdsComparisonSectionHighImpact: "Hohe Auswirkung",
    sdsComparisonSectionChanged: "Geändert",
    sdsComparisonSectionMinorChange: "Kleine Änderung",
    sdsComparisonSectionNoChange: "Keine Änderung",
    sdsNoteComplianceImpactLabel: "Compliance-Auswirkung",
    sdsNoteComplianceImpactPlaceholder:
      "Beschreiben Sie die Compliance-Auswirkung für diesen Abschnitt.",
    sdsNoteRequiredForCritical:
      "Bei kritischen/hohen Änderungen ist eine Notiz erforderlich.",
    sdsNoteChangeSeverityLabel: "Änderungsschwere",
    sdsNoteChangeSeverityNone: "Keine",
    sdsNoteChangeSeverityLow: "Niedrig",
    sdsNoteChangeSeverityMedium: "Mittel",
    sdsNoteChangeSeverityHigh: "Hoch",
    sdsNoteChangeSeverityCritical: "Kritisch",
    sdsNoteAssignedActions: "Zugewiesene Aktionen",
    sdsNoteAddAction: "Aktion hinzufügen",
    sdsNoteDepartmentLabel: "Abteilung",
    sdsNoteActionTypeLabel: "Aktionstyp",
    sdsNoteActionTypeOther: "Andere",
    sdsNoteDueDateLabel: "Fällig am",
    sdsDeptPlantSafety: "Anlagensicherheit",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Einkauf",
    sdsDeptQuality: "Qualität",
    sdsDeptLogistics: "Logistik",
    sdsDeptWarehouse: "Lager",
    sdsActionUpdateSops: "SOPs aktualisieren",
    sdsActionUpdateEmergencyProcedures: "Notfallverfahren aktualisieren",
    sdsActionUpdateWorkplaceSignage: "Arbeitsplatzkennzeichnung aktualisieren",
    sdsActionScheduleTraining: "Schulung planen",
    sdsActionUpdateRiskAssessment: "Risikobewertung aktualisieren",
    sdsActionReportToAuthority: "An Behörde melden",
    sdsActionVendorQuery: "Rückfrage an Lieferanten",
    sdsActionSupplierQualification: "Lieferantenqualifizierung",
    sdsActionSourceAlternative: "Alternative Quelle suchen",
    sdsActionUpdateSpecification: "Spezifikation aktualisieren",
    sdsActionUpdateMaterialDataSheet: "Materialdatenblatt aktualisieren",
    sdsActionUpdateTransportDoc: "Transportdokument aktualisieren",
    sdsActionUpdateHazmatDeclaration: "Gefahrguterklärung aktualisieren",
    sdsActionUpdateStorageSop: "Lager-SOP aktualisieren",
    sdsActionReviewSegregation: "Separationskonzept prüfen",
    sdsActionsTitle: "Aktionsverfolgung",
    sdsActionsFilterStatus: "Status",
    sdsActionsFilterDepartment: "Abteilung",
    sdsActionsFilterMaterial: "Material oder CAS suchen",
    sdsActionsFilterDueDateFrom: "Fällig von",
    sdsActionsFilterDueDateTo: "Fällig bis",
    sdsActionsColumnMaterial: "Material",
    sdsActionsColumnSection: "Abschnitt",
    sdsActionsColumnDepartment: "Abteilung",
    sdsActionsColumnAction: "Aktion",
    sdsActionsColumnDueDate: "Fälligkeit",
    sdsActionsColumnStatus: "Status",
    sdsActionsMarkComplete: "Abschließen",
    sdsActionsMarkCompleteConfirm:
      "Möchten Sie diese Aktion als abgeschlossen markieren?",
    sdsActionsMarkedComplete: "Aktion als abgeschlossen markiert",
    sdsActionsStatusOpen: "Offen",
    sdsActionsStatusInProgress: "In Bearbeitung",
    sdsActionsStatusCompleted: "Abgeschlossen",
    sdsActionsStatusOverdue: "Überfällig",
    sdsActionsSelected: "ausgewählt",
    sdsActionsEmptyState:
      "Noch keine Compliance-Aktionen vorhanden. Aktionen werden bei der Vergleichsprüfung erstellt.",
    sdsActionsBackendNotice:
      "Die Aktionsliste zeigt derzeit keine Backend-Daten. Inhalte erscheinen, sobald die API-Integration verfügbar ist.",
    sdsApproveReviewDecision: "Prüfung & Entscheidung",
    sdsApproveDocumentationProgress: "Dokumentationsfortschritt",
    sdsApproveBlockedMissingNotes: "Freigabe blockiert, fehlende Notizen",
    sdsApproveOpenActions: "Offene Aktionen",
    sdsApproveComparisonStarted: "Vergleich gestartet",
    sdsApproveBaseline: "Baseline",
    sdsApproveIncoming: "Incoming",
    sdsApproveButton: "Freigeben",
    sdsRejectButton: "Ablehnen",
    sdsApproveConfirmMessage:
      "Möchten Sie diesen Vergleich wirklich freigeben?",
    sdsApproveConfirmMessageDetailed:
      'Möchten Sie "{incoming}" als neue Baseline für "{material}" freigeben? Die bisherige Baseline ("{baseline}") wird als ersetzt archiviert.',
    sdsApproveConfirmTitle: "Vergleich freigeben",
    sdsApproveSuccess: "Vergleich erfolgreich freigegeben",
    sdsRejectReasonPrompt: "Bitte Ablehnungsgrund eingeben",
    sdsRejectTitle: "Vergleich ablehnen",
    sdsRejectSuccess: "Vergleich wurde abgelehnt",
    productComplianceWorkflowReceived: "Eingegangen",
    productComplianceWorkflowInProgress: "In Bearbeitung",
    productComplianceWorkflowApproved: "Freigegeben",
    productComplianceWorkflowObsolete: "Veraltet",
    productComplianceMaterialTimelineSummaryPending: "Ausstehende Prüfungen",
    productComplianceMaterialTimelineSummaryPendingDescription:
      "Versionen mit offener Freigabe",
    productComplianceMaterialTimelineSummaryApproved: "Freigegeben",
    productComplianceMaterialTimelineSummaryApprovedDescription:
      "Versionen mit validierter Konformität",
    productComplianceMaterialTimelineSummarySuperseded: "Ersetzt",
    productComplianceMaterialTimelineSummarySupersededDescription:
      "Versionen nur zur Rückverfolgung",
    productComplianceMaterialTimelineSectionTitle: "Vollständige Timeline",
    productComplianceMaterialTimelineSectionSubtitle:
      "Chronologische SDB-Versionen, Status, Importe und letzte Änderungen",
    productComplianceMaterialTimelineFamilySearchPlaceholder:
      "Nach CAS, Lieferant oder Material suchen...",
    productComplianceMaterialTimelineFamilyMaterial: "Material",
    productComplianceMaterialTimelineFamilySupplier: "Lieferant",
    productComplianceMaterialTimelineFamilyVersions: "Versionen",
    productComplianceMaterialTimelineOrderAz: "A-Z",
    productComplianceMaterialTimelineOrderNewest: "Neueste zuerst",
    productComplianceMaterialTimelineOrderOldest: "Älteste zuerst",
    productComplianceMaterialTimelineSearchPlaceholder:
      "Version, Lieferant oder Änderung suchen...",
    productComplianceMaterialTimelineImported: "Import",
    productComplianceMaterialTimelineLatestChanges: "Letzte Änderungen",
    productComplianceMaterialTimelineEmpty:
      "Keine Timeline-Einträge für die aktuelle Suche.",
    productComplianceMaterialTimelineShortcutsTitle: "Schnellzugriffe",
    productComplianceMaterialTimelineShortcutGenealogy:
      "Rekursive Genealogie öffnen",
    productComplianceMaterialTimelineShortcutEvidence:
      "Evidence Pack erstellen",
    productComplianceMaterialTimelineShortcutLabel: "GHS-Etikett drucken",
    productComplianceMaterialTimelineLegendTitle: "Statuslegende",
    productComplianceMaterialTimelineCompositionTitle: "Zusammensetzung",
    productComplianceMaterialTimelineCharacteristicsTitle: "Materialmerkmale",
    productComplianceMaterialTimelineDocumentSignalsTitle: "Dokumentsignale",
    productComplianceMaterialTimelineFieldSupplier: "Lieferant",
    productComplianceMaterialTimelineFieldUfi: "UFI",
    productComplianceMaterialTimelineFieldSubstance: "Substanz",
    productComplianceMaterialTimelineFieldConcentration: "Konzentration",
    productComplianceMaterialTimelineFieldSection3Source: "Quelle Abschnitt 3",
    productComplianceMaterialTimelineFieldParsingStatus: "Parsing-Status",
    productComplianceMaterialTimelineFieldSectionsDetected:
      "Erkannte Abschnitte",
    productComplianceMaterialTimelineFieldMissingSections:
      "Fehlende Abschnitte",
    productComplianceMaterialTimelineFieldAcceptability: "Akzeptanzstatus",
    productComplianceMaterialTimelineFieldAdditional: "Weitere Angaben",
    productComplianceMaterialTimelineNotAvailable: "Nicht verfügbar",
    productComplianceMaterialTimelineAcceptabilityAccepted: "Akzeptiert",
    productComplianceMaterialTimelineAcceptabilityRejected: "Abgelehnt",
    productComplianceMaterialTimelineAcceptabilityPending: "Ausstehend",
    productComplianceMaterialTimelineSection3SourceHttp: "Extraktor API",
    productComplianceMaterialTimelineSection3SourceDeterministic:
      "Deterministische Analyse",
    productComplianceMaterialTimelineSection3SourceHttpDisabled:
      "Extraktor deaktiviert",
    productComplianceMaterialTimelineParsingComplete: "Vollständig",
    productComplianceMaterialTimelineParsingIncomplete: "Unvollständig",
    productComplianceStatusPendingReview: "Ausstehend",
    productComplianceStatusApproved: "Freigegeben",
    productComplianceStatusSuperseded: "Ersetzt",
    productComplianceMaterialSodiumHydroxide: "Natriumhydroxid 50%",
    productComplianceMaterialSulfuricAcid: "Schwefelsäure 98%",
    productComplianceSupplierChemcorp: "Lieferant: ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Lieferant: GlobalChem Ltd.",
    productComplianceMaterialTimelineChangeSodium20Section2:
      "Abschnitt 2: Aktualisierte Piktogramme für Korrosionsgefahr",
    productComplianceMaterialTimelineChangeSodium20Section16:
      "Abschnitt 16: CLP-Referenzen harmonisiert",
    productComplianceMaterialTimelineChangeSodium21Section8:
      "Abschnitt 8: Expositionsgrenzen für Standort Lyon angepasst",
    productComplianceMaterialTimelineChangeSodium21Section11:
      "Abschnitt 11: Toxikologietext präzisiert",
    productComplianceMaterialTimelineChangeSodium30Section8:
      "Abschnitt 8: Verstärkte PSA, Visier obligatorisch",
    productComplianceMaterialTimelineChangeSodium30Section2:
      "Abschnitt 2: Signalwort von Warning auf Danger geändert",
    productComplianceMaterialTimelineChangeSodium30Section15:
      "Abschnitt 15: Regulatorische Referenzen ergänzt",
    productComplianceMaterialTimelineChangeSodium12Section3:
      "Abschnitt 3: Nominale Konzentration 49-51%",
    productComplianceMaterialTimelineChangeSodium12Section8:
      "Abschnitt 8: Funktionale Gleichwertigkeit bestätigt",
    productComplianceMaterialTimelineChangeSodium12Section16:
      "Abschnitt 16: Transport-Addendum ergänzt",
    productComplianceMaterialTimelineChangeSulfuric15Section8:
      "Abschnitt 8: Zusätzlicher Handschutz bei Heißabfüllung",
    productComplianceMaterialTimelineChangeSulfuric15Section14:
      "Abschnitt 14: UN-Transportklassifizierung verfeinert",
    productComplianceMaterialTimelineDeleteVersion: "Version löschen",
    productComplianceMaterialTimelineDeleteFamily: "Familie löschen",
    productComplianceMaterialTimelineDeleteVersionConfirmTitle:
      "Version löschen",
    productComplianceMaterialTimelineDeleteVersionConfirmMessage:
      'Möchten Sie die Version "{version}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    productComplianceMaterialTimelineDeleteFamilyConfirmTitle:
      "Dokumentfamilie löschen",
    productComplianceMaterialTimelineDeleteFamilyConfirmMessage:
      "Möchten Sie diese Dokumentfamilie mit allen {count} Version(en) wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    productComplianceMaterialTimelineDeleteVersionSuccess:
      "Version erfolgreich gelöscht",
    productComplianceMaterialTimelineDeleteFamilySuccess:
      "Dokumentfamilie erfolgreich gelöscht ({count} Version(en))",
    productComplianceMaterialTimelineDeleteError: "Fehler beim Löschen",
    sdsTimelineBackToWorkspace: "Zurück zum Workspace",
    sdsTimelineExportEvidence: "Nachweisbericht exportieren",
    sdsTimelineViewComparison: "Vergleich ansehen",
    sdsImportDialogTitle: "Sicherheitsdatenblatt importieren",
    sdsImportAsyncDescription:
      "Das Dokument wird gespeichert und im Hintergrund extrahiert. Sie können weiterarbeiten.",
    sdsImportFileSize: "Dateigröße",
    sdsImportSelectMaterial: "Material",
    sdsImportSelectMaterialPlaceholder: "Bestehendes Material auswählen",
    sdsImportGuidance:
      "1. Material auswählen oder anlegen · 2. Sicherheitsdatenblatt hochladen · 3. Extraktion im Hintergrund verfolgen",
    sdsImportCreateMaterial: "Neues Material anlegen",
    sdsImportCreateMaterialTitle: "Material anlegen",
    sdsImportCreateMaterialDescription:
      "Nach dem Speichern wird das neue Material für dieses Sicherheitsdatenblatt ausgewählt.",
    sdsImportButtonStartExtraction: "Extraktion starten",
    sdsImportAccepted: "SDB-Extraktion wurde gestartet.",
    sdsExtractionStatusLabel: "Extraktionsstatus",
    sdsExtractionStatusextracting: "Extraktion läuft",
    sdsExtractionStatusready: "Bereit",
    sdsExtractionStatusfailed: "Fehlgeschlagen",
    sdsExtractionStatusstale: "Überfällig",
    sdsExtractionFailed: "SDB-Extraktion ist fehlgeschlagen.",
    sdsExtractionRetry: "Extraktion wiederholen",
    sdsExtractionRetryAccepted: "SDB-Extraktion wurde erneut gestartet.",
    sdsImportStepValidating: "Datei prüfen...",
    sdsImportStepExtractingText: "Text extrahieren...",
    sdsImportStepParsingSections: "Abschnitte analysieren...",
    sdsImportStepExtractingIdentity: "Identität ermitteln...",
    sdsImportStepExtractingSubstances: "Substanzen extrahieren...",
    sdsImportStepResolvingSupplier: "Lieferant suchen...",
    sdsImportStepResolvingMaterial: "Material suchen...",
    sdsImportStepComplete: "Extraktion abgeschlossen",
    sdsImportSectionDocument: "Dokument",
    sdsImportSectionMaterial: "Material",
    sdsImportSectionSupplier: "Lieferant",
    sdsImportSectionSubstances: "Substanzen",
    sdsImportSectionSections: "Abschnitte",
    sdsImportSectionComment: "Kommentar",
    sdsImportFieldFilename: "Datei",
    sdsPolicyContext: "Richtlinienkontext",
    sdsPolicyJurisdiction: "Rechtsraum",
    sdsPolicyMarkets: "Märkte",
    sdsPolicyProductScopes: "Produktbereiche",
    sdsPolicyUfiState: "UFI-Status",
    sdsPolicyUfiStateunknown: "Unbekannt",
    sdsPolicyUfiStatepresent: "Vorhanden",
    sdsPolicyUfiStateabsent: "Nicht vorhanden",
    sdsPolicyUnconfigured: "Richtlinienkontext nicht konfiguriert",
    sdsPolicyContextReasonufi_state_unknown:
      "UFI-Status ist noch nicht aus einer abgeschlossenen Extraktion bestimmt.",
    sdsPolicyContextReasonno_matching_regulatory_policy:
      "Keine passende regulatorische Richtlinienversion gefunden.",
    sdsPolicyContextReasonno_matching_organization_control_profile:
      "Kein passendes organisatorisches Kontrollprofil gefunden.",
    sdsPolicyAmbiguous: "Richtlinienkontext ist mehrdeutig",
    sdsPolicyAmbiguousDescription:
      "Eine berechtigte Richtlinienadministration muss ein passendes Paar bestätigen.",
    sdsPolicyRegulatoryVersion: "Regulatorische Richtlinienversion",
    sdsPolicyControlVersion: "Kontrollprofilversion",
    sdsPolicyConfirmationRationale: "Begründung",
    sdsPolicyConfirm: "Anwendbarkeit bestätigen",
    sdsPolicyStatus: "Status",
    sdsPolicyConfirmed: "Bestätigt",
    sdsPolicyResolved: "Aufgelöst",
    sdsPolicyConfirmationSaved: "Richtlinienanwendbarkeit wurde bestätigt.",
    sdsPolicyRegulatoryPolicies: "Regulatorische Richtlinien",
    sdsPolicyControlProfiles: "Organisatorische Kontrollprofile",
    sdsPolicyVersions: "Versionen",
    sdsPolicyEmpty: "Keine Richtlinien verfügbar.",
    sdsPolicyCreateRegulatory: "Regulatorische Richtlinie anlegen",
    sdsPolicyCreateControl: "Kontrollprofil anlegen",
    sdsPolicyEffectiveFrom: "Gültig ab",
    sdsPolicyEffectiveUntil: "Gültig bis",
    sdsPolicyUfiApplicability: "UFI-Anwendbarkeit",
    sdsPolicyUfiRequired: "Erforderlich",
    sdsPolicyUfiOptional: "Optional",
    sdsPolicyUfiNotApplicable: "Nicht anwendbar",
    sdsPolicyRuleSubject: "Regelgegenstand",
    sdsPolicyRuleCondition: "Regelbedingung",
    sdsPolicyEvaluationMode: "Bewertungsmethode",
    sdsPolicyEvaluationModeReviewerAssessed: "Durch Prüfer bewertet",
    sdsPolicyEvaluationModereviewer_assessed: "Durch Prüfer bewertet",
    sdsPolicyEvidenceRequirements: "Nachweisanforderungen",
    sdsPolicySeverity: "Schweregrad",
    sdsPolicySeverityLow: "Niedrig",
    sdsPolicySeverityMedium: "Mittel",
    sdsPolicySeverityHigh: "Hoch",
    sdsPolicySeverityCritical: "Kritisch",
    sdsPolicyBlockingEffect: "Sperrwirkung",
    sdsPolicyBlockingEffectNone: "Keine",
    sdsPolicyBlockingEffectAssessment: "Bewertung sperren",
    sdsPolicyBlockingEffectApproval: "Freigabe sperren",
    sdsPolicyCitationSource: "Quellenwerk",
    sdsPolicyCitationReference: "Fundstelle",
    sdsPolicyCitationUrl: "Quellen-URL",
    sdsPolicyControlRequirement: "Kontrollanforderung",
    sdsPolicyRegulatoryRuleId: "ID der regulatorischen Regel",
    sdsPolicyControlEffect: "Kontrollwirkung",
    sdsPolicyControlEffectAdditional: "Zusätzliche Anforderung",
    sdsPolicyControlEffectStrengthen: "Anforderung verstärken",
    sdsImportFieldPages: "Seiten",
    sdsImportFieldLanguage: "Sprache",
    sdsImportFieldRevisionDate: "Revisionsdatum",
    sdsImportFieldMaterialName: "Materialname",
    sdsImportFieldMaterialNumber: "Materialnummer",
    sdsImportFieldTradeName: "Handelsname",
    sdsImportFieldUfi: "UFI",
    sdsImportConfidence: "Konfidenz: {value}%",
    sdsImportFieldSupplierName: "Lieferantenname",
    sdsImportSupplierNotFound:
      "Lieferant im Register nicht gefunden. Sie können mit einem bestehenden Lieferanten verknüpfen oder neuen Eintrag übernehmen.",
    sdsImportMaterialNotFound:
      "Material im Katalog nicht gefunden. Sie können mit einem bestehenden Material verknüpfen oder neuen Eintrag übernehmen.",
    sdsImportLinkExistingSupplier: "Bestehenden Lieferanten verknüpfen",
    sdsImportLinkExistingMaterial: "Bestehendes Material verknüpfen",
    sdsSupplierListTitle: "Lieferanten",
    sdsSupplierAddButton: "Lieferant hinzufügen",
    sdsMaterialCreated: "Material wurde angelegt.",
    sdsSupplierEmptyState: "Keine Lieferanten verfügbar.",
    sdsSupplierBackendNotice:
      "Die Lieferantenverwaltung erfordert ein Backend-Update — die Liste erscheint, sobald sie verfügbar ist.",
    sdsSupplierContact: "Kontakt",
    sdsSupplierMaterialsCount: "Materialien",
    sdsSupplierSdsDocuments: "SDB-Dokumente",
    sdsSupplierSdsEmptyState: "Keine SDB-Dokumente verfügbar.",
    sdsSupplierFieldName: "Name",
    sdsSupplierFieldCode: "Code",
    sdsSupplierFieldCountry: "Land",
    sdsSupplierFieldAddress: "Adresse",
    sdsSupplierFieldContactName: "Kontaktname",
    sdsSupplierFieldContactEmail: "Kontakt-E-Mail",
    sdsSupplierFieldContact: "Kontakt",
    sdsSupplierFieldStatus: "Status",
    sdsSupplierFieldNotes: "Notizen",
    sdsSupplierCodePlaceholder: "Lieferantencode",
    sdsSupplierStatusActive: "Aktiv",
    sdsSupplierStatusInactive: "Inaktiv",
    sdsSupplierStatusUnderReview: "In Prüfung",
    sdsSupplierSavedSuccess: "Lieferant erfolgreich gespeichert.",
    sdsSupplierDetailTitle: "Lieferantendetails",
    sdsSupplierNotVerified: "Nicht verifiziert",
    sdsSupplierFormCrudNotice:
      "Anlegen und Bearbeiten von Lieferanten erfordert ein Backend-Update. Das Formular kann bereits ausgefüllt werden.",
    sdsImportFieldLongComment: "Notiz",
    sdsImportSubstanceName: "Name",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Konzentration",
    sdsImportSubstanceAdd: "Substanz hinzufügen",
    sdsImportButtonConfirm: "Import bestätigen",
    sdsImportStatusFound: "Gefunden",
    sdsImportStatusCreated: "Neu angelegt",
    sdsImportStatusNotFound: "Nicht gefunden",
    sdsImportStatusError: "Fehler",
    sdsImportConfirmSuccess: "Import erfolgreich bestätigt",
    sdsImportConfirmSuccessWithMaterial:
      "SDB erfolgreich importiert — {material}",
    sdsImportAnalyzing: "Analysiert...",
    sdsImportStreamError: "Fehler bei der Extraktion",
    sdsImportWarnings: "Warnungen",
    sdsImportPreviewReady: "Vorschau bereit – Felder prüfen und bestätigen",
    sdsImportNoFile: "Keine Datei ausgewählt",
    sdsImportUfiInvalid:
      "Ungültiges Format – erwartet: XXXX-XXXX-XXXX-XXXX (z.B. A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Ungültige CAS-Nummer – erwartet: XXXXXXX-XX-X mit gültiger Prüfziffer",
    sdsNavApplication: "SDB",
    sdsNavDashboard: "Dashboard",
    sdsNavInbox: "Dashboard",
    sdsNotAvailable: "Nicht verfügbar",
    sdsInboxTitle: "Dashboard",
    sdsInboxUpload: "SDB hochladen",
    sdsInboxSearchPlaceholder: "Dokument, Produkt oder Lieferant suchen",
    sdsInboxExtractionFilter: "Extraktionsstatus",
    sdsInboxResolutionFilter: "Auflösungsstatus",
    sdsInboxSupplierResolutionFilter: "Ausstellerauflösung",
    sdsInboxMaterialResolutionFilter: "Materialzuordnung",
    sdsInboxReviewFilter: "Prüfstatus",
    sdsInboxValidityFilter: "Gültigkeit",
    sdsInboxSupplierFilter: "Aussteller",
    sdsInboxMaterialFilter: "Material",
    sdsInboxAllStates: "Alle Status",
    sdsInboxDocument: "Dokument",
    sdsInboxVersion: "Version {version}",
    sdsInboxRevisionDate: "Datum / überarbeitet am",
    sdsInboxIdentity: "Extrahierte Identität",
    sdsInboxIssuer: "Aussteller",
    sdsInboxRelatedMaterials: "Zugeordnete Materialien",
    sdsInboxRelatedMaterialsCount: "{count} zugeordnet",
    sdsInboxExtraction: "Extraktion",
    sdsInboxResolution: "Auflösung",
    sdsInboxReview: "Prüfstatus",
    sdsInboxValidity: "Gültigkeit",
    sdsInboxLastActivity: "Letzte Aktivität",
    sdsResolutionStatusunresolved: "Nicht aufgelöst",
    sdsResolutionStatusin_progress: "In Bearbeitung",
    sdsResolutionStatusresolved: "Aufgelöst",
    sdsSupplierResolutionStatusunresolved: "Aussteller nicht aufgelöst",
    sdsSupplierResolutionStatusconfirmed: "Aussteller bestätigt",
    sdsSupplierResolutionStatuscorrected: "Aussteller korrigiert",
    sdsMaterialResolutionStatusunassigned: "Kein Material zugeordnet",
    sdsMaterialResolutionStatusambiguous: "Materialentscheidung ausstehend",
    sdsMaterialResolutionStatusassigned: "Material zugeordnet",
    sdsValidityStatusvalid: "Gültig",
    sdsValidityStatusexpiring: "Läuft bald ab",
    sdsValidityStatusexpired: "Abgelaufen",
    sdsValidityStatusunknown: "Gültigkeit unbekannt",
    sdsWorkflowreceived: "Eingegangen",
    sdsWorkflowin_progress: "In Bearbeitung",
    sdsWorkflowapproved: "Freigegeben",
    sdsWorkflowobsolete: "Veraltet",
    sdsDocumentTitle: "SDB-Dokument",
    sdsDocumentBackToInbox: "Zum Dashboard",
    sdsDocumentRetryExtraction: "Extraktion wiederholen",
    sdsDocumentExtractionFailed: "Extraktion fehlgeschlagen",
    sdsDocumentExtractionFailedDescription:
      "Die Extraktion konnte nicht abgeschlossen werden. Wiederholen Sie den Vorgang oder wenden Sie sich an den Support.",
    sdsDocumentExtractionStale: "Extraktion überfällig",
    sdsDocumentExtractionStaleDescription:
      "Die Extraktion hat ihr Zeitlimit überschritten. Wiederholen Sie die Extraktion.",
    sdsDocumentDispatchFailed: "Extraktionsversand fehlgeschlagen",
    sdsDocumentDispatchFailedDescription:
      "Die Extraktion konnte nicht gestartet werden. Wiederholen Sie den Versand.",
    sdsDocumentExtractionAttempt: "Extraktionsversuch",
    sdsDocumentExtractionStarted: "Extraktion gestartet",
    sdsDocumentExtractionCompleted: "Extraktion abgeschlossen",
    sdsDocumentAttemptCompleted: "Abgeschlossen am",
    sdsDocumentAttemptExtraction: "Methode und Workflow",
    sdsDocumentAttemptProviderModel: "Anbieter: {provider} · Modell: {model}",
    sdsDocumentAttemptConfidence: "Sicherheit: {semantics} · {level}",
    sdsDocumentAttemptProvenance: "Herkunftsnachweis",
    sdsDocumentAttemptSourceMode: "Quelle: {sourceMode}",
    sdsDocumentAttemptNoSourceReferences: "Keine Quellstellen verfügbar",
    sdsDocumentAttemptSourcePage: "Seite {page}",
    sdsDocumentAttemptSourceSpan: "Seite {page}, Zeichen {start}–{end}",
    sdsDocumentAttemptCompleteProvenance: "Herkunftsnachweis vollständig",
    sdsDocumentAttemptMissingSections: "Fehlende Abschnitte: {sections}",
    sdsDocumentAttemptUnavailableFragments:
      "Nicht verfügbare Fragmente: {count}",
    sdsDocumentAttemptIncompleteTableProvenance:
      "Tabellenherkunft unvollständig",
    sdsDocumentAttemptFailure: "Fehlerdetails",
    sdsDocumentAttemptFailureCode: "Code: {code}",
    sdsDocumentAttemptFailureField: "Feld: {field}",
    sdsDocumentAttemptFailureReason: "Grund: {reason}",
    sdsDocumentAttemptGovernance: "Extraktionsbewertung",
    sdsDocumentAttemptGovernanceDescription:
      "Persistierte Bewertung dieses Extraktionsversuchs. Der Prüfstatus wird vom Backend festgelegt.",
    sdsDocumentAttemptTextSource: "Textquelle",
    sdsDocumentAttemptTextSourcenative_text: "Eingebetteter Text",
    sdsDocumentAttemptTextSourceocr: "Texterkennung (OCR)",
    sdsDocumentAttemptLanguage: "Erkannte Sprache",
    sdsDocumentAttemptLanguageSupportsupported: "Unterstützt",
    sdsDocumentAttemptLanguageSupportunsupported: "Nicht unterstützt",
    sdsDocumentAttemptRequiredContent: "Pflichtinhalte",
    sdsDocumentAttemptRequiredContentcomplete: "Vollständig",
    sdsDocumentAttemptRequiredContentincomplete: "Unvollständig",
    sdsDocumentAttemptRequiredContentinvalid: "Ungültig",
    sdsDocumentAttemptRequiredContentunavailable: "Nicht verfügbar",
    sdsDocumentAttemptUncertainty: "Unsicherheit",
    sdsDocumentAttemptUncertaintynone: "Keine",
    sdsDocumentAttemptUncertaintycontradictory: "Widersprüchlich",
    sdsDocumentAttemptReviewReadiness: "Prüfbereitschaft",
    sdsDocumentAttemptReviewreview_ready: "Prüfbereit",
    sdsDocumentAttemptReviewblocked: "Blockiert",
    sdsDocumentAttemptMissingFields: "Fehlende Pflichtfelder",
    sdsDocumentAttemptInvalidFields: "Ungültige Pflichtfelder",
    sdsDocumentAttemptRequiredContentIssue: "{field}: {reason}",
    sdsDocumentAttemptContradictions: "Widersprüchliche Angaben",
    sdsDocumentAttemptEvidenceIds: "Beleg-IDs: {evidenceIds}",
    sdsDocumentAttemptBlockingReasons: "Blockierende Gründe",
    sdsDocumentAttemptBlockingReasonunsupported_language:
      "Nicht unterstützte Sprache",
    sdsDocumentAttemptBlockingReasonincomplete_required_content:
      "Unvollständige Pflichtinhalte",
    sdsDocumentAttemptBlockingReasoninvalid_required_content:
      "Ungültige Pflichtinhalte",
    sdsDocumentAttemptBlockingReasoncontradictory_evidence:
      "Widersprüchliche Belege",
    sdsDocumentAttemptBlockingReasonmalformed_input: "Ungültige Eingabe",
    sdsDocumentAttemptBlockingReasonterminal_failure: "Terminaler Fehler",
    sdsDocumentFailureRetryable: "Wiederholung möglich",
    sdsDocumentFailureNotRetryable: "Keine Wiederholung möglich",
    sdsDocumentSelectVersion: "Version auswählen",
    sdsDocumentTabDocument: "Dokument und Versionen",
    sdsDocumentTabExtraction: "Extraktion auswerten",
    sdsDocumentTabFacts: "Sicherheitsdatenblatt",
    sdsDocumentTabSupplier: "Aussteller",
    sdsDocumentTabMaterials: "Anwendbare Materialien",
    sdsDocumentTabEvidence: "Quellnachweise",
    sdsDocumentTabAssessment: "Gesteuerte Bewertung",
    sdsDocumentTabActivity: "Aktivität",
    sdsRevisionComparisonTitle: "Revisionsvergleich",
    sdsRevisionComparisonDescription:
      "Vergleichen Sie diese Revision mit der aktuellen wirksamen Revision desselben Sicherheitsdatenblatts.",
    sdsRevisionComparisonCreate: "Vergleich erstellen",
    sdsRevisionComparisonRefresh: "Vergleich neu laden",
    sdsRevisionComparisonBaseline: "Wirksame Ausgangsrevision",
    sdsRevisionComparisonCandidate: "Kandidatenrevision",
    sdsRevisionComparisonCreated: "Erstellt am",
    sdsRevisionComparisonDigest: "Vergleichsprüfsumme",
    sdsRevisionComparisonBaselineSnapshotId: "ID des Ausgangssnapshots",
    sdsRevisionComparisonCandidateSnapshotId: "ID des Kandidatensnapshots",
    sdsRevisionComparisonBaselineInputDigest: "Prüfsumme der Ausgangseingabe",
    sdsRevisionComparisonCandidateInputDigest:
      "Prüfsumme der Kandidateneingabe",
    sdsRevisionComparisonCategory: "Kategorie",
    sdsRevisionComparisonAllCategories: "Alle Kategorien",
    sdsRevisionComparisonFactPath: "Faktpfad",
    sdsRevisionComparisonSection: "Abschnitt",
    sdsRevisionComparisonApplyFilters: "Filter anwenden",
    sdsRevisionComparisonPosition: "Position",
    sdsRevisionComparisonFactAbsent: "Fakt nicht vorhanden",
    sdsRevisionComparisonNoDifferences:
      "Keine Fakten für diesen Filter gefunden.",
    sdsRevisionComparisonNoSection: "Ohne Abschnitt",
    sdsRevisionComparisonSectionNumber: "Abschnitt {section}",
    sdsRevisionComparisonCategoryadded: "Hinzugefügt",
    sdsRevisionComparisonCategoryremoved: "Entfernt",
    sdsRevisionComparisonCategorychanged: "Geändert",
    sdsRevisionComparisonCategoryunchanged: "Unverändert",
    sdsRevisionComparisonCategoryunknown: "Unklar",
    sdsRevisionComparisonCategorycontradictory: "Widersprüchlich",
    sdsRevisionComparisonEvidenceTitle: "Verknüpfter Quellnachweis",
    sdsRevisionComparisonEvidenceRelation: "Nachweisbeziehung",
    sdsRevisionComparisonEvidenceUnavailable:
      "Der eingefrorene Quellnachweis ist nicht verfügbar.",
    sdsAssessmentBlockingOutcome: "Sperrergebnis",
    sdsComplianceActionsTitle: "Compliance-Aktionen",
    sdsComplianceActionsDescription:
      "Zugeordnete Arbeit für unveränderliche Bewertungsfeststellungen.",
    sdsComplianceActionsRefresh: "Aktionen aktualisieren",
    sdsComplianceActionsEmpty: "Keine Compliance-Aktionen vorhanden.",
    sdsComplianceActionCreate: "Compliance-Aktion erstellen",
    sdsComplianceActionFindings: "Feststellungen",
    sdsComplianceActionOwner: "Verantwortliche Person",
    sdsComplianceActionNewOwner: "Neue verantwortliche Person",
    sdsComplianceActionContext: "Erforderlicher Arbeitskontext",
    sdsComplianceActionDueAt: "Fällig am",
    sdsComplianceActionRequired: "Erforderlich",
    sdsComplianceActionBlocking: "Blockierend",
    sdsComplianceActionRationale: "Begründung",
    sdsComplianceActionStart: "Bearbeitung beginnen",
    sdsComplianceActionComplete: "Abschließen",
    sdsComplianceActionReassign: "Neu zuweisen",
    sdsComplianceActionWaive: "Ausnahme genehmigen",
    sdsComplianceActionCancel: "Stornieren",
    sdsComplianceActionDisposition: "Feststellung disponieren",
    sdsComplianceActionDispositionFinding: "Zu disponierende Feststellung",
    sdsComplianceActionOverdue: "Überfällig",
    sdsComplianceActionSaved: "Compliance-Aktion wurde gespeichert.",
    sdsComplianceActionStatusopen: "Offen",
    sdsComplianceActionStatusin_progress: "In Bearbeitung",
    sdsComplianceActionStatuscompleted: "Abgeschlossen",
    sdsComplianceActionStatuswaived: "Ausnahme genehmigt",
    sdsComplianceActionStatuscancelled: "Storniert",
    sdsAssessmentStatus: "Bewertungsstatus",
    sdsAssessmentCreatedAt: "Erstellt am",
    sdsAssessmentEffectiveFrom: "Wirksam ab",
    sdsAssessmentEffectiveTimeZone: "Zeitzone der Wirksamkeit",
    sdsAssessmentEffectiveStatus: "Status der Wirksamkeit",
    sdsAssessmentSupersededAt: "Abgelöst am",
    sdsAssessmentBaselineAssessment: "Ausgangsbewertung",
    sdsAssessmentBaselineRevision: "Wirksame Ausgangsrevision",
    sdsAssessmentTerminalRationale: "Abschlussbegründung",
    sdsAssessmentRegulatoryFindings: "Regulatorische Feststellungen",
    sdsAssessmentOrganizationFindings: "Organisatorische Feststellungen",
    sdsAssessmentRequirement: "Anforderung",
    sdsAssessmentRequirementId: "Anforderungs-ID: {requirementId}",
    sdsAssessmentRequirementVersionId:
      "Anforderungsversion-ID: {requirementVersionId}",
    sdsAssessmentOutcome: "Ergebnis",
    sdsAssessmentRationale: "Begründung",
    sdsAssessmentComment: "Kommentar",
    sdsAssessmentEvidence: "Quellnachweise",
    sdsAssessmentEvidenceReference: "Seite {page}, Absatz {paragraph}",
    sdsAssessmentEvidenceReferenceId: "Nachweis {evidenceId} ({relation})",
    sdsAssessmentEvaluation: "Bewertung",
    sdsAssessmentReviewedBy: "Geprüft von",
    sdsAssessmentCreateDescription:
      "Dokumentieren Sie für jede regulatorische und organisatorische Anforderung Ergebnis, Begründung und Quellnachweis.",
    sdsAssessmentCreate: "Bewertung erstellen",
    sdsAssessmentCreated: "Bewertung wurde erstellt.",
    sdsAssessmentDraftDescription:
      "Entwürfe können bis zur Einreichung bearbeitet werden.",
    sdsAssessmentSaveFindingDrafts: "Feststellungsentwürfe speichern",
    sdsAssessmentDraftSaved: "Feststellungsentwürfe wurden gespeichert.",
    sdsAssessmentSubmissionRationale: "Einreichungsbegründung",
    sdsAssessmentSubmit: "Bewertung einreichen",
    sdsAssessmentSubmitted: "Bewertung wurde zur Prüfung eingereicht.",
    sdsAssessmentCancellationRationale: "Begründung der Stornierung",
    sdsAssessmentCancel: "Bewertung stornieren",
    sdsAssessmentCancelled: "Bewertung wurde storniert.",
    sdsAssessmentRejectionRationale: "Ablehnungsbegründung",
    sdsAssessmentReject: "Bewertung ablehnen",
    sdsAssessmentRejected: "Bewertung wurde abgelehnt.",
    sdsAssessmentHistory: "Bewertungsverlauf",
    sdsAssessmentKind: "Bewertungsart",
    sdsAssessmentKindinitial_baseline: "Erste Ausgangsbewertung",
    sdsAssessmentKindcandidate_revision: "Kandidatenrevision",
    sdsAssessmentPolicyRequired:
      "Eine aufgelöste oder bestätigte Richtlinienanwendbarkeit ist erforderlich.",
    sdsAssessmentReviewerRequired:
      "Eine Prüferrolle ist erforderlich, um die Bewertung zu erstellen.",
    sdsAssessmentReadyForApproval:
      "Alle sperrenden Feststellungen sind erfüllt und können freigegeben werden.",
    sdsAssessmentBlocked:
      "Nicht erfüllte oder unbekannte sperrende Feststellungen verhindern die Freigabe.",
    sdsAssessmentApprovalRationale: "Freigabebegründung",
    sdsAssessmentInvalidEffectiveDateTime:
      "Datum, Uhrzeit und IANA-Zeitzone müssen einen eindeutigen Zeitpunkt ergeben.",
    sdsAssessmentAcceptedExceptions: "Akzeptierte Ausnahmen",
    sdsAssessmentAcceptedExceptionFinding: "Feststellung der Ausnahme",
    sdsAssessmentAcceptedExceptionRationale: "Begründung der Ausnahme",
    sdsAssessmentAcceptedAt: "Akzeptiert am",
    sdsAssessmentAddAcceptedException: "Ausnahme hinzufügen",
    sdsAssessmentRemoveAcceptedException: "Ausnahme entfernen",
    sdsAssessmentApprove: "Wirksamkeit freigeben",
    sdsAssessmentApproved: "Wirksame Revision wurde freigegeben.",
    sdsAssessmentOutcomesatisfied: "Erfüllt",
    sdsAssessmentOutcomeunsatisfied: "Nicht erfüllt",
    sdsAssessmentOutcomeunknown: "Unbekannt",
    sdsAssessmentOutcomenot_applicable: "Nicht anwendbar",
    sdsAssessmentStatuspending_approval: "Freigabe ausstehend",
    sdsAssessmentStatusscheduled: "Geplant",
    sdsAssessmentStatuseffective: "Wirksam",
    sdsAssessmentStatusdraft: "Entwurf",
    sdsAssessmentStatusin_review: "In Prüfung",
    sdsAssessmentStatusawaiting_actions: "Aktionen ausstehend",
    sdsAssessmentStatusapproved: "Freigegeben",
    sdsAssessmentStatuscancelled: "Storniert",
    sdsAssessmentStatusrejected: "Abgelehnt",
    sdsAssessmentStatussuperseded: "Überholt",
    sdsDocumentResolution: "Auflösungsstatus",
    sdsDocumentIssuer: "Aussteller",
    sdsDocumentExtraction: "Extraktionsstatus",
    sdsDocumentReview: "Prüfstatus",
    sdsDocumentSections: "Erkannte Abschnitte",
    sdsDocumentLastActivity: "Letzte Aktivität",
    sdsDocumentReceipts: "Empfangsereignisse",
    sdsDocumentReceiptFile: "Datei",
    sdsDocumentReceiptSize: "{size} Bytes",
    sdsDocumentReceiptReceivedAt: "Empfangen am",
    sdsDocumentReceiptChecksum: "SHA-256-Prüfsumme",
    sdsDocumentAttempts: "Extraktionsversuche",
    sdsDocumentAttemptNumber: "Versuch",
    sdsDocumentAttemptCreated: "Angelegt am",
    sdsDocumentVersions: "Versionen",
    sdsDocumentVersion: "Version {version}",
    sdsDocumentPrintDate: "Druckdatum",
    sdsDocumentFactsAwaitingExtraction:
      "Extrahierte Daten stehen nach Abschluss der Extraktion zur Verfügung.",
    sdsDocumentProvenance: "Datenherkunft",
    sdsDocumentProvenanceDescription:
      "Die Konfidenz bewertet nur die Qualität der automatischen Extraktion. Sie ist optional und beeinflusst nicht, ob Daten extrahiert wurden.",
    sdsDocumentProvenanceField: "Feld",
    sdsDocumentProvenanceSource: "Herkunft",
    sdsDocumentProvenanceConfidence: "Extraktionskonfidenz",
    sdsDocumentProvenanceExtractedAt: "Extrahiert am",
    sdsDocumentProvenanceUpdatedAt: "Manuell aktualisiert am",
    sdsDocumentProvenanceConfidenceNotAssessed:
      "Keine Konfidenzbewertung verfügbar",
    sdsDocumentProvenanceNotManuallyUpdated: "Noch nicht manuell aktualisiert",
    sdsDocumentProvenanceUnavailable: "Keine Herkunftsdaten verfügbar.",
    sdsDocumentProvenanceSourceextracted: "Extrahiert",
    sdsDocumentProvenanceSourcemanual: "Manuell geprüft",
    sdsFactReviewTitle: "Extrahierte Daten prüfen",
    sdsFactReviewSection: "SDS-Abschnitt",
    sdsFactReviewDescription:
      "Prüfen Sie die automatisch extrahierten Daten nach SDS-Abschnitt. Korrigieren Sie Werte bei Bedarf im nachfolgenden Bereich.",
    sdsFactMaintenanceDescription:
      "Die Daten wurden aus der Extraktion übernommen. Passen Sie Angaben an und speichern Sie Ihre Änderungen.",
    sdsFactCarryForwardTitle: "Korrektur aus vorheriger Revision",
    sdsFactCarryForwardDescription:
      "Zuvor ausgewählte Werte werden vorgeschlagen. Prüfen Sie die aktuelle Extraktion und übernehmen Sie passende Korrekturen.",
    sdsFactCarryForwardPreviousExtracted: "Vorherige Extraktion",
    sdsFactCarryForwardPreviousSelected: "Vorherige Korrektur",
    sdsFactCarryForwardCurrentExtracted: "Aktuelle Extraktion",
    sdsFactCarryForwardExtractionComparison: "Extraktionsvergleich",
    sdsFactCarryForwardExtractionChanged:
      "Extraktion gegenüber Vorgänger geändert",
    sdsFactCarryForwardExtractionUnchanged: "Extraktion unverändert",
    sdsFactCarryForwardAdopt: "Vorherige Korrektur übernehmen",
    sdsFactCarryForwardAdopted: "Vorherige Korrektur wurde übernommen.",
    sdsFactCarryForwardConfirmTitle: "Vorherige Korrektur übernehmen?",
    sdsFactCarryForwardDiscardChanges:
      "Nicht gespeicherte Änderungen werden verworfen. Speichern Sie diese zuerst, wenn Sie sie behalten möchten.",
    sdsFactCarryForwardConfirm: "Übernehmen und Änderungen verwerfen",
    sdsFactAuditChangedAt: "Geändert am",
    sdsFactAuditChangedBy: "Geändert von",
    sdsFactAuditSource: "Änderungsart",
    sdsFactAuditSourceRevision: "Quellrevision",
    sdsFactAuditSourcemanual: "Manuelle Änderung",
    sdsFactAuditSourcecarry_forward: "Vorherige Korrektur",
    sdsFactAuditSourcecorrection: "Faktkorrektur",
    sdsFactAuditSourceacknowledgement: "Bestätigung",
    sdsFactReviewProgress: "{reviewed} von {total} Fakten geprüft",
    sdsFactReviewField: "Feld",
    sdsFactReviewValue: "Wert",
    sdsFactReviewCurrentValue: "Aktuelle Interpretation",
    sdsFactReviewCertainty: "Vollständigkeit",
    sdsFactReviewDecision: "Entscheidung",
    sdsFactReviewConclusion: "Schlussfolgerung",
    sdsFactReviewNoConclusion: "Keine kanonische Schlussfolgerung",
    sdsFactReviewAccept: "Annehmen",
    sdsFactReviewReject: "Ablehnen",
    sdsFactReviewCorrect: "Korrigieren",
    sdsFactReviewAcknowledgeUnknown: "Unklar bestätigen",
    sdsFactReviewAcknowledgeContradictory: "Widerspruch bestätigen",
    sdsFactReviewSubmit: "Entscheidung speichern",
    sdsFactReviewDialogaccepted: "Interpretation annehmen",
    sdsFactReviewDialogrejected: "Interpretation ablehnen",
    sdsFactReviewDialogcorrected: "Interpretation korrigieren",
    sdsFactReviewDialogacknowledged_unknown:
      "Unklare Schlussfolgerung bestätigen",
    sdsFactReviewDialogacknowledged_contradictory:
      "Widersprüchliche Schlussfolgerung bestätigen",
    sdsFactReviewDecisionpending: "Ausstehend",
    sdsFactReviewDecisionaccepted: "Angenommen",
    sdsFactReviewDecisionrejected: "Abgelehnt",
    sdsFactReviewDecisioncorrected: "Korrigiert",
    sdsFactReviewDecisionacknowledged_unknown: "Unklar bestätigt",
    sdsFactReviewDecisionacknowledged_contradictory: "Widerspruch bestätigt",
    sdsFactReviewConclusionknown: "Bekannt",
    sdsFactReviewConclusionunknown: "Unklar",
    sdsFactReviewConclusioncontradictory: "Widersprüchlich",
    sdsFactReviewCertaintycomplete: "Vollständig",
    sdsFactReviewCertaintymissing: "Fehlend",
    sdsFactReviewCertaintymalformed: "Fehlerhaft",
    sdsFactReviewCertaintypartial: "Teilweise",
    sdsFactReviewCertaintycontradictory: "Widersprüchlich",
    sdsFactReviewCertaintyunknown_confidence: "Unbekannte Konfidenz",
    sdsFactReviewEvidenceTitle: "Verknüpfte Quellnachweise",
    sdsFactReviewEvidenceDescription:
      "Mindestens einen versuchsbezogenen Absatz auswählen und Beziehung festlegen.",
    sdsFactReviewEvidenceMissing: "Verknüpfter Quellnachweis nicht verfügbar",
    sdsFactReviewOpenEvidence: "Quellnachweis öffnen",
    sdsFactReviewNoEvidence: "Keine Quellnachweise mit diesem Fakt verknüpft.",
    sdsFactReviewNoEvidenceAvailable:
      "Keine Quellnachweise für diese Revision verfügbar.",
    sdsFactReviewSupporting: "Unterstützend",
    sdsFactReviewContradicting: "Widersprechend",
    sdsFactReviewHistoryTitle: "Entscheidungsverlauf",
    sdsFactReviewNoHistory: "Noch keine Prüfentscheidung gespeichert.",
    sdsFactReviewPending: "Ausstehend",
    sdsFactReviewReviewedBy: "Geprüft von {reviewer}",
    sdsFactReviewCorrectionsTitle: "Korrekturaudit",
    sdsFactReviewAcknowledgementsTitle: "Bestätigte Schlussfolgerungen",
    sdsFactReviewPreviousValue: "Vorheriger Wert",
    sdsFactReviewCorrectedValue: "Korrigierter Wert",
    sdsFactReviewReason: "Korrekturgrund",
    sdsFactReviewConclusionReason: "Begründung der Schlussfolgerung",
    sdsFactReviewComment: "Kommentar",
    sdsFactReviewSaved: "Prüfentscheidung wurde gespeichert.",
    sdsFactReviewConflictTitle: "Fakt wurde zwischenzeitlich geprüft",
    sdsFactReviewConflictMessage:
      "Aktueller Stand wurde neu geladen. Prüfen Sie die Änderungen vor einer erneuten Entscheidung.",
    sdsFactReviewUfiValue: "UFI",
    sdsFactReviewUfiScope: "Geltungsbereich",
    sdsFactReviewUfiScopeValue: "Wert des Geltungsbereichs",
    sdsFactReviewAddUfi: "UFI hinzufügen",
    sdsFactReviewUfiScopeproductUuid: "Produkt",
    sdsFactReviewUfiScopemixtureUuid: "Gemisch",
    sdsFactReviewUfiScopemarket: "Markt",
    sdsFactReviewUfiScopelanguage: "Sprache",
    sdsDocumentEvidenceUnavailable:
      "Quellnachweise stehen nach der dauerhaft gespeicherten Extraktion zur Verfügung.",
    sdsDocumentEvidenceSource: "Quelle",
    sdsDocumentEvidencePage: "Seite {page}",
    sdsDocumentEvidenceLocation: "SDS-Abschnitt {section} · Seite {page}",
    sdsDocumentEvidenceSectionUnknown: "unbekannt",
    sdsDocumentEvidenceHeadingUnknown: "Überschrift nicht erkannt",
    sdsDocumentFocusedEvidence: "Ausgewählter Quellnachweis",
    sdsPdfReviewDownload: "PDF herunterladen",
    sdsPdfReviewPreviousPage: "Vorherige Seite",
    sdsPdfReviewNextPage: "Nächste Seite",
    sdsPdfReviewPage: "Seite",
    sdsPdfReviewPageOf: "von {count}",
    sdsPdfReviewLoadFailed: "Original-PDF konnte nicht geladen werden.",
    sdsPdfReviewUnavailable:
      "Original-Sicherheitsdatenblatt für diese Version ist nicht verfügbar.",
    sdsDocumentEvidenceProvenance: "Extraktionsherkunft",
    sdsDocumentEvidenceCreated: "Gespeichert am",
    sdsDocumentEvidenceContent: "Absatz",
    sdsDocumentEvidenceSection: "Verknüpfter Abschnitt/Fakt",
    sdsDocumentEvidenceUnlinked: "Keinem Fakt zugeordnet",
    sdsDocumentExtractedIdentity: "Extrahierte Produktidentität",
    sdsDocumentProductName: "Produktname",
    sdsDocumentMaterialNumber: "Materialnummer",
    sdsDocumentUfi: "UFI",
    sdsFactsIssuerName: "Ausstellername",
    sdsDocumentExtractedSupplier: "Extrahierter Lieferant",
    sdsFactsSelectIssuer: "Aussteller auswählen",
    sdsFactsSelectSupplier: "Lieferanten auswählen",
    sdsFactsSection1Title: "Abschnitt 1 · Bezeichnung",
    sdsFactsSection1Description:
      "Produktidentität, Verwendungen und Ausstellerdaten aus dem Sicherheitsdatenblatt.",
    sdsFactsRecommendedUses: "Empfohlene Verwendungen",
    sdsFactsUsesAdvisedAgainst: "Verwendungen, von denen abgeraten wird",
    sdsFactsMultilineListHint: "Jeden Eintrag in einer eigenen Zeile erfassen.",
    sdsFactsSupplierAddress: "Ausstelleradresse",
    sdsFactsSupplierEmail: "Aussteller-E-Mail",
    sdsFactsSupplierPhone: "Ausstellertelefon",
    sdsFactsEmergencyPhone: "Notrufnummer",
    sdsFactsSection2Title: "Abschnitt 2 · Mögliche Gefahren",
    sdsFactsSection2Description:
      "Einstufung, Kennzeichnungselemente sowie sonstige Gefahren.",
    sdsFactsPictograms: "Gefahrenpiktogramme",
    sdsFactsPStatements: "P-Sätze",
    sdsFactsOtherHazards: "Sonstige Gefahren",
    sdsFactsSection3Title: "Abschnitt 3 · Zusammensetzung",
    sdsFactsSection3Description:
      "Stoff- oder Gemischart und einstufungsrelevante Bestandteile.",
    sdsFactsSubstanceOrMixture: "Stoff oder Gemisch",
    sdsFactsAddIngredient: "Bestandteil hinzufügen",
    sdsFactsIngredient: "Bestandteil {number}",
    sdsFactsCasNumber: "CAS-Nr.",
    sdsFactsEcNumber: "EG-Nr.",
    sdsFactsClassification: "Einstufung",
    sdsFactsNoIngredients: "Keine Bestandteile erfasst.",
    sdsFactsSection15Title: "Abschnitt 15 · Rechtsvorschriften",
    sdsFactsSection15Description:
      "Produktspezifische Vorschriften, Beschränkungen und Bewertungen.",
    sdsFactsRegulatoryReferences: "Rechtsvorschriften",
    sdsFactsSevesoCategory: "SEVESO-Kategorie",
    sdsFactsWaterHazardClass: "Wassergefährdungsklasse (WGK)",
    sdsFactsVocValue: "VOC-Wert",
    sdsFactsChemicalSafetyAssessment: "Stoffsicherheitsbeurteilung",
    sdsFactsRestrictions: "Beschränkungsbedingungen",
    sdsFactsSvhc: "SVHC",
    sdsFactsMicroplastics: "Mikroplastik / SPM",
    sdsDocumentFactsUnavailable: "Keine extrahierten Daten verfügbar.",
    sdsDocumentFactsSaved: "Extrahierte Daten wurden gespeichert.",
    sdsDocumentSupplierDecision: "Ausstellerzuordnung",
    sdsDocumentSupplierComment: "Begründung der Zuordnung",
    sdsDocumentSupplierCommentPlaceholder:
      "Begründung für die Korrektur dokumentieren",
    sdsDocumentIssuerResolutionDescription:
      "Bestätigen Sie den Aussteller nur nach Prüfung. Korrigieren Sie die Zuordnung oder legen Sie einen fehlenden Lieferanten an.",
    sdsIssuerEvidenceTitle: "Extrahierter Aussteller und Kontakt",
    sdsCanonicalIssuerTitle: "Aussteller",
    sdsCanonicalIssuerDescription:
      "Wählen oder pflegen Sie den Geschäftspartner, der das Sicherheitsdatenblatt ausgestellt hat.",
    sdsCanonicalSupplierTitle: "Lieferant",
    sdsCanonicalSupplierDescription:
      "Der Lieferant entspricht zunächst dem Aussteller. Aktivieren Sie die Abweichung nur bei einem anderen liefernden Geschäftspartner.",
    sdsSelectBusinessPartner: "Geschäftspartner auswählen",
    sdsSupplierDiffersFromIssuer: "Lieferant weicht vom Aussteller ab",
    sdsDocumentCreateSupplier: "Lieferant anlegen",
    sdsBusinessPartnerEdit: "Geschäftspartner bearbeiten",
    sdsBusinessPartnerSaved: "Geschäftspartner wurde gespeichert.",
    sdsIdentityResolutionTitle: "SDS-Zuordnung",
    sdsIdentitySearch: "Bestehendes Sicherheitsdatenblatt suchen",
    sdsIdentityAddRevision: "Als neue Revision hinzufügen",
    sdsIdentityRevisionIdentifier: "Revisionskennung",
    sdsIdentityReasonIssuerProduct: "Aussteller und Produkt stimmen überein",
    sdsIdentityReasonReviewerSearch: "Vom Prüfer gesucht",
    sdsIdentityNewRevisionExplanation:
      "Bestätigen Sie Aussteller, Sicherheitsdatenblatt und Produkt sowie die verfügbaren Revisionsangaben. Fehlende Angaben sind erlaubt. Die Datei wird als neue Revision angehängt; die wirksame Revision bleibt unverändert. Nicht gespeicherte Formularänderungen werden nicht übernommen.",
    sdsIdentityNewRevisionAdded: "Neue Revision wurde hinzugefügt.",
    sdsIdentityNewRevisionUnresolved:
      "Die neue Revision wurde nicht bestätigt.",
    sdsIdentityResolutionDescription:
      "Prüfen Sie die vorgeschlagenen Sicherheitsdatenblätter und ordnen Sie dieses Dokument zu. Jede Zuordnung wird bestätigt und kann von berechtigten Prüfern korrigiert werden.",
    sdsIdentityResolutionAmbiguous:
      "Mehrdeutige Chronologie oder Dateigleichheit blockiert automatische Zuordnung.",
    sdsIdentityResolutionCandidate: "Kandidat",
    sdsIdentityResolutionReasons: "Begründungen",
    sdsIdentityResolutionActions: "Aktionen",
    sdsIdentityResolutionIssuer: "Aussteller",
    sdsIdentityResolutionSupplier: "Lieferant",
    sdsIdentityResolutionAssociate: "Zuordnen",
    sdsIdentityResolutionEstablish: "Neue Identität bestätigen",
    sdsIdentityResolutionResolved: "SDS-Zuordnung gespeichert",
    sdsIdentityResolutionCanonicalDocument:
      "Zugeordnetes Sicherheitsdatenblatt",
    sdsIdentityResolutionCanonicalVersion: "Revision",
    sdsIdentityRevisionDate: "Revisionsdatum",
    sdsIdentityResolutionReasonIssuerAndRevisionIdentifier:
      "Aussteller- und Revisionskennung",
    sdsIdentityResolutionReasonIssuerRevisionDateAndProductName:
      "Aussteller, Revisionsdatum und Produktname",
    sdsIdentityResolutionReasonIdenticalFileChecksum:
      "Identische Dateiprüfsumme",
    sdsIdentityResolutionReasonConflictingChronology:
      "Widersprüchliche Chronologie",
    "sdsIdentityBlockingReasonreviewed-issuer-required":
      "Aussteller auswählen, um verfügbare Aktionen zu bestimmen.",
    "sdsIdentityBlockingReasonissuer-mismatch":
      "Der Kandidat gehört zu einem anderen Aussteller.",
    "sdsIdentityBlockingReasoninsufficient-same-revision-evidence":
      "Die Nachweise reichen nicht für dieselbe Revision aus.",
    "sdsIdentityBlockingReasonidentical-file":
      "Eine identische Datei kann nicht als neue Revision hinzugefügt werden.",
    "sdsIdentityBlockingReasonnot-latest-revision":
      "Neue Revisionen können nur an die letzte bekannte Revision angehängt werden.",
    "sdsIdentityBlockingReasonrevision-date-not-later":
      "Das Revisionsdatum ist nicht neuer als die letzte bekannte Revision.",
    "sdsIdentityBlockingReasonrevision-identifier-not-unique":
      "Die Revisionskennung wird bereits verwendet.",
    sdsDocumentCreateIssuer: "Aussteller anlegen",
    sdsDocumentConfirmSupplier: "Aussteller bestätigen",
    sdsDocumentCorrectSupplier: "Aussteller korrigieren",
    sdsSupplierDecisionunresolved: "Nicht aufgelöst",
    sdsSupplierDecisionconfirmed: "Bestätigt",
    sdsSupplierDecisioncorrected: "Korrigiert",
    sdsDocumentSupplierConfirmed: "Aussteller wurde bestätigt.",
    sdsDocumentSupplierCorrected: "Aussteller wurde korrigiert.",
    sdsIssuerCreated: "Aussteller wurde angelegt.",
    sdsSupplierCreated: "Lieferant wurde angelegt.",
    sdsSupplierEmergencyPhone: "Notfalltelefon",
    sdsDocumentCandidates: "Materialkandidaten",
    sdsDocumentCandidatesDescription:
      "Extraktionsergebnisse prüfen und bewusst entscheiden.",
    sdsDocumentRefreshCandidates: "Materialkandidaten aktualisieren",
    sdsDocumentMaterial: "Material",
    sdsDocumentMatchScore: "Übereinstimmung",
    sdsDocumentMatchReasons: "Gründe",
    sdsDocumentReviewedEvidence: "Geprüfte Nachweise",
    sdsDocumentDecision: "Entscheidung",
    sdsCandidateDecisionpending: "Ausstehend",
    sdsCandidateDecisionapproved: "Genehmigt",
    sdsCandidateDecisionrejected: "Abgelehnt",
    sdsDocumentAccept: "Akzeptieren",
    sdsDocumentDismiss: "Verwerfen",
    sdsDocumentCandidateAccepted: "Materialkandidat wurde akzeptiert.",
    sdsDocumentCandidateDismissed: "Materialkandidat wurde verworfen.",
    sdsDocumentLinkedMaterials: "Verknüpfte Materialien",
    sdsDocumentLinkedMaterialsDescription:
      "Aus geprüften Revisionsentscheidungen abgeleitete Zuordnungen. Sie können nicht unabhängig bearbeitet werden.",
    sdsDocumentLinkMaterial: "Material verknüpfen",
    sdsDocumentCreateAndLink: "Material anlegen und verknüpfen",
    sdsDocumentSearchMaterials: "Material suchen",
    sdsDocumentSearchByUfi: "UFI suchen",
    sdsDocumentUfiSearchPlaceholder: "UFI eingeben",
    sdsDocumentUfiSearchNoMatches:
      "Kein Material mit dieser UFI gefunden. Verknüpfen Sie ein Material manuell oder legen Sie ein neues an.",
    sdsDocumentUfiSearchOneMatch:
      "Ein Material gefunden. Wählen Sie die UUID-basierte Materialzuordnung ausdrücklich aus.",
    sdsDocumentUfiSearchAmbiguous:
      "{count} Materialien gefunden. Wählen Sie die UUID-basierte Materialzuordnung ausdrücklich aus.",
    sdsDocumentMaterialChoice:
      "{materialName} · {materialNumber} · UUID: {materialUuid}",
    sdsDocumentApplicability: "Anwendbarkeit",
    sdsDocumentApplicable: "Anwendbar",
    sdsDocumentNotApplicable: "Nicht anwendbar",
    sdsDocumentPreferred: "Bevorzugt",
    sdsDocumentPreferredSelected: "Bevorzugt",
    sdsDocumentSelectPreferred: "Bevorzugen",
    sdsDocumentPreferredSaved: "Bevorzugte SDB-Version wurde gespeichert.",
    sdsDocumentMaterialLinked: "Material wurde verknüpft.",
    sdsDocumentMaterialCreated: "Material wurde angelegt und verknüpft.",
    sdsDocumentRetryAccepted: "Extraktion wurde erneut gestartet.",
    sdsDocumentActivityReceived: "SDB-Dokument wurde empfangen.",
    sdsMaterialSearchPlaceholder: "Material suchen",
    sdsMaterialPrimarySupplier: "Primärer Lieferant",
    sdsMaterialOpenWorkspace: "SDB anzeigen",
    sdsMaterialWorkspace: "Material-SDB",
    sdsMaterialMasterData: "Materialstammdaten",
    sdsMaterialSaved: "Materialstammdaten wurden gespeichert.",
    sdsMaterialBackToCatalog: "Zur Materialliste",
    sdsMaterialLinkedDocuments: "Zugeordnete SDB-Dokumente",
    sdsMaterialLinkedDocumentsDescription:
      "Alle SDB-Versionen, Aussteller und Anwendbarkeitsentscheidungen für dieses Material.",
    sdsMaterialNoLinkedDocuments:
      "Diesem Material ist noch kein SDB zugeordnet.",
    sdsSupplierSearchPlaceholder: "Lieferanten suchen",

    sdsIdentitySourceDocument: "Quelldokument",
    sdsIdentitySourceProduct: "Extrahiertes Produkt",
    sdsIdentitySourceRevision: "Revision",
    sdsIdentityLatestRevision: "Letzte Revision",
    sdsIdentityCandidateDataUnavailable:
      "Interne Kandidatendaten sind nicht verfügbar. Aktionen sind deaktiviert.",
    sdsIdentitySearchFailed: "Kandidatensuche fehlgeschlagen",
    sdsIdentityNoCandidates:
      "Keine passenden Sicherheitsdatenblätter gefunden.",
    sdsIdentityAutomaticSearchScope:
      "Die automatische Prüfung berücksichtigt Prüfsumme, Aussteller, Produkt und verfügbare Revisionsangaben. Der ausgewählte Aussteller begrenzt die Kandidaten.",
    sdsIdentityManualSearchScope:
      "Die manuelle Suche durchsucht Dokumentname, extrahierten Aussteller und Produkt. Der ausgewählte Aussteller begrenzt die Kandidaten.",
    sdsIdentityDecision: "Art der Zuordnung",
    sdsIdentityDecisionReviewer: "Prüfer",
    sdsIdentityDecisionTimestamp: "Entschieden am",
    sdsIdentityDecisionRationale: "Begründung",
    sdsIdentityOptionalComment: "Zusätzliche Bemerkung (optional)",
    sdsIdentityOptionalCommentHelp:
      "Die angezeigten Nachweise dokumentieren diese Entscheidung. Eine zusätzliche Bemerkung ist nicht erforderlich.",
    sdsIdentityOptionalCommentPlaceholder: "Optionale Bemerkung zur Zuordnung",
    sdsIdentityManualDecisionRationale: "Grund für manuelle Zuordnung",
    sdsIdentityManualDecisionRationaleHelp:
      "Beschreiben Sie kurz, warum dieses Sicherheitsdatenblatt trotz manueller Suche zu diesem Ziel gehört.",
    sdsIdentityManualDecisionRationalePlaceholder:
      "Zum Beispiel: Revisionskennung im Dokument bestätigt die Zuordnung.",
    sdsIdentityDecisionHistory: "Entscheidungshistorie",
    sdsIdentityDecisionTarget: "Ziel",
    sdsIdentityNewIdentityTarget: "Neue eigenständige SDS-Identität",
    sdsIdentityCorrectDecision: "Zuordnung korrigieren",
    sdsIdentityCorrectionHint:
      "Falls die Zuordnung nicht stimmt, können Sie sie korrigieren. Die bisherige Zuordnung bleibt nachvollziehbar.",
    sdsIdentityReplacementDecision: "Ersatzentscheidung",
    sdsIdentityCorrectionRationale: "Begründung der Korrektur",
    sdsIdentityCorrectionRationaleHelp:
      "Beschreiben Sie kurz, warum die bisherige Entscheidung ersetzt werden muss. Die bisherige Entscheidung bleibt nachvollziehbar.",
    sdsIdentityCorrectionRationalePlaceholder:
      "Zum Beispiel: Zielrevision wurde zuvor falsch zugeordnet.",
    sdsIdentityCorrectionUnavailable:
      "Die aktuelle Entscheidung kann nicht korrigiert werden.",
    sdsIdentityContinue: "Weiter",
    sdsIdentityConfirmDecision: "Entscheidung bestätigen",
    sdsIdentityDecisionassociate: "Mit bestehender Revision verknüpfen",
    sdsIdentityDecisionadd_revision: "Als neue Revision hinzufügen",
    sdsIdentityDecisionestablish: "Neue Identität etablieren",
    sdsIdentityDecisionSummaryassociate: "Dieselbe SDS-Revision",
    sdsIdentityDecisionSummaryadd_revision:
      "Neue Revision eines bestehenden Sicherheitsdatenblatts",
    sdsIdentityDecisionSummaryestablish: "Eigenständiges Sicherheitsdatenblatt",
    sdsIdentityConsequenceassociate:
      "Diese Datei wird derselben bestätigten SDS-Revision zugeordnet.",
    sdsIdentityConsequenceadd_revision:
      "Diese Datei wird als neue Revision an das ausgewählte Sicherheitsdatenblatt angehängt.",
    sdsIdentityConsequenceestablish:
      "Für diese Datei wird eine neue eigenständige SDS-Identität erstellt.",
  },
  en: {
    productComplianceLogo: "AI",
    productComplianceMaterialTimeline: "Timeline",
    productComplianceSdsHubTitle: "SDS Compliance Hub",
    productComplianceSdsHubSubtitle:
      "AI-native decisions, traceable and exportable",
    sdsNavOverview: "Overview",
    sdsNavSuppliers: "Suppliers",
    sdsNavMaterials: "Materials",
    sdsNavPolicies: "Policies",
    sdsNavReassessments: "Reassessments",
    sdsReassessmentDocument: "SDS document",
    sdsReassessmentPriority: "Priority",
    sdsReassessmentStatus: "Status",
    sdsReassessmentPolicyVersion: "Policy version",
    sdsReassessmentControlVersion: "Control profile version",
    sdsReassessmentCreated: "Created",
    sdsReassessmentEmpty: "No reassessments available.",
    sdsReassessmentPrioritycritical: "Critical",
    sdsReassessmentPriorityhigh: "High",
    sdsReassessmentPrioritynormal: "Normal",
    sdsReassessmentStatusqueued: "Queued",
    sdsReassessmentStatusin_progress: "In progress",
    sdsReassessmentStatuscompleted: "Completed",
    sdsReassessmentStatussuperseded: "Superseded",
    sdsReassessmentStatusfailed: "Failed",
    sdsReassessmentGovernedState: "Governance state",
    sdsReassessmentGovernedStatePending: "Reassessment pending",
    sdsReassessmentGovernedStatePendingDescription:
      "A reassessment with {priority} priority is open. This Revision is not shown as currently governed.",
    sdsReassessmentGovernedStateStale: "Governance is not current",
    sdsReassessmentGovernedStateStaleDescription:
      "This Revision has no current effective governance.",
    sdsReassessmentGovernedStateUnknown: "Governance is unknown",
    sdsReassessmentGovernedStateUnknownDescription:
      "Policy applicability is ambiguous or unconfigured.",
    sdsReassessmentGovernedStateCurrent: "Currently governed",
    sdsReassessmentGovernedStateCurrentDescription:
      "This Revision has effective governance and no open reassessment.",
    sdsNavActions: "Actions",
    sdsNavComparison: "Comparison",
    sdsNavNewComparison: "New Comparison",
    productComplianceLatency: "Latency 230ms",
    productComplianceAuditStreamingOn: "Audit streaming ON",
    productComplianceTabDashboard: "Role-based dashboard",
    productComplianceTabWorkspaceDiff: "Workspace Smart Diff",
    productComplianceTabTimelineEvidence: "Timeline + Evidence Pack",
    productComplianceTabSitesVariables: "Sites & Variables",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Admin",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "Pending review",
    productComplianceDashboardSummaryPendingDescription:
      "Documents waiting for validation",
    productComplianceDashboardSummaryOverdue: "Overdue tasks",
    productComplianceDashboardSummaryOverdueDescription:
      "Assigned actions outside SLA",
    productComplianceDashboardSummaryReviewTime: "Avg review time",
    productComplianceDashboardSummaryReviewTimeDescription: "Over last 30 days",
    productComplianceDashboardSummaryPrioritization: "Prioritization",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Sections pre-analyzed automatically",
    productComplianceDashboardLibraryTitle: "Materials Library",
    productComplianceDashboardLibrarySubtitle:
      "Search, risk and direct access to AI workspace",
    productComplianceDashboardUploadDrop: "Drop an SDS file here or",
    productComplianceDashboardUploadBrowse: "click to browse",
    productComplianceDashboardSearchPlaceholder: "Search by material or CAS...",
    productComplianceDashboardColumnMaterial: "Material",
    productComplianceDashboardColumnWorkflow: "Workflow",
    productComplianceDashboardColumnRiskScore: "Risk score",
    productComplianceDashboardOpenWorkspace: "Open AI Workspace",
    productComplianceDashboardWorkspaceNotificationTitle: "Workspace",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Open AI Workspace: {name}",
    productComplianceDashboardUploadComment:
      "SDS upload from Product Compliance dashboard",
    productComplianceDashboardUploadSingleFileWarning:
      "Only one file allowed at a time ({fileName}).",
    sdsMaterialListKpiAwaitingReview: "Awaiting review",
    sdsMaterialListKpiInProgress: "In progress",
    sdsMaterialListKpiParsingIncomplete: "Parsing incomplete",
    sdsMaterialListFilterAll: "All",
    sdsMaterialListFilterPendingReview: "Pending review",
    sdsMaterialListFilterInProgress: "In progress",
    sdsMaterialListFilterApproved: "Approved",
    sdsMaterialListFilterObsolete: "Obsolete",
    sdsMaterialListImportSds: "Import SDS",
    sdsMaterialListReviewSds: "Review SDS",
    sdsMaterialListOpenMaterial: "Open material",
    sdsMaterialAddButton: "Add material",
    sdsMaterialFieldName: "Trade name",
    sdsMaterialFieldNumber: "Internal code",
    sdsMaterialFieldCas: "CAS number",
    sdsMaterialFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsMaterialFieldUfi: "UFI",
    sdsMaterialFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsMaterialFieldDescription: "Description",
    sdsMaterialFieldPrimarySupplier: "Primary supplier",
    sdsFeatureRequiresBackend:
      "This feature requires a backend update and is currently disabled.",
    sdsValidationRequired: "Required",
    sdsMaterialValidationRequired: "Enter trade name and internal code.",
    sdsMaterialListColumnMaterial: "Material",
    sdsMaterialListColumnSupplier: "Supplier",
    sdsMaterialListColumnSdsStatus: "SDS status",
    sdsMaterialListColumnWorkflowStatus: "Review status",
    sdsMaterialListColumnSections: "Sections",
    sdsMaterialListColumnLastUpdated: "Last updated",
    sdsOverviewTitle: "Compliance Overview",
    sdsOverviewAwaitingReview: "Awaiting review",
    sdsOverviewAwaitingReviewDesc: "Materials waiting for approval",
    sdsOverviewInProgress: "In progress",
    sdsOverviewInProgressDesc: "Active compliance reviews",
    sdsOverviewOverdue: "Overdue",
    sdsOverviewOverdueDesc: "Materials with overdue compliance actions",
    sdsOverviewApprovedThisMonth: "Approved this month",
    sdsOverviewApprovedThisMonthDesc: "Materials approved in current month",
    sdsOverviewPriorityQueue: "Materials Needing Attention",
    sdsOverviewNothingPending: "No pending materials.",
    sdsOverviewQuickActions: "Quick Actions",
    sdsOverviewExportActions: "Export actions report",
    sdsOverviewDaysPending: "Days pending",
    sdsOverviewComingSoon: "Coming soon",
    sdsWorkspaceImportNewVersion: "Import New Version",
    sdsWorkspaceViewHistory: "View History",
    sdsWorkspaceCurrentVersion: "Current version",
    sdsWorkspaceSectionsDetected: "Sections detected",
    sdsWorkspaceMissingSections: "Missing sections",
    sdsApprovedSourcesTitle: "Approved Sources",
    sdsApprovedSourcesEmpty: "No approved sources available.",
    sdsWorkspaceCompareTitle: "Compare versions",
    sdsWorkspaceSelectBaseline: "Select baseline",
    sdsWorkspaceSelectIncoming: "Select incoming",
    sdsWorkspaceSelectPlaceholder: "Select version",
    sdsWorkspaceComparingPreview: "Comparing: {baseline} vs. {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Only the most recent version is shown right now. Full version history will be available after a backend update.",
    sdsWorkspaceStartComparison: "Start Comparison",
    sdsFactsTitle: "Extracted SDS data",
    sdsFactsOpen: "Review data",
    sdsFactsBack: "Back to material",
    sdsFactsStatus: "Extraction status: {status}",
    sdsFactsMissingSections: "Missing sections: {sections}",
    sdsFactsDurableNotice:
      "Changes are saved for this version and recorded in its audit trail.",
    sdsFactsLoadFailed: "Extracted SDS data could not be loaded.",
    sdsFactsLoadFailedDescription:
      "Check the connection and load the data again.",
    sdsFactsSection1: "Section 1 - Identification",
    sdsFactsSection2: "Section 2 - Hazards identification",
    sdsFactsSection3: "Section 3 - Composition/information on ingredients",
    sdsFactsSection8: "Section 8 - Exposure controls/personal protection",
    sdsFactsSection14: "Section 14 - Transport information",
    sdsFactsSection15: "Section 15 - Regulatory information",
    sdsFactsMaterialName: "Product name",
    sdsFactsMaterialNumber: "Material number",
    sdsFactsSupplierName: "Supplier name",
    sdsFactsHazardClasses: "Hazard classes",
    sdsFactsHStatements: "H statements",
    sdsFactsSignalWord: "Signal word",
    sdsFactsSubstances: "Ingredients",
    sdsFactsAddSubstance: "Add ingredient",
    sdsFactsNoSubstances: "No ingredients recorded.",
    sdsFactsSubstanceName: "Substance name",
    sdsFactsSubstanceCas: "CAS number",
    sdsFactsConcentrationMin: "Concentration from",
    sdsFactsConcentrationMax: "Concentration to",
    sdsFactsConcentrationUnit: "Unit",
    sdsFactsSubstanceConfidence: "Confidence (0 to 1)",
    sdsFactsExposureControls: "Exposure controls",
    sdsFactsPersonalProtection: "Personal protection",
    sdsFactsExposureLimits: "Occupational exposure limits",
    sdsFactsUnNumber: "UN number",
    sdsFactsShippingName: "Proper shipping name",
    sdsFactsTransportClass: "Transport hazard class",
    sdsFactsPackingGroup: "Packing group",
    sdsFactsNumberInvalid: "{field} must be a number.",
    sdsFactsConfidenceInvalid: "Confidence must be between 0 and 1.",
    sdsFactsAuditCount: "{count} manual changes recorded",
    sdsFactsDiscard: "Discard changes",
    sdsFactsSaved: "SDS data has been saved.",
    sdsWizardBadge: "Wizard",
    sdsWizardStep1Title: "Select Material",
    sdsWizardStep2Title: "Select Versions",
    sdsWizardStep3Title: "Configure",
    sdsWizardSelectedMaterial: "Selected material",
    sdsWizardVersionsStubNotice:
      "Only one version is available for this material. Import more versions or wait for the version-history endpoint.",
    sdsWizardCrossSupplier: "Cross-supplier comparison",
    sdsWizardCrossSupplierDesc:
      "When enabled, baseline and incoming can come from different suppliers.",
    sdsWizardNoBaselineOptions: "No baseline versions available.",
    sdsWizardNoIncomingOptions: "No incoming versions available.",
    sdsWizardComparisonName: "Comparison name",
    sdsWizardComparisonNotes: "Comparison notes",
    sdsWizardBack: "Back",
    sdsWizardNext: "Next",
    sdsWizardStartComparison: "Start Comparison",
    sdsComparisonToolbarViewSplit: "Split",
    sdsComparisonToolbarViewUnified: "Unified",
    sdsComparisonToolbarShowChangesOnly: "Show changes only",
    sdsComparisonToolbarJumpSection: "Jump to section",
    sdsComparisonDevelopmentModeNotice:
      "Development mode: showing mock comparison data. Connect /api/product-compliance/comparisons/:id when available.",
    sdsReportExportComparison: "Export SDS comparison report",
    sdsReportBrand: "SMX Product Compliance",
    sdsReportTitle: "SDS comparison report",
    sdsReportGeneratedOn: "Generated on",
    sdsReportMaterial: "Material",
    sdsReportBaseline: "Baseline",
    sdsReportIncoming: "Incoming",
    sdsReportBy: "Created by",
    sdsReportDate: "Comparison date",
    sdsReportExecutiveSummary: "Executive summary",
    sdsReportCriticalChanges: "Critical changes",
    sdsReportHighChanges: "High changes",
    sdsReportActionsAssigned: "Assigned actions",
    sdsReportSections: "sections",
    sdsReportSectionAnalysis: "Section analysis",
    sdsReportNoNote: "No compliance note documented.",
    sdsReportUnchangedSections: "Unchanged sections",
    sdsReportReviewedBy: "Reviewed by",
    sdsReportApprovedBy: "Approved by",
    sdsReportSignature: "Signature",
    sdsReportEvidenceVersionsTitle: "All SDS versions",
    sdsReportEvidenceVersionLabel: "Version label",
    sdsReportEvidenceRevisionDate: "Revision date",
    sdsReportEvidenceImportDate: "Import date",
    sdsReportEvidenceWorkflowStatus: "Workflow status",
    sdsReportEvidenceSectionsDetected: "Sections detected",
    sdsReportEvidenceComparisonsTitle: "Comparison history",
    sdsReportEvidenceNoComparisons: "No completed comparisons recorded.",
    sdsReportEvidenceOpenActionsTitle: "Open actions summary",
    sdsReportEvidenceActionCount: "Count",
    sdsReportEvidenceNoOpenActions: "No open actions recorded.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "No content available",
    sdsComparisonUnchangedHidden: "unchanged sections hidden",
    sdsComparisonShowAllSections: "Show all",
    sdsComparisonSectionCriticalChange: "Critical change",
    sdsComparisonSectionHighImpact: "High impact",
    sdsComparisonSectionChanged: "Changed",
    sdsComparisonSectionMinorChange: "Minor change",
    sdsComparisonSectionNoChange: "No change",
    sdsNoteComplianceImpactLabel: "Compliance impact",
    sdsNoteComplianceImpactPlaceholder:
      "Describe the compliance impact for this section.",
    sdsNoteRequiredForCritical:
      "A note is required for critical/high impact changes.",
    sdsNoteChangeSeverityLabel: "Change severity",
    sdsNoteChangeSeverityNone: "None",
    sdsNoteChangeSeverityLow: "Low",
    sdsNoteChangeSeverityMedium: "Medium",
    sdsNoteChangeSeverityHigh: "High",
    sdsNoteChangeSeverityCritical: "Critical",
    sdsNoteAssignedActions: "Assigned actions",
    sdsNoteAddAction: "Add action",
    sdsNoteDepartmentLabel: "Department",
    sdsNoteActionTypeLabel: "Action type",
    sdsNoteActionTypeOther: "Other",
    sdsNoteDueDateLabel: "Due date",
    sdsDeptPlantSafety: "Plant safety",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Procurement",
    sdsDeptQuality: "Quality",
    sdsDeptLogistics: "Logistics",
    sdsDeptWarehouse: "Warehouse",
    sdsActionUpdateSops: "Update SOPs",
    sdsActionUpdateEmergencyProcedures: "Update emergency procedures",
    sdsActionUpdateWorkplaceSignage: "Update workplace signage",
    sdsActionScheduleTraining: "Schedule training",
    sdsActionUpdateRiskAssessment: "Update risk assessment",
    sdsActionReportToAuthority: "Report to authority",
    sdsActionVendorQuery: "Vendor query",
    sdsActionSupplierQualification: "Supplier qualification",
    sdsActionSourceAlternative: "Source alternative supplier",
    sdsActionUpdateSpecification: "Update specification",
    sdsActionUpdateMaterialDataSheet: "Update material data sheet",
    sdsActionUpdateTransportDoc: "Update transport document",
    sdsActionUpdateHazmatDeclaration: "Update hazmat declaration",
    sdsActionUpdateStorageSop: "Update storage SOP",
    sdsActionReviewSegregation: "Review segregation",
    sdsActionsTitle: "Action Tracker",
    sdsActionsFilterStatus: "Status",
    sdsActionsFilterDepartment: "Department",
    sdsActionsFilterMaterial: "Search material or CAS",
    sdsActionsFilterDueDateFrom: "Due date from",
    sdsActionsFilterDueDateTo: "Due date to",
    sdsActionsColumnMaterial: "Material",
    sdsActionsColumnSection: "Section",
    sdsActionsColumnDepartment: "Department",
    sdsActionsColumnAction: "Action",
    sdsActionsColumnDueDate: "Due date",
    sdsActionsColumnStatus: "Status",
    sdsActionsMarkComplete: "Mark complete",
    sdsActionsMarkCompleteConfirm:
      "Do you want to mark this action as completed?",
    sdsActionsMarkedComplete: "Action marked as completed",
    sdsActionsStatusOpen: "Open",
    sdsActionsStatusInProgress: "In Progress",
    sdsActionsStatusCompleted: "Completed",
    sdsActionsStatusOverdue: "Overdue",
    sdsActionsSelected: "selected",
    sdsActionsEmptyState:
      "No compliance actions yet. Actions are created while reviewing a comparison.",
    sdsActionsBackendNotice:
      "The action list currently has no backend data. Entries will appear once API integration is available.",
    sdsApproveReviewDecision: "Review decision",
    sdsApproveDocumentationProgress: "Documentation progress",
    sdsApproveBlockedMissingNotes: "Approval blocked, missing notes",
    sdsApproveOpenActions: "Open actions",
    sdsApproveComparisonStarted: "Comparison started",
    sdsApproveBaseline: "Baseline",
    sdsApproveIncoming: "Incoming",
    sdsApproveButton: "Approve",
    sdsRejectButton: "Reject",
    sdsApproveConfirmMessage: "Do you want to approve this comparison?",
    sdsApproveConfirmMessageDetailed:
      'Approve "{incoming}" as the new baseline for "{material}"? The previous baseline ("{baseline}") will be archived as superseded.',
    sdsApproveConfirmTitle: "Approve comparison",
    sdsApproveSuccess: "Comparison approved successfully",
    sdsRejectReasonPrompt: "Please provide a rejection reason",
    sdsRejectTitle: "Reject comparison",
    sdsRejectSuccess: "Comparison rejected",
    productComplianceWorkflowReceived: "Received",
    productComplianceWorkflowInProgress: "In progress",
    productComplianceWorkflowApproved: "Approved",
    productComplianceWorkflowObsolete: "Obsolete",
    productComplianceMaterialTimelineSummaryPending: "Pending review",
    productComplianceMaterialTimelineSummaryPendingDescription:
      "Versions waiting for release",
    productComplianceMaterialTimelineSummaryApproved: "Approved",
    productComplianceMaterialTimelineSummaryApprovedDescription:
      "Versions with validated compliance",
    productComplianceMaterialTimelineSummarySuperseded: "Superseded",
    productComplianceMaterialTimelineSummarySupersededDescription:
      "Versions kept for traceability",
    productComplianceMaterialTimelineSectionTitle: "Complete Timeline",
    productComplianceMaterialTimelineSectionSubtitle:
      "Chronological SDS versions, status, imports and latest changes",
    productComplianceMaterialTimelineFamilySearchPlaceholder:
      "Search by CAS, supplier or material...",
    productComplianceMaterialTimelineFamilyMaterial: "Material",
    productComplianceMaterialTimelineFamilySupplier: "Supplier",
    productComplianceMaterialTimelineFamilyVersions: "Versiones",
    productComplianceMaterialTimelineOrderAz: "A-Z",
    productComplianceMaterialTimelineOrderNewest: "Most recent",
    productComplianceMaterialTimelineOrderOldest: "Least recent",
    productComplianceMaterialTimelineSearchPlaceholder:
      "Search by version, supplier or change...",
    productComplianceMaterialTimelineImported: "Import",
    productComplianceMaterialTimelineLatestChanges: "Latest changes",
    productComplianceMaterialTimelineEmpty:
      "No timeline entries found for current search.",
    productComplianceMaterialTimelineShortcutsTitle: "Shortcuts",
    productComplianceMaterialTimelineShortcutGenealogy:
      "Open recursive genealogy",
    productComplianceMaterialTimelineShortcutEvidence: "Compose evidence pack",
    productComplianceMaterialTimelineShortcutLabel: "Print GHS label",
    productComplianceMaterialTimelineLegendTitle: "Status legend",
    productComplianceMaterialTimelineCompositionTitle: "Composition",
    productComplianceMaterialTimelineCharacteristicsTitle:
      "Material characteristics",
    productComplianceMaterialTimelineDocumentSignalsTitle: "Document signals",
    productComplianceMaterialTimelineFieldSupplier: "Supplier",
    productComplianceMaterialTimelineFieldUfi: "UFI",
    productComplianceMaterialTimelineFieldSubstance: "Substance",
    productComplianceMaterialTimelineFieldConcentration: "Concentration",
    productComplianceMaterialTimelineFieldSection3Source: "Section 3 source",
    productComplianceMaterialTimelineFieldParsingStatus: "Parsing status",
    productComplianceMaterialTimelineFieldSectionsDetected: "Sections detected",
    productComplianceMaterialTimelineFieldMissingSections: "Missing sections",
    productComplianceMaterialTimelineFieldAcceptability: "Acceptability",
    productComplianceMaterialTimelineFieldAdditional: "Additional data",
    productComplianceMaterialTimelineNotAvailable: "Not available",
    productComplianceMaterialTimelineAcceptabilityAccepted: "Accepted",
    productComplianceMaterialTimelineAcceptabilityRejected: "Rejected",
    productComplianceMaterialTimelineAcceptabilityPending: "Pending",
    productComplianceMaterialTimelineSection3SourceHttp: "Extractor API",
    productComplianceMaterialTimelineSection3SourceDeterministic:
      "Deterministic analysis",
    productComplianceMaterialTimelineSection3SourceHttpDisabled:
      "Extractor disabled",
    productComplianceMaterialTimelineParsingComplete: "Complete",
    productComplianceMaterialTimelineParsingIncomplete: "Incomplete",
    productComplianceStatusPendingReview: "Pending review",
    productComplianceStatusApproved: "Approved",
    productComplianceStatusSuperseded: "Superseded",
    productComplianceMaterialSodiumHydroxide: "Sodium Hydroxide 50%",
    productComplianceMaterialSulfuricAcid: "Sulfuric Acid 98%",
    productComplianceSupplierChemcorp: "Supplier: ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Supplier: GlobalChem Ltd.",
    productComplianceMaterialTimelineChangeSodium20Section2:
      "Section 2: corrosive pictograms updated",
    productComplianceMaterialTimelineChangeSodium20Section16:
      "Section 16: CLP references harmonized",
    productComplianceMaterialTimelineChangeSodium21Section8:
      "Section 8: exposure thresholds aligned for Lyon site",
    productComplianceMaterialTimelineChangeSodium21Section11:
      "Section 11: toxicology wording clarified",
    productComplianceMaterialTimelineChangeSodium30Section8:
      "Section 8: stronger PPE, face shield mandatory",
    productComplianceMaterialTimelineChangeSodium30Section2:
      "Section 2: signal word changed from Warning to Danger",
    productComplianceMaterialTimelineChangeSodium30Section15:
      "Section 15: regulatory references completed",
    productComplianceMaterialTimelineChangeSodium12Section3:
      "Section 3: nominal concentration 49-51%",
    productComplianceMaterialTimelineChangeSodium12Section8:
      "Section 8: functional equivalence confirmed",
    productComplianceMaterialTimelineChangeSodium12Section16:
      "Section 16: transport addendum added",
    productComplianceMaterialTimelineChangeSulfuric15Section8:
      "Section 8: extra hand protection for hot filling",
    productComplianceMaterialTimelineChangeSulfuric15Section14:
      "Section 14: UN transport classification refined",
    productComplianceMaterialTimelineDeleteVersion: "Delete version",
    productComplianceMaterialTimelineDeleteFamily: "Delete family",
    productComplianceMaterialTimelineDeleteVersionConfirmTitle:
      "Delete version",
    productComplianceMaterialTimelineDeleteVersionConfirmMessage:
      'Are you sure you want to delete version "{version}"? This action cannot be undone.',
    productComplianceMaterialTimelineDeleteFamilyConfirmTitle:
      "Delete document family",
    productComplianceMaterialTimelineDeleteFamilyConfirmMessage:
      "Are you sure you want to delete this document family with all {count} version(s)? This action cannot be undone.",
    productComplianceMaterialTimelineDeleteVersionSuccess:
      "Version deleted successfully",
    productComplianceMaterialTimelineDeleteFamilySuccess:
      "Document family deleted successfully ({count} version(s))",
    productComplianceMaterialTimelineDeleteError: "Error deleting",
    sdsTimelineBackToWorkspace: "Back to Workspace",
    sdsTimelineExportEvidence: "Export Evidence",
    sdsTimelineViewComparison: "View Comparison",
    sdsImportDialogTitle: "Import SDS",
    sdsImportAsyncDescription:
      "The document is stored and extracted in the background. You can continue working.",
    sdsImportFileSize: "File size",
    sdsImportSelectMaterial: "Material",
    sdsImportSelectMaterialPlaceholder: "Select an existing material",
    sdsImportGuidance:
      "1. Select or create material · 2. Upload safety data sheet · 3. Follow background extraction",
    sdsImportCreateMaterial: "Create new material",
    sdsImportCreateMaterialTitle: "Create material",
    sdsImportCreateMaterialDescription:
      "After saving, the new material is selected for this safety data sheet.",
    sdsImportButtonStartExtraction: "Start extraction",
    sdsImportAccepted: "SDS extraction has started.",
    sdsExtractionStatusLabel: "Extraction status",
    sdsExtractionStatusextracting: "Extracting",
    sdsExtractionStatusready: "Ready",
    sdsExtractionStatusfailed: "Failed",
    sdsExtractionStatusstale: "Stale",
    sdsExtractionFailed: "SDS extraction failed.",
    sdsExtractionRetry: "Retry extraction",
    sdsExtractionRetryAccepted: "SDS extraction has restarted.",
    sdsImportStepValidating: "Validating file...",
    sdsImportStepExtractingText: "Extracting text...",
    sdsImportStepParsingSections: "Parsing sections...",
    sdsImportStepExtractingIdentity: "Extracting identity...",
    sdsImportStepExtractingSubstances: "Extracting substances...",
    sdsImportStepResolvingSupplier: "Resolving supplier...",
    sdsImportStepResolvingMaterial: "Resolving material...",
    sdsImportStepComplete: "Extraction complete",
    sdsImportSectionDocument: "Document",
    sdsImportSectionMaterial: "Material",
    sdsImportSectionSupplier: "Supplier",
    sdsImportSectionSubstances: "Substances",
    sdsImportSectionSections: "Sections",
    sdsImportSectionComment: "Comment",
    sdsImportFieldFilename: "File",
    sdsPolicyContext: "Policy context",
    sdsPolicyJurisdiction: "Jurisdiction",
    sdsPolicyMarkets: "Markets",
    sdsPolicyProductScopes: "Product scopes",
    sdsPolicyUfiState: "UFI state",
    sdsPolicyUfiStateunknown: "Unknown",
    sdsPolicyUfiStatepresent: "Present",
    sdsPolicyUfiStateabsent: "Absent",
    sdsPolicyUnconfigured: "Policy context is not configured",
    sdsPolicyContextReasonufi_state_unknown:
      "UFI state has not yet been determined from a completed extraction.",
    sdsPolicyContextReasonno_matching_regulatory_policy:
      "No matching Regulatory policy version was found.",
    sdsPolicyContextReasonno_matching_organization_control_profile:
      "No matching Organization control profile was found.",
    sdsPolicyAmbiguous: "Policy context is ambiguous",
    sdsPolicyAmbiguousDescription:
      "An authorized Policy Administrator must confirm a matching pair.",
    sdsPolicyRegulatoryVersion: "Regulatory policy version",
    sdsPolicyControlVersion: "Control profile version",
    sdsPolicyConfirmationRationale: "Rationale",
    sdsPolicyConfirm: "Confirm applicability",
    sdsPolicyStatus: "Status",
    sdsPolicyConfirmed: "Confirmed",
    sdsPolicyResolved: "Resolved",
    sdsPolicyConfirmationSaved: "Policy applicability was confirmed.",
    sdsPolicyRegulatoryPolicies: "Regulatory policies",
    sdsPolicyControlProfiles: "Organization control profiles",
    sdsPolicyVersions: "Versions",
    sdsPolicyEmpty: "No policies available.",
    sdsPolicyCreateRegulatory: "Create Regulatory policy",
    sdsPolicyCreateControl: "Create control profile",
    sdsPolicyEffectiveFrom: "Effective from",
    sdsPolicyEffectiveUntil: "Effective until",
    sdsPolicyUfiApplicability: "UFI applicability",
    sdsPolicyUfiRequired: "Required",
    sdsPolicyUfiOptional: "Optional",
    sdsPolicyUfiNotApplicable: "Not applicable",
    sdsPolicyRuleSubject: "Rule subject",
    sdsPolicyRuleCondition: "Rule condition",
    sdsPolicyEvaluationMode: "Evaluation method",
    sdsPolicyEvaluationModeReviewerAssessed: "Reviewer assessed",
    sdsPolicyEvaluationModereviewer_assessed: "Reviewer assessed",
    sdsPolicyEvidenceRequirements: "Evidence requirements",
    sdsPolicySeverity: "Severity",
    sdsPolicySeverityLow: "Low",
    sdsPolicySeverityMedium: "Medium",
    sdsPolicySeverityHigh: "High",
    sdsPolicySeverityCritical: "Critical",
    sdsPolicyBlockingEffect: "Blocking effect",
    sdsPolicyBlockingEffectNone: "None",
    sdsPolicyBlockingEffectAssessment: "Block assessment",
    sdsPolicyBlockingEffectApproval: "Block approval",
    sdsPolicyCitationSource: "Source",
    sdsPolicyCitationReference: "Reference",
    sdsPolicyCitationUrl: "Source URL",
    sdsPolicyControlRequirement: "Control requirement",
    sdsPolicyRegulatoryRuleId: "Regulatory rule ID",
    sdsPolicyControlEffect: "Control effect",
    sdsPolicyControlEffectAdditional: "Additional requirement",
    sdsPolicyControlEffectStrengthen: "Strengthen requirement",
    sdsImportFieldPages: "Pages",
    sdsImportFieldLanguage: "Language",
    sdsImportFieldRevisionDate: "Revision date",
    sdsImportFieldMaterialName: "Material name",
    sdsImportFieldMaterialNumber: "Material number",
    sdsImportFieldTradeName: "Trade name",
    sdsImportFieldUfi: "UFI",
    sdsImportConfidence: "Confidence: {value}%",
    sdsImportFieldSupplierName: "Supplier name",
    sdsImportSupplierNotFound:
      "Supplier not found in registry. You can link this SDS to an existing supplier or accept a new entry.",
    sdsImportMaterialNotFound:
      "Material not found in catalog. You can link this SDS to an existing material or accept a new entry.",
    sdsImportLinkExistingSupplier: "Link existing supplier",
    sdsImportLinkExistingMaterial: "Link existing material",
    sdsSupplierListTitle: "Suppliers",
    sdsSupplierAddButton: "Add Supplier",
    sdsMaterialCreated: "Material has been created.",
    sdsSupplierEmptyState: "No suppliers available.",
    sdsSupplierBackendNotice:
      "Supplier management requires a backend update — list will appear once available.",
    sdsSupplierContact: "Contact",
    sdsSupplierMaterialsCount: "Materials",
    sdsSupplierSdsDocuments: "SDS Documents",
    sdsSupplierSdsEmptyState: "No SDS documents available.",
    sdsSupplierFieldName: "Name",
    sdsSupplierFieldCode: "Code",
    sdsSupplierFieldCountry: "Country",
    sdsSupplierFieldAddress: "Address",
    sdsSupplierFieldContactName: "Contact name",
    sdsSupplierFieldContactEmail: "Contact email",
    sdsSupplierFieldContact: "Contact",
    sdsSupplierFieldStatus: "Status",
    sdsSupplierFieldNotes: "Notes",
    sdsSupplierCodePlaceholder: "Supplier code",
    sdsSupplierStatusActive: "Active",
    sdsSupplierStatusInactive: "Inactive",
    sdsSupplierStatusUnderReview: "Under review",
    sdsSupplierSavedSuccess: "Supplier saved successfully.",
    sdsSupplierDetailTitle: "Supplier details",
    sdsSupplierNotVerified: "Not verified",
    sdsSupplierFormCrudNotice:
      "Creating and editing suppliers requires a backend update. You can already fill in the form.",
    sdsImportFieldLongComment: "Note",
    sdsImportSubstanceName: "Name",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Concentration",
    sdsImportSubstanceAdd: "Add substance",
    sdsImportButtonConfirm: "Confirm import",
    sdsImportStatusFound: "Found",
    sdsImportStatusCreated: "New",
    sdsImportStatusNotFound: "Not found",
    sdsImportStatusError: "Error",
    sdsImportConfirmSuccess: "Import confirmed successfully",
    sdsImportConfirmSuccessWithMaterial:
      "SDS imported successfully — {material}",
    sdsImportAnalyzing: "Analyzing...",
    sdsImportStreamError: "Error during extraction",
    sdsImportWarnings: "Warnings",
    sdsImportPreviewReady: "Preview ready — review fields and confirm",
    sdsImportNoFile: "No file selected",
    sdsImportUfiInvalid:
      "Invalid format — expected: XXXX-XXXX-XXXX-XXXX (e.g. A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Invalid CAS number — expected: XXXXXXX-XX-X with valid check digit",
    sdsNavApplication: "SDS",
    sdsNavDashboard: "Dashboard",
    sdsNavInbox: "Dashboard",
    sdsNotAvailable: "Not available",
    sdsInboxTitle: "Dashboard",
    sdsInboxUpload: "Upload SDS",
    sdsInboxSearchPlaceholder: "Search document, product, or supplier",
    sdsInboxExtractionFilter: "Extraction status",
    sdsInboxResolutionFilter: "Resolution status",
    sdsInboxSupplierResolutionFilter: "Issuer resolution",
    sdsInboxMaterialResolutionFilter: "Material assignment",
    sdsInboxReviewFilter: "Review status",
    sdsInboxValidityFilter: "Validity",
    sdsInboxSupplierFilter: "Issuer",
    sdsInboxMaterialFilter: "Material",
    sdsInboxAllStates: "All states",
    sdsInboxDocument: "Document",
    sdsInboxVersion: "Version {version}",
    sdsInboxRevisionDate: "Revision date",
    sdsInboxIdentity: "Extracted identity",
    sdsInboxIssuer: "Issuer",
    sdsInboxRelatedMaterials: "Related materials",
    sdsInboxRelatedMaterialsCount: "{count} related",
    sdsInboxExtraction: "Extraction",
    sdsInboxResolution: "Resolution",
    sdsInboxReview: "Review status",
    sdsInboxValidity: "Validity",
    sdsInboxLastActivity: "Last activity",
    sdsResolutionStatusunresolved: "Unresolved",
    sdsResolutionStatusin_progress: "In progress",
    sdsResolutionStatusresolved: "Resolved",
    sdsSupplierResolutionStatusunresolved: "Issuer unresolved",
    sdsSupplierResolutionStatusconfirmed: "Issuer confirmed",
    sdsSupplierResolutionStatuscorrected: "Issuer corrected",
    sdsMaterialResolutionStatusunassigned: "No material assigned",
    sdsMaterialResolutionStatusambiguous: "Material decision pending",
    sdsMaterialResolutionStatusassigned: "Material assigned",
    sdsValidityStatusvalid: "Valid",
    sdsValidityStatusexpiring: "Expiring soon",
    sdsValidityStatusexpired: "Expired",
    sdsValidityStatusunknown: "Validity unknown",
    sdsWorkflowreceived: "Received",
    sdsWorkflowin_progress: "In progress",
    sdsWorkflowapproved: "Approved",
    sdsWorkflowobsolete: "Obsolete",
    sdsDocumentTitle: "SDS document",
    sdsDocumentBackToInbox: "Back to dashboard",
    sdsDocumentRetryExtraction: "Retry extraction",
    sdsDocumentExtractionFailed: "Extraction failed",
    sdsDocumentExtractionFailedDescription:
      "Extraction could not be completed. Retry it or contact support.",
    sdsDocumentExtractionStale: "Extraction timed out",
    sdsDocumentExtractionStaleDescription:
      "Extraction exceeded its timeout. Retry extraction.",
    sdsDocumentDispatchFailed: "Extraction dispatch failed",
    sdsDocumentDispatchFailedDescription:
      "Extraction could not start. Retry dispatch.",
    sdsDocumentExtractionAttempt: "Extraction attempt",
    sdsDocumentExtractionStarted: "Extraction started",
    sdsDocumentExtractionCompleted: "Extraction completed",
    sdsDocumentAttemptCompleted: "Completed at",
    sdsDocumentAttemptExtraction: "Method and workflow",
    sdsDocumentAttemptProviderModel: "Provider: {provider} · Model: {model}",
    sdsDocumentAttemptConfidence: "Confidence: {semantics} · {level}",
    sdsDocumentAttemptProvenance: "Provenance",
    sdsDocumentAttemptSourceMode: "Source: {sourceMode}",
    sdsDocumentAttemptNoSourceReferences: "No source references available",
    sdsDocumentAttemptSourcePage: "Page {page}",
    sdsDocumentAttemptSourceSpan: "Page {page}, characters {start}–{end}",
    sdsDocumentAttemptCompleteProvenance: "Provenance complete",
    sdsDocumentAttemptMissingSections: "Missing sections: {sections}",
    sdsDocumentAttemptUnavailableFragments: "Unavailable fragments: {count}",
    sdsDocumentAttemptIncompleteTableProvenance: "Table provenance incomplete",
    sdsDocumentAttemptFailure: "Failure details",
    sdsDocumentAttemptFailureCode: "Code: {code}",
    sdsDocumentAttemptFailureField: "Field: {field}",
    sdsDocumentAttemptFailureReason: "Reason: {reason}",
    sdsDocumentAttemptGovernance: "Extraction assessment",
    sdsDocumentAttemptGovernanceDescription:
      "Persisted assessment for this extraction attempt. The backend determines review readiness.",
    sdsDocumentAttemptTextSource: "Text source",
    sdsDocumentAttemptTextSourcenative_text: "Embedded text",
    sdsDocumentAttemptTextSourceocr: "Optical character recognition (OCR)",
    sdsDocumentAttemptLanguage: "Detected language",
    sdsDocumentAttemptLanguageSupportsupported: "Supported",
    sdsDocumentAttemptLanguageSupportunsupported: "Unsupported",
    sdsDocumentAttemptRequiredContent: "Required content",
    sdsDocumentAttemptRequiredContentcomplete: "Complete",
    sdsDocumentAttemptRequiredContentincomplete: "Incomplete",
    sdsDocumentAttemptRequiredContentinvalid: "Invalid",
    sdsDocumentAttemptRequiredContentunavailable: "Unavailable",
    sdsDocumentAttemptUncertainty: "Uncertainty",
    sdsDocumentAttemptUncertaintynone: "None",
    sdsDocumentAttemptUncertaintycontradictory: "Contradictory",
    sdsDocumentAttemptReviewReadiness: "Review readiness",
    sdsDocumentAttemptReviewreview_ready: "Ready for review",
    sdsDocumentAttemptReviewblocked: "Blocked",
    sdsDocumentAttemptMissingFields: "Missing required fields",
    sdsDocumentAttemptInvalidFields: "Invalid required fields",
    sdsDocumentAttemptRequiredContentIssue: "{field}: {reason}",
    sdsDocumentAttemptContradictions: "Contradictory facts",
    sdsDocumentAttemptEvidenceIds: "Evidence IDs: {evidenceIds}",
    sdsDocumentAttemptBlockingReasons: "Blocking reasons",
    sdsDocumentAttemptBlockingReasonunsupported_language:
      "Unsupported language",
    sdsDocumentAttemptBlockingReasonincomplete_required_content:
      "Incomplete required content",
    sdsDocumentAttemptBlockingReasoninvalid_required_content:
      "Invalid required content",
    sdsDocumentAttemptBlockingReasoncontradictory_evidence:
      "Contradictory evidence",
    sdsDocumentAttemptBlockingReasonmalformed_input: "Malformed input",
    sdsDocumentAttemptBlockingReasonterminal_failure: "Terminal failure",
    sdsDocumentFailureRetryable: "Retry available",
    sdsDocumentFailureNotRetryable: "Retry unavailable",
    sdsDocumentSelectVersion: "Select version",
    sdsDocumentTabDocument: "Document and versions",
    sdsDocumentTabExtraction: "Evaluate extraction",
    sdsDocumentTabFacts: "Safety data sheet",
    sdsDocumentTabSupplier: "Issuer",
    sdsDocumentTabMaterials: "Applicable materials",
    sdsDocumentTabEvidence: "Source evidence",
    sdsDocumentTabAssessment: "Governed assessment",
    sdsDocumentTabActivity: "Activity",
    sdsRevisionComparisonTitle: "Revision comparison",
    sdsRevisionComparisonDescription:
      "Compare this Revision with the current Effective Revision of the same Safety Data Sheet.",
    sdsRevisionComparisonCreate: "Create comparison",
    sdsRevisionComparisonRefresh: "Refresh comparison",
    sdsRevisionComparisonBaseline: "Effective baseline Revision",
    sdsRevisionComparisonCandidate: "Candidate Revision",
    sdsRevisionComparisonCreated: "Created at",
    sdsRevisionComparisonDigest: "Comparison digest",
    sdsRevisionComparisonBaselineSnapshotId: "Baseline snapshot ID",
    sdsRevisionComparisonCandidateSnapshotId: "Candidate snapshot ID",
    sdsRevisionComparisonBaselineInputDigest: "Baseline input digest",
    sdsRevisionComparisonCandidateInputDigest: "Candidate input digest",
    sdsRevisionComparisonCategory: "Category",
    sdsRevisionComparisonAllCategories: "All categories",
    sdsRevisionComparisonFactPath: "Fact path",
    sdsRevisionComparisonSection: "Section",
    sdsRevisionComparisonApplyFilters: "Apply filters",
    sdsRevisionComparisonPosition: "Position",
    sdsRevisionComparisonFactAbsent: "Fact absent",
    sdsRevisionComparisonNoDifferences: "No facts match the selected filters.",
    sdsRevisionComparisonNoSection: "No section",
    sdsRevisionComparisonSectionNumber: "Section {section}",
    sdsRevisionComparisonCategoryadded: "Added",
    sdsRevisionComparisonCategoryremoved: "Removed",
    sdsRevisionComparisonCategorychanged: "Changed",
    sdsRevisionComparisonCategoryunchanged: "Unchanged",
    sdsRevisionComparisonCategoryunknown: "Unknown",
    sdsRevisionComparisonCategorycontradictory: "Contradictory",
    sdsRevisionComparisonEvidenceTitle: "Linked source evidence",
    sdsRevisionComparisonEvidenceRelation: "Evidence relation",
    sdsRevisionComparisonEvidenceUnavailable:
      "The frozen source evidence is unavailable.",
    sdsAssessmentBlockingOutcome: "Blocking outcome",
    sdsComplianceActionsTitle: "Compliance actions",
    sdsComplianceActionsDescription:
      "Assigned work for immutable assessment findings.",
    sdsComplianceActionsRefresh: "Refresh actions",
    sdsComplianceActionsEmpty: "No Compliance actions exist.",
    sdsComplianceActionCreate: "Create Compliance action",
    sdsComplianceActionFindings: "Findings",
    sdsComplianceActionOwner: "Action owner",
    sdsComplianceActionNewOwner: "New action owner",
    sdsComplianceActionContext: "Required work context",
    sdsComplianceActionDueAt: "Due at",
    sdsComplianceActionRequired: "Required",
    sdsComplianceActionBlocking: "Blocking",
    sdsComplianceActionRationale: "Rationale",
    sdsComplianceActionStart: "Start work",
    sdsComplianceActionComplete: "Complete",
    sdsComplianceActionReassign: "Reassign",
    sdsComplianceActionWaive: "Authorize waiver",
    sdsComplianceActionCancel: "Cancel",
    sdsComplianceActionDisposition: "Record finding disposition",
    sdsComplianceActionDispositionFinding: "Finding to dispose",
    sdsComplianceActionOverdue: "Overdue",
    sdsComplianceActionSaved: "Compliance action was saved.",
    sdsComplianceActionStatusopen: "Open",
    sdsComplianceActionStatusin_progress: "In progress",
    sdsComplianceActionStatuscompleted: "Completed",
    sdsComplianceActionStatuswaived: "Waived",
    sdsComplianceActionStatuscancelled: "Cancelled",
    sdsAssessmentStatus: "Assessment status",
    sdsAssessmentCreatedAt: "Created at",
    sdsAssessmentEffectiveFrom: "Effective from",
    sdsAssessmentEffectiveTimeZone: "Effective timezone",
    sdsAssessmentEffectiveStatus: "Effective status",
    sdsAssessmentSupersededAt: "Superseded at",
    sdsAssessmentBaselineAssessment: "Baseline assessment",
    sdsAssessmentBaselineRevision: "Effective baseline Revision",
    sdsAssessmentTerminalRationale: "Terminal rationale",
    sdsAssessmentRegulatoryFindings: "Regulatory findings",
    sdsAssessmentOrganizationFindings: "Organization findings",
    sdsAssessmentRequirement: "Requirement",
    sdsAssessmentRequirementId: "Requirement ID: {requirementId}",
    sdsAssessmentRequirementVersionId:
      "Requirement version ID: {requirementVersionId}",
    sdsAssessmentOutcome: "Outcome",
    sdsAssessmentRationale: "Rationale",
    sdsAssessmentComment: "Comment",
    sdsAssessmentEvidence: "Source evidence",
    sdsAssessmentEvidenceReference: "Page {page}, paragraph {paragraph}",
    sdsAssessmentEvidenceReferenceId: "Evidence {evidenceId} ({relation})",
    sdsAssessmentEvaluation: "Evaluation",
    sdsAssessmentReviewedBy: "Reviewed by",
    sdsAssessmentCreateDescription:
      "Record an outcome, rationale, and source evidence for every regulatory and organization requirement.",
    sdsAssessmentCreate: "Create assessment",
    sdsAssessmentCreated: "Assessment created.",
    sdsAssessmentDraftDescription:
      "Finding drafts remain editable until submission.",
    sdsAssessmentSaveFindingDrafts: "Save finding drafts",
    sdsAssessmentDraftSaved: "Finding drafts saved.",
    sdsAssessmentSubmissionRationale: "Submission rationale",
    sdsAssessmentSubmit: "Submit assessment",
    sdsAssessmentSubmitted: "Assessment submitted for review.",
    sdsAssessmentCancellationRationale: "Cancellation rationale",
    sdsAssessmentCancel: "Cancel assessment",
    sdsAssessmentCancelled: "Assessment cancelled.",
    sdsAssessmentRejectionRationale: "Rejection rationale",
    sdsAssessmentReject: "Reject assessment",
    sdsAssessmentRejected: "Assessment rejected.",
    sdsAssessmentHistory: "Assessment history",
    sdsAssessmentKind: "Assessment kind",
    sdsAssessmentKindinitial_baseline: "Initial baseline",
    sdsAssessmentKindcandidate_revision: "Candidate revision",
    sdsAssessmentPolicyRequired:
      "A resolved or confirmed policy applicability is required.",
    sdsAssessmentReviewerRequired:
      "A reviewer role is required to create the assessment.",
    sdsAssessmentReadyForApproval:
      "All blocking findings are satisfied and ready for approval.",
    sdsAssessmentBlocked:
      "Unsatisfied or unknown blocking findings prevent approval.",
    sdsAssessmentApprovalRationale: "Approval rationale",
    sdsAssessmentInvalidEffectiveDateTime:
      "Date, time, and IANA timezone must resolve to one instant.",
    sdsAssessmentAcceptedExceptions: "Accepted exceptions",
    sdsAssessmentAcceptedExceptionFinding: "Exception finding",
    sdsAssessmentAcceptedExceptionRationale: "Exception rationale",
    sdsAssessmentAcceptedAt: "Accepted at",
    sdsAssessmentAddAcceptedException: "Add exception",
    sdsAssessmentRemoveAcceptedException: "Remove exception",
    sdsAssessmentApprove: "Approve effectiveness",
    sdsAssessmentApproved: "Effective Revision approved.",
    sdsAssessmentOutcomesatisfied: "Satisfied",
    sdsAssessmentOutcomeunsatisfied: "Unsatisfied",
    sdsAssessmentOutcomeunknown: "Unknown",
    sdsAssessmentOutcomenot_applicable: "Not applicable",
    sdsAssessmentStatuspending_approval: "Pending approval",
    sdsAssessmentStatusscheduled: "Scheduled",
    sdsAssessmentStatuseffective: "Effective",
    sdsAssessmentStatusdraft: "Draft",
    sdsAssessmentStatusin_review: "In review",
    sdsAssessmentStatusawaiting_actions: "Awaiting actions",
    sdsAssessmentStatusapproved: "Approved",
    sdsAssessmentStatuscancelled: "Cancelled",
    sdsAssessmentStatusrejected: "Rejected",
    sdsAssessmentStatussuperseded: "Superseded",
    sdsDocumentResolution: "Resolution status",
    sdsDocumentIssuer: "Issuer",
    sdsDocumentExtraction: "Extraction status",
    sdsDocumentReview: "Review status",
    sdsDocumentSections: "Detected sections",
    sdsDocumentLastActivity: "Last activity",
    sdsDocumentReceipts: "Receipt occurrences",
    sdsDocumentReceiptFile: "File",
    sdsDocumentReceiptSize: "{size} bytes",
    sdsDocumentReceiptReceivedAt: "Received at",
    sdsDocumentReceiptChecksum: "SHA-256 checksum",
    sdsDocumentAttempts: "Extraction attempts",
    sdsDocumentAttemptNumber: "Attempt",
    sdsDocumentAttemptCreated: "Created at",
    sdsDocumentVersions: "Versions",
    sdsDocumentVersion: "Version {version}",
    sdsDocumentPrintDate: "Print date",
    sdsDocumentFactsAwaitingExtraction:
      "Extracted data is available after extraction completes.",
    sdsDocumentProvenance: "Data provenance",
    sdsDocumentProvenanceDescription:
      "Confidence assesses only automated extraction quality. It is optional and does not indicate whether data was extracted.",
    sdsDocumentProvenanceField: "Field",
    sdsDocumentProvenanceSource: "Source",
    sdsDocumentProvenanceConfidence: "Extraction confidence",
    sdsDocumentProvenanceExtractedAt: "Extracted at",
    sdsDocumentProvenanceUpdatedAt: "Manually updated at",
    sdsDocumentProvenanceConfidenceNotAssessed:
      "No confidence assessment available",
    sdsDocumentProvenanceNotManuallyUpdated: "Not manually updated yet",
    sdsDocumentProvenanceUnavailable: "No provenance data available.",
    sdsDocumentProvenanceSourceextracted: "Extracted",
    sdsDocumentProvenanceSourcemanual: "Manually reviewed",
    sdsFactReviewTitle: "Review extracted data",
    sdsFactReviewSection: "SDS section",
    sdsFactReviewDescription:
      "Review automatically extracted data by SDS section. Correct values as needed in the following area.",
    sdsFactMaintenanceDescription:
      "The data was adopted from extraction. Adjust information and save your changes.",
    sdsFactCarryForwardTitle: "Correction from previous Revision",
    sdsFactCarryForwardDescription:
      "Previously selected values are proposed. Review current extraction and adopt applicable corrections.",
    sdsFactCarryForwardPreviousExtracted: "Previous extraction",
    sdsFactCarryForwardPreviousSelected: "Previous correction",
    sdsFactCarryForwardCurrentExtracted: "Current extraction",
    sdsFactCarryForwardExtractionComparison: "Extraction comparison",
    sdsFactCarryForwardExtractionChanged:
      "Extraction changed from previous Revision",
    sdsFactCarryForwardExtractionUnchanged: "Extraction unchanged",
    sdsFactCarryForwardAdopt: "Adopt previous correction",
    sdsFactCarryForwardAdopted: "Previous correction adopted.",
    sdsFactCarryForwardConfirmTitle: "Adopt previous correction?",
    sdsFactCarryForwardDiscardChanges:
      "Unsaved changes will be discarded. Save them first if you want to keep them.",
    sdsFactCarryForwardConfirm: "Adopt and discard changes",
    sdsFactAuditChangedAt: "Changed at",
    sdsFactAuditChangedBy: "Changed by",
    sdsFactAuditSource: "Change type",
    sdsFactAuditSourceRevision: "Source Revision",
    sdsFactAuditSourcemanual: "Manual change",
    sdsFactAuditSourcecarry_forward: "Previous correction",
    sdsFactAuditSourcecorrection: "Fact correction",
    sdsFactAuditSourceacknowledgement: "Acknowledgement",
    sdsFactReviewProgress: "{reviewed} of {total} facts reviewed",
    sdsFactReviewField: "Field",
    sdsFactReviewValue: "Value",
    sdsFactReviewCurrentValue: "Current interpretation",
    sdsFactReviewCertainty: "Completeness",
    sdsFactReviewDecision: "Decision",
    sdsFactReviewConclusion: "Conclusion",
    sdsFactReviewNoConclusion: "No canonical conclusion",
    sdsFactReviewAccept: "Accept",
    sdsFactReviewReject: "Reject",
    sdsFactReviewCorrect: "Correct",
    sdsFactReviewAcknowledgeUnknown: "Acknowledge unknown",
    sdsFactReviewAcknowledgeContradictory: "Acknowledge contradiction",
    sdsFactReviewSubmit: "Save decision",
    sdsFactReviewDialogaccepted: "Accept interpretation",
    sdsFactReviewDialogrejected: "Reject interpretation",
    sdsFactReviewDialogcorrected: "Correct interpretation",
    sdsFactReviewDialogacknowledged_unknown: "Acknowledge unknown conclusion",
    sdsFactReviewDialogacknowledged_contradictory:
      "Acknowledge contradictory conclusion",
    sdsFactReviewDecisionpending: "Pending",
    sdsFactReviewDecisionaccepted: "Accepted",
    sdsFactReviewDecisionrejected: "Rejected",
    sdsFactReviewDecisioncorrected: "Corrected",
    sdsFactReviewDecisionacknowledged_unknown: "Unknown acknowledged",
    sdsFactReviewDecisionacknowledged_contradictory:
      "Contradiction acknowledged",
    sdsFactReviewConclusionknown: "Known",
    sdsFactReviewConclusionunknown: "Unknown",
    sdsFactReviewConclusioncontradictory: "Contradictory",
    sdsFactReviewCertaintycomplete: "Complete",
    sdsFactReviewCertaintymissing: "Missing",
    sdsFactReviewCertaintymalformed: "Malformed",
    sdsFactReviewCertaintypartial: "Partial",
    sdsFactReviewCertaintycontradictory: "Contradictory",
    sdsFactReviewCertaintyunknown_confidence: "Unknown confidence",
    sdsFactReviewEvidenceTitle: "Linked source evidence",
    sdsFactReviewEvidenceDescription:
      "Select at least one attempt-scoped paragraph and its relationship.",
    sdsFactReviewEvidenceMissing: "Linked source evidence unavailable",
    sdsFactReviewOpenEvidence: "Open source evidence",
    sdsFactReviewNoEvidence: "No source evidence linked to this fact.",
    sdsFactReviewNoEvidenceAvailable:
      "No source evidence is available for this Revision.",
    sdsFactReviewSupporting: "Supporting",
    sdsFactReviewContradicting: "Contradicting",
    sdsFactReviewHistoryTitle: "Decision history",
    sdsFactReviewNoHistory: "No review decision has been stored.",
    sdsFactReviewPending: "Pending",
    sdsFactReviewReviewedBy: "Reviewed by {reviewer}",
    sdsFactReviewCorrectionsTitle: "Correction audit",
    sdsFactReviewAcknowledgementsTitle: "Acknowledged conclusions",
    sdsFactReviewPreviousValue: "Previous value",
    sdsFactReviewCorrectedValue: "Corrected value",
    sdsFactReviewReason: "Correction reason",
    sdsFactReviewConclusionReason: "Conclusion rationale",
    sdsFactReviewComment: "Comment",
    sdsFactReviewSaved: "Review decision saved.",
    sdsFactReviewConflictTitle: "Fact was reviewed concurrently",
    sdsFactReviewConflictMessage:
      "Current state was reloaded. Review the changes before deciding again.",
    sdsFactReviewUfiValue: "UFI",
    sdsFactReviewUfiScope: "Scope",
    sdsFactReviewUfiScopeValue: "Scope value",
    sdsFactReviewAddUfi: "Add UFI",
    sdsFactReviewUfiScopeproductUuid: "Product",
    sdsFactReviewUfiScopemixtureUuid: "Mixture",
    sdsFactReviewUfiScopemarket: "Market",
    sdsFactReviewUfiScopelanguage: "Language",
    sdsDocumentEvidenceUnavailable:
      "Source evidence is available after the extraction outcome has been stored.",
    sdsDocumentEvidenceSource: "Source",
    sdsDocumentEvidencePage: "Page {page}",
    sdsDocumentEvidenceLocation: "SDS section {section} · Page {page}",
    sdsDocumentEvidenceSectionUnknown: "unknown",
    sdsDocumentEvidenceHeadingUnknown: "Heading not detected",
    sdsDocumentFocusedEvidence: "Selected source evidence",
    sdsPdfReviewDownload: "Download PDF",
    sdsPdfReviewPreviousPage: "Previous page",
    sdsPdfReviewNextPage: "Next page",
    sdsPdfReviewPage: "Page",
    sdsPdfReviewPageOf: "of {count}",
    sdsPdfReviewLoadFailed: "Original PDF could not be loaded.",
    sdsPdfReviewUnavailable:
      "Original safety data sheet for this version is not available.",
    sdsDocumentEvidenceProvenance: "Extraction provenance",
    sdsDocumentEvidenceCreated: "Stored at",
    sdsDocumentEvidenceContent: "Paragraph",
    sdsDocumentEvidenceSection: "Linked section/fact",
    sdsDocumentEvidenceUnlinked: "Not linked to a fact",
    sdsDocumentExtractedIdentity: "Extracted product identity",
    sdsDocumentProductName: "Product name",
    sdsDocumentMaterialNumber: "Material number",
    sdsDocumentUfi: "UFI",
    sdsFactsIssuerName: "Issuer name",
    sdsDocumentExtractedSupplier: "Extracted supplier",
    sdsFactsSelectIssuer: "Select issuer",
    sdsFactsSelectSupplier: "Select supplier",
    sdsFactsSection1Title: "Section 1 · Identification",
    sdsFactsSection1Description:
      "Product identity, uses, and issuer details from the safety data sheet.",
    sdsFactsRecommendedUses: "Recommended uses",
    sdsFactsUsesAdvisedAgainst: "Uses advised against",
    sdsFactsMultilineListHint: "Enter each item on a separate line.",
    sdsFactsSupplierAddress: "Issuer address",
    sdsFactsSupplierEmail: "Issuer email",
    sdsFactsSupplierPhone: "Issuer phone",
    sdsFactsEmergencyPhone: "Emergency phone",
    sdsFactsSection2Title: "Section 2 · Hazard identification",
    sdsFactsSection2Description:
      "Classification, label elements, and other hazards.",
    sdsFactsPictograms: "Hazard pictograms",
    sdsFactsPStatements: "P statements",
    sdsFactsOtherHazards: "Other hazards",
    sdsFactsSection3Title: "Section 3 · Composition",
    sdsFactsSection3Description:
      "Substance or mixture type and classification-relevant ingredients.",
    sdsFactsSubstanceOrMixture: "Substance or mixture",
    sdsFactsAddIngredient: "Add ingredient",
    sdsFactsIngredient: "Ingredient {number}",
    sdsFactsCasNumber: "CAS no.",
    sdsFactsEcNumber: "EC no.",
    sdsFactsClassification: "Classification",
    sdsFactsNoIngredients: "No ingredients recorded.",
    sdsFactsSection15Title: "Section 15 · Regulatory information",
    sdsFactsSection15Description:
      "Product-specific regulations, restrictions, and assessments.",
    sdsFactsRegulatoryReferences: "Regulatory references",
    sdsFactsSevesoCategory: "SEVESO category",
    sdsFactsWaterHazardClass: "Water hazard class",
    sdsFactsVocValue: "VOC value",
    sdsFactsChemicalSafetyAssessment: "Chemical safety assessment",
    sdsFactsRestrictions: "Restriction conditions",
    sdsFactsSvhc: "SVHC",
    sdsFactsMicroplastics: "Microplastics / SPM",
    sdsDocumentFactsUnavailable: "No extracted data available.",
    sdsDocumentFactsSaved: "Extracted data saved.",
    sdsDocumentSupplierDecision: "Issuer assignment",
    sdsDocumentSupplierComment: "Assignment rationale",
    sdsDocumentSupplierCommentPlaceholder:
      "Document the reason for this correction",
    sdsDocumentIssuerResolutionDescription:
      "Confirm the issuer only after review. Correct the assignment or create a missing supplier.",
    sdsIssuerEvidenceTitle: "Extracted issuer and contact evidence",
    sdsCanonicalIssuerTitle: "Issuer",
    sdsCanonicalIssuerDescription:
      "Select or maintain the BusinessPartner that issued this Safety Data Sheet.",
    sdsCanonicalSupplierTitle: "Supplier",
    sdsCanonicalSupplierDescription:
      "Supplier defaults to issuer. Enable the difference only when another BusinessPartner supplies the product.",
    sdsSelectBusinessPartner: "Select BusinessPartner",
    sdsSupplierDiffersFromIssuer: "Supplier differs from issuer",
    sdsDocumentCreateSupplier: "Create supplier",
    sdsBusinessPartnerEdit: "Edit BusinessPartner",
    sdsBusinessPartnerSaved: "BusinessPartner saved.",
    sdsIdentityResolutionTitle: "SDS assignment",
    sdsIdentitySearch: "Find existing safety data sheet",
    sdsIdentityAddRevision: "Add as new Revision",
    sdsIdentityRevisionIdentifier: "Revision identifier",
    sdsIdentityReasonIssuerProduct: "Issuer and product match",
    sdsIdentityReasonReviewerSearch: "Reviewer search",
    sdsIdentityNewRevisionExplanation:
      "Confirm issuer, safety data sheet, product, and available Revision evidence. Missing values are allowed. This file is appended as a new Revision; the effective Revision stays unchanged. Unsaved form changes are not adopted.",
    sdsIdentityNewRevisionAdded: "New Revision added.",
    sdsIdentityNewRevisionUnresolved: "New Revision was not confirmed.",
    sdsIdentityResolutionDescription:
      "Review the suggested safety data sheets and assign this document. Every assignment is confirmed and can be corrected by authorized reviewers.",
    sdsIdentityResolutionAmbiguous:
      "Conflicting chronology or file equivalence blocks automatic association.",
    sdsIdentityResolutionCandidate: "Candidate",
    sdsIdentityResolutionReasons: "Reasons",
    sdsIdentityResolutionActions: "Actions",
    sdsIdentityResolutionIssuer: "Issuer",
    sdsIdentityResolutionSupplier: "Supplier",
    sdsIdentityResolutionAssociate: "Associate",
    sdsIdentityResolutionEstablish: "Establish identity",
    sdsIdentityResolutionResolved: "SDS assignment saved",
    sdsIdentityResolutionCanonicalDocument: "Assigned safety data sheet",
    sdsIdentityResolutionCanonicalVersion: "Revision",
    sdsIdentityRevisionDate: "Revision date",
    sdsIdentityResolutionReasonIssuerAndRevisionIdentifier:
      "Issuer and revision identifier",
    sdsIdentityResolutionReasonIssuerRevisionDateAndProductName:
      "Issuer, revision date, and product name",
    sdsIdentityResolutionReasonIdenticalFileChecksum: "Identical file checksum",
    sdsIdentityResolutionReasonConflictingChronology: "Conflicting chronology",
    "sdsIdentityBlockingReasonreviewed-issuer-required":
      "Select the issuer to determine available actions.",
    "sdsIdentityBlockingReasonissuer-mismatch":
      "Candidate belongs to another issuer.",
    "sdsIdentityBlockingReasoninsufficient-same-revision-evidence":
      "Evidence is insufficient for same-Revision association.",
    "sdsIdentityBlockingReasonidentical-file":
      "An identical file cannot be added as a new Revision.",
    "sdsIdentityBlockingReasonnot-latest-revision":
      "A new Revision can only follow the latest known Revision.",
    "sdsIdentityBlockingReasonrevision-date-not-later":
      "Revision date is not later than the latest known Revision.",
    "sdsIdentityBlockingReasonrevision-identifier-not-unique":
      "Revision identifier is already used.",
    sdsDocumentCreateIssuer: "Create issuer",
    sdsDocumentConfirmSupplier: "Confirm issuer",
    sdsDocumentCorrectSupplier: "Correct issuer",
    sdsSupplierDecisionunresolved: "Unresolved",
    sdsSupplierDecisionconfirmed: "Confirmed",
    sdsSupplierDecisioncorrected: "Corrected",
    sdsDocumentSupplierConfirmed: "Issuer confirmed.",
    sdsDocumentSupplierCorrected: "Issuer corrected.",
    sdsIssuerCreated: "Issuer created.",
    sdsSupplierCreated: "Supplier created.",
    sdsSupplierEmergencyPhone: "Emergency telephone",
    sdsDocumentCandidates: "Material candidates",
    sdsDocumentCandidatesDescription:
      "Review extraction results and make an explicit decision.",
    sdsDocumentRefreshCandidates: "Refresh Material candidates",
    sdsDocumentMaterial: "Material",
    sdsDocumentMatchScore: "Match score",
    sdsDocumentMatchReasons: "Reasons",
    sdsDocumentReviewedEvidence: "Reviewed evidence",
    sdsDocumentDecision: "Decision",
    sdsCandidateDecisionpending: "Pending",
    sdsCandidateDecisionapproved: "Approved",
    sdsCandidateDecisionrejected: "Rejected",
    sdsDocumentAccept: "Accept",
    sdsDocumentDismiss: "Dismiss",
    sdsDocumentCandidateAccepted: "Material candidate accepted.",
    sdsDocumentCandidateDismissed: "Material candidate dismissed.",
    sdsDocumentLinkedMaterials: "Linked materials",
    sdsDocumentLinkedMaterialsDescription:
      "Associations derived from reviewed Revision decisions. They cannot be edited independently.",
    sdsDocumentLinkMaterial: "Link material",
    sdsDocumentCreateAndLink: "Create and link material",
    sdsDocumentSearchMaterials: "Search materials",
    sdsDocumentSearchByUfi: "Search UFI",
    sdsDocumentUfiSearchPlaceholder: "Enter UFI",
    sdsDocumentUfiSearchNoMatches:
      "No Material matches this UFI. Link a Material manually or create a new one.",
    sdsDocumentUfiSearchOneMatch:
      "One Material found. Explicitly select its UUID-based Material link.",
    sdsDocumentUfiSearchAmbiguous:
      "{count} Materials found. Explicitly select a UUID-based Material link.",
    sdsDocumentMaterialChoice:
      "{materialName} · {materialNumber} · UUID: {materialUuid}",
    sdsDocumentApplicability: "Applicability",
    sdsDocumentApplicable: "Applicable",
    sdsDocumentNotApplicable: "Not applicable",
    sdsDocumentPreferred: "Preferred",
    sdsDocumentPreferredSelected: "Preferred",
    sdsDocumentSelectPreferred: "Select preferred",
    sdsDocumentPreferredSaved: "Preferred SDS version saved.",
    sdsDocumentMaterialLinked: "Material linked.",
    sdsDocumentMaterialCreated: "Material created and linked.",
    sdsDocumentRetryAccepted: "Extraction restarted.",
    sdsDocumentActivityReceived: "SDS document received.",
    sdsMaterialSearchPlaceholder: "Search materials",
    sdsMaterialPrimarySupplier: "Primary supplier",
    sdsMaterialOpenWorkspace: "View SDS",
    sdsMaterialWorkspace: "Material SDS",
    sdsMaterialMasterData: "Material master data",
    sdsMaterialSaved: "Material master data saved.",
    sdsMaterialBackToCatalog: "Back to materials",
    sdsMaterialLinkedDocuments: "Linked SDS documents",
    sdsMaterialLinkedDocumentsDescription:
      "All SDS versions, issuers, and applicability decisions for this material.",
    sdsMaterialNoLinkedDocuments: "No SDS is linked to this material yet.",
    sdsSupplierSearchPlaceholder: "Search suppliers",

    sdsIdentitySourceDocument: "Source document",
    sdsIdentitySourceProduct: "Extracted product",
    sdsIdentitySourceRevision: "Revision",
    sdsIdentityLatestRevision: "Latest revision",
    sdsIdentityCandidateDataUnavailable:
      "Internal candidate data is unavailable. Actions are disabled.",
    sdsIdentitySearchFailed: "Candidate search failed",
    sdsIdentityNoCandidates: "No matching safety data sheets found.",
    sdsIdentityAutomaticSearchScope:
      "Automatic evidence considers checksum, issuer, product, and available revision details. Selected issuer scopes candidates.",
    sdsIdentityManualSearchScope:
      "Manual search covers document name, extracted issuer, and product. Selected issuer scopes candidates.",
    sdsIdentityDecision: "Assignment type",
    sdsIdentityDecisionReviewer: "Reviewer",
    sdsIdentityDecisionTimestamp: "Decided on",
    sdsIdentityDecisionRationale: "Rationale",
    sdsIdentityOptionalComment: "Additional comment (optional)",
    sdsIdentityOptionalCommentHelp:
      "The displayed evidence documents this decision. No additional comment is required.",
    sdsIdentityOptionalCommentPlaceholder:
      "Optional comment about this decision",
    sdsIdentityManualDecisionRationale: "Reason for manual association",
    sdsIdentityManualDecisionRationaleHelp:
      "Briefly explain why this safety data sheet belongs to this target despite using manual search.",
    sdsIdentityManualDecisionRationalePlaceholder:
      "For example: Revision identifier in the document confirms the association.",
    sdsIdentityDecisionHistory: "Decision history",
    sdsIdentityDecisionTarget: "Target",
    sdsIdentityNewIdentityTarget: "New independent SDS identity",
    sdsIdentityCorrectDecision: "Correct assignment",
    sdsIdentityCorrectionHint:
      "If the assignment is incorrect, you can correct it. The previous assignment remains traceable.",
    sdsIdentityReplacementDecision: "Replacement decision",
    sdsIdentityCorrectionRationale: "Correction rationale",
    sdsIdentityCorrectionRationaleHelp:
      "Briefly explain why the previous decision must be replaced. The previous decision remains traceable.",
    sdsIdentityCorrectionRationalePlaceholder:
      "For example: The target revision was assigned incorrectly.",
    sdsIdentityCorrectionUnavailable: "Current decision cannot be corrected.",
    sdsIdentityContinue: "Continue",
    sdsIdentityConfirmDecision: "Confirm decision",
    sdsIdentityDecisionassociate: "Associate with existing revision",
    sdsIdentityDecisionadd_revision: "Add as new revision",
    sdsIdentityDecisionestablish: "Establish new identity",
    sdsIdentityDecisionSummaryassociate: "Same SDS revision",
    sdsIdentityDecisionSummaryadd_revision:
      "New revision of an existing safety data sheet",
    sdsIdentityDecisionSummaryestablish: "Independent safety data sheet",
    sdsIdentityConsequenceassociate:
      "This file will be associated with confirmed same SDS revision.",
    sdsIdentityConsequenceadd_revision:
      "This file will be appended as a new revision to selected safety data sheet.",
    sdsIdentityConsequenceestablish:
      "A new independent SDS identity will be created for this file.",
  },
  es: {
    productComplianceLogo: "AI",
    productComplianceMaterialTimeline: "Cronología",
    productComplianceSdsHubTitle: "Centro de cumplimiento de FDS",
    productComplianceSdsHubSubtitle:
      "Decisiones nativas de IA, trazables y exportables",
    sdsNavOverview: "Resumen",
    sdsNavSuppliers: "Proveedores",
    sdsNavMaterials: "Materiales",
    sdsNavPolicies: "Políticas",
    sdsNavReassessments: "Reevaluaciones",
    sdsReassessmentDocument: "Documento FDS",
    sdsReassessmentPriority: "Prioridad",
    sdsReassessmentStatus: "Estado",
    sdsReassessmentPolicyVersion: "Versión de la política",
    sdsReassessmentControlVersion: "Versión del perfil de control",
    sdsReassessmentCreated: "Creado",
    sdsReassessmentEmpty: "No hay reevaluaciones disponibles.",
    sdsReassessmentPrioritycritical: "Crítica",
    sdsReassessmentPriorityhigh: "Alta",
    sdsReassessmentPrioritynormal: "Normal",
    sdsReassessmentStatusqueued: "En cola",
    sdsReassessmentStatusin_progress: "En curso",
    sdsReassessmentStatuscompleted: "Completado",
    sdsReassessmentStatussuperseded: "Sustituido",
    sdsReassessmentStatusfailed: "Error",
    sdsReassessmentGovernedState: "Estado de gobernanza",
    sdsReassessmentGovernedStatePending: "Reevaluación pendiente",
    sdsReassessmentGovernedStatePendingDescription:
      "Hay una reevaluación abierta con prioridad {priority}. Esta revisión no se muestra como actualmente gobernada.",
    sdsReassessmentGovernedStateStale: "La gobernanza no está actualizada",
    sdsReassessmentGovernedStateStaleDescription:
      "Esta revisión no tiene una gobernanza efectiva actual.",
    sdsReassessmentGovernedStateUnknown: "Se desconoce el estado de gobernanza",
    sdsReassessmentGovernedStateUnknownDescription:
      "La aplicabilidad de la política es ambigua o no está configurada.",
    sdsReassessmentGovernedStateCurrent: "Actualmente bajo gobernanza",
    sdsReassessmentGovernedStateCurrentDescription:
      "Esta revisión tiene una gobernanza efectiva y no hay ninguna reevaluación abierta.",
    sdsNavActions: "Acciones",
    sdsNavComparison: "Comparación",
    sdsNavNewComparison: "Nueva Comparación",
    productComplianceLatency: "Latencia 230ms",
    productComplianceAuditStreamingOn: "Transmisión de auditoría activada",
    productComplianceTabDashboard: "Panel basado en roles",
    productComplianceTabWorkspaceDiff:
      "Comparación inteligente del espacio de trabajo",
    productComplianceTabTimelineEvidence: "Cronología + paquete de evidencias",
    productComplianceTabSitesVariables: "Centros y variables",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Administrador",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "Pendiente de revisión",
    productComplianceDashboardSummaryPendingDescription:
      "Documentos pendientes de validación",
    productComplianceDashboardSummaryOverdue: "Tareas vencidas",
    productComplianceDashboardSummaryOverdueDescription:
      "Acciones asignadas fuera del SLA",
    productComplianceDashboardSummaryReviewTime: "Tiempo medio de revisión",
    productComplianceDashboardSummaryReviewTimeDescription:
      "Durante los últimos 30 días",
    productComplianceDashboardSummaryPrioritization: "Priorización",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Secciones preanalizadas automáticamente",
    productComplianceDashboardLibraryTitle: "Biblioteca de materiales",
    productComplianceDashboardLibrarySubtitle:
      "Búsqueda, riesgo y acceso directo al espacio de trabajo de IA",
    productComplianceDashboardUploadDrop: "Suelte un archivo FDS aquí o",
    productComplianceDashboardUploadBrowse: "haga clic para examinar",
    productComplianceDashboardSearchPlaceholder: "Buscar por material o CAS...",
    productComplianceDashboardColumnMaterial: "Material",
    productComplianceDashboardColumnWorkflow: "Flujo de trabajo",
    productComplianceDashboardColumnRiskScore: "Puntuación de riesgo",
    productComplianceDashboardOpenWorkspace: "Abrir espacio de trabajo de IA",
    productComplianceDashboardWorkspaceNotificationTitle: "Espacio de trabajo",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Abrir espacio de trabajo de IA: {name}",
    productComplianceDashboardUploadComment:
      "Carga de FDS desde el panel de cumplimiento de productos",
    productComplianceDashboardUploadSingleFileWarning:
      "Solo se permite un archivo a la vez ({fileName}).",
    sdsMaterialListKpiAwaitingReview: "Pendiente de revisión",
    sdsMaterialListKpiInProgress: "En curso",
    sdsMaterialListKpiParsingIncomplete: "Análisis incompleto",
    sdsMaterialListFilterAll: "Todos",
    sdsMaterialListFilterPendingReview: "Pendiente de revisión",
    sdsMaterialListFilterInProgress: "En curso",
    sdsMaterialListFilterApproved: "Aprobado",
    sdsMaterialListFilterObsolete: "Obsoleto",
    sdsMaterialListImportSds: "Importar FDS",
    sdsMaterialListReviewSds: "Revisar FDS",
    sdsMaterialListOpenMaterial: "Abrir material",
    sdsMaterialAddButton: "Añadir material",
    sdsMaterialFieldName: "Nombre comercial",
    sdsMaterialFieldNumber: "Código interno",
    sdsMaterialFieldCas: "Número CAS",
    sdsMaterialFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsMaterialFieldUfi: "UFI",
    sdsMaterialFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsMaterialFieldDescription: "Descripción",
    sdsMaterialFieldPrimarySupplier: "Proveedor principal",
    sdsFeatureRequiresBackend:
      "Esta función requiere una actualización del backend y está desactivada actualmente.",
    sdsValidationRequired: "Obligatorio",
    sdsMaterialValidationRequired:
      "Introduzca el nombre comercial y el código interno.",
    sdsMaterialListColumnMaterial: "Material",
    sdsMaterialListColumnSupplier: "Proveedor",
    sdsMaterialListColumnSdsStatus: "Estado de la FDS",
    sdsMaterialListColumnWorkflowStatus: "Estado de revisión",
    sdsMaterialListColumnSections: "Secciones",
    sdsMaterialListColumnLastUpdated: "Última actualización",
    sdsOverviewTitle: "Resumen de cumplimiento",
    sdsOverviewAwaitingReview: "Pendiente de revisión",
    sdsOverviewAwaitingReviewDesc: "Materiales pendientes de aprobación",
    sdsOverviewInProgress: "En curso",
    sdsOverviewInProgressDesc: "Revisiones de cumplimiento activas",
    sdsOverviewOverdue: "Vencido",
    sdsOverviewOverdueDesc: "Materiales con acciones de cumplimiento vencidas",
    sdsOverviewApprovedThisMonth: "Aprobado este mes",
    sdsOverviewApprovedThisMonthDesc: "Materiales aprobados en el mes actual",
    sdsOverviewPriorityQueue: "Materiales que requieren atención",
    sdsOverviewNothingPending: "No hay materiales pendientes.",
    sdsOverviewQuickActions: "Acciones rápidas",
    sdsOverviewExportActions: "Exportar informe de acciones",
    sdsOverviewDaysPending: "Días pendientes",
    sdsOverviewComingSoon: "Próximamente",
    sdsWorkspaceImportNewVersion: "Importar nueva versión",
    sdsWorkspaceViewHistory: "Ver historial",
    sdsWorkspaceCurrentVersion: "Versión actual",
    sdsWorkspaceSectionsDetected: "Secciones detectadas",
    sdsWorkspaceMissingSections: "Secciones faltantes",
    sdsApprovedSourcesTitle: "Fuentes aprobadas",
    sdsApprovedSourcesEmpty: "No hay fuentes aprobadas disponibles.",
    sdsWorkspaceCompareTitle: "Comparar versiones",
    sdsWorkspaceSelectBaseline: "Seleccionar línea base",
    sdsWorkspaceSelectIncoming: "Seleccionar entrante",
    sdsWorkspaceSelectPlaceholder: "Seleccionar versión",
    sdsWorkspaceComparingPreview: "Comparando: {baseline} frente a {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Actualmente solo se muestra la versión más reciente. El historial completo de versiones estará disponible tras una actualización del backend.",
    sdsWorkspaceStartComparison: "Iniciar comparación",
    sdsFactsTitle: "Datos extraídos de la FDS",
    sdsFactsOpen: "Revisar datos",
    sdsFactsBack: "Volver al material",
    sdsFactsStatus: "Estado de extracción: {status}",
    sdsFactsMissingSections: "Secciones faltantes: {sections}",
    sdsFactsDurableNotice:
      "Los cambios se guardan para esta versión y se registran en su trazabilidad de auditoría.",
    sdsFactsLoadFailed: "No se pudieron cargar los datos extraídos de la FDS.",
    sdsFactsLoadFailedDescription:
      "Compruebe la conexión y vuelva a cargar los datos.",
    sdsFactsSection1: "Sección 1 - Identificación",
    sdsFactsSection2: "Sección 2 - Identificación de peligros",
    sdsFactsSection3:
      "Sección 3 - Composición/información sobre los componentes",
    sdsFactsSection8: "Sección 8 - Controles de exposición/protección personal",
    sdsFactsSection14: "Sección 14 - Información sobre transporte",
    sdsFactsSection15: "Sección 15 - Información reglamentaria",
    sdsFactsMaterialName: "Nombre del producto",
    sdsFactsMaterialNumber: "Número de material",
    sdsFactsSupplierName: "Nombre del proveedor",
    sdsFactsHazardClasses: "Clases de peligro",
    sdsFactsHStatements: "Indicaciones de peligro H",
    sdsFactsSignalWord: "Palabra de advertencia",
    sdsFactsSubstances: "Ingredientes",
    sdsFactsAddSubstance: "Añadir ingrediente",
    sdsFactsNoSubstances: "No hay ingredientes registrados.",
    sdsFactsSubstanceName: "Nombre de la sustancia",
    sdsFactsSubstanceCas: "Número CAS",
    sdsFactsConcentrationMin: "Concentración mínima",
    sdsFactsConcentrationMax: "Concentración máxima",
    sdsFactsConcentrationUnit: "Unidad",
    sdsFactsSubstanceConfidence: "Confianza (de 0 a 1)",
    sdsFactsExposureControls: "Controles de exposición",
    sdsFactsPersonalProtection: "Protección personal",
    sdsFactsExposureLimits: "Límites de exposición profesional",
    sdsFactsUnNumber: "Número ONU",
    sdsFactsShippingName: "Designación oficial de transporte",
    sdsFactsTransportClass: "Clase de peligro para el transporte",
    sdsFactsPackingGroup: "Grupo de embalaje",
    sdsFactsNumberInvalid: "{field} debe ser un número.",
    sdsFactsConfidenceInvalid: "La confianza debe estar entre 0 y 1.",
    sdsFactsAuditCount: "{count} cambios manuales registrados",
    sdsFactsDiscard: "Descartar cambios",
    sdsFactsSaved: "Se han guardado los datos de la FDS.",
    sdsWizardBadge: "Asistente",
    sdsWizardStep1Title: "Seleccionar material",
    sdsWizardStep2Title: "Seleccionar versiones",
    sdsWizardStep3Title: "Configurar",
    sdsWizardSelectedMaterial: "Material seleccionado",
    sdsWizardVersionsStubNotice:
      "Solo hay una versión disponible para este material. Importe más versiones o espere a que esté disponible el servicio del historial de versiones.",
    sdsWizardCrossSupplier: "Comparación entre proveedores",
    sdsWizardCrossSupplierDesc:
      "Si se activa, la línea base y la versión entrante pueden proceder de distintos proveedores.",
    sdsWizardNoBaselineOptions: "No hay versiones de línea base disponibles.",
    sdsWizardNoIncomingOptions: "No hay versiones entrantes disponibles.",
    sdsWizardComparisonName: "Nombre de la comparación",
    sdsWizardComparisonNotes: "Notas de la comparación",
    sdsWizardBack: "Volver",
    sdsWizardNext: "Siguiente",
    sdsWizardStartComparison: "Iniciar comparación",
    sdsComparisonToolbarViewSplit: "Vista dividida",
    sdsComparisonToolbarViewUnified: "Vista unificada",
    sdsComparisonToolbarShowChangesOnly: "Mostrar solo los cambios",
    sdsComparisonToolbarJumpSection: "Ir a la sección",
    sdsComparisonDevelopmentModeNotice:
      "Modo de desarrollo: se muestran datos de comparación de ejemplo. Conecte /api/product-compliance/comparisons/:id cuando esté disponible.",
    sdsReportExportComparison: "Exportar informe de comparación de FDS",
    sdsReportBrand: "Cumplimiento de productos SMX",
    sdsReportTitle: "Informe de comparación de FDS",
    sdsReportGeneratedOn: "Generado el",
    sdsReportMaterial: "Material",
    sdsReportBaseline: "Línea base",
    sdsReportIncoming: "Entrante",
    sdsReportBy: "Creado por",
    sdsReportDate: "Fecha de comparación",
    sdsReportExecutiveSummary: "Resumen ejecutivo",
    sdsReportCriticalChanges: "Cambios críticos",
    sdsReportHighChanges: "Cambios de alto impacto",
    sdsReportActionsAssigned: "Acciones asignadas",
    sdsReportSections: "Secciones",
    sdsReportSectionAnalysis: "Análisis de la sección",
    sdsReportNoNote: "No se ha documentado ninguna nota de cumplimiento.",
    sdsReportUnchangedSections: "Secciones sin cambios",
    sdsReportReviewedBy: "Revisado por",
    sdsReportApprovedBy: "Aprobado por",
    sdsReportSignature: "Firma",
    sdsReportEvidenceVersionsTitle: "Todas las versiones de FDS",
    sdsReportEvidenceVersionLabel: "Etiqueta de versión",
    sdsReportEvidenceRevisionDate: "Fecha de revisión",
    sdsReportEvidenceImportDate: "Fecha de importación",
    sdsReportEvidenceWorkflowStatus: "Estado del flujo de trabajo",
    sdsReportEvidenceSectionsDetected: "Secciones detectadas",
    sdsReportEvidenceComparisonsTitle: "Historial de comparaciones",
    sdsReportEvidenceNoComparisons:
      "No hay comparaciones completadas registradas.",
    sdsReportEvidenceOpenActionsTitle: "Resumen de acciones abiertas",
    sdsReportEvidenceActionCount: "Recuento",
    sdsReportEvidenceNoOpenActions: "No hay acciones abiertas registradas.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "No hay contenido disponible",
    sdsComparisonUnchangedHidden: "secciones sin cambios ocultas",
    sdsComparisonShowAllSections: "Mostrar todas",
    sdsComparisonSectionCriticalChange: "Cambio crítico",
    sdsComparisonSectionHighImpact: "Impacto alto",
    sdsComparisonSectionChanged: "Modificado",
    sdsComparisonSectionMinorChange: "Cambio menor",
    sdsComparisonSectionNoChange: "Sin cambios",
    sdsNoteComplianceImpactLabel: "Impacto en el cumplimiento",
    sdsNoteComplianceImpactPlaceholder:
      "Describa el impacto de esta sección en el cumplimiento.",
    sdsNoteRequiredForCritical:
      "Se requiere una nota para los cambios críticos o de alto impacto.",
    sdsNoteChangeSeverityLabel: "Gravedad del cambio",
    sdsNoteChangeSeverityNone: "Ninguna",
    sdsNoteChangeSeverityLow: "Baja",
    sdsNoteChangeSeverityMedium: "Media",
    sdsNoteChangeSeverityHigh: "Alta",
    sdsNoteChangeSeverityCritical: "Crítica",
    sdsNoteAssignedActions: "Acciones asignadas",
    sdsNoteAddAction: "Añadir acción",
    sdsNoteDepartmentLabel: "Departamento",
    sdsNoteActionTypeLabel: "Tipo de acción",
    sdsNoteActionTypeOther: "Otra",
    sdsNoteDueDateLabel: "Fecha de vencimiento",
    sdsDeptPlantSafety: "Seguridad de planta",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Compras",
    sdsDeptQuality: "Calidad",
    sdsDeptLogistics: "Logística",
    sdsDeptWarehouse: "Almacén",
    sdsActionUpdateSops: "Actualizar procedimientos normalizados de trabajo",
    sdsActionUpdateEmergencyProcedures:
      "Actualizar procedimientos de emergencia",
    sdsActionUpdateWorkplaceSignage:
      "Actualizar señalización del lugar de trabajo",
    sdsActionScheduleTraining: "Programar formación",
    sdsActionUpdateRiskAssessment: "Actualizar evaluación de riesgos",
    sdsActionReportToAuthority: "Notificar a la autoridad",
    sdsActionVendorQuery: "Consulta al proveedor",
    sdsActionSupplierQualification: "Cualificación del proveedor",
    sdsActionSourceAlternative: "Buscar un proveedor alternativo",
    sdsActionUpdateSpecification: "Actualizar especificación",
    sdsActionUpdateMaterialDataSheet: "Actualizar ficha de datos del material",
    sdsActionUpdateTransportDoc: "Actualizar documento de transporte",
    sdsActionUpdateHazmatDeclaration:
      "Actualizar declaración de mercancías peligrosas",
    sdsActionUpdateStorageSop: "Actualizar PNT de almacenamiento",
    sdsActionReviewSegregation: "Revisar segregación",
    sdsActionsTitle: "Seguimiento de acciones",
    sdsActionsFilterStatus: "Estado",
    sdsActionsFilterDepartment: "Departamento",
    sdsActionsFilterMaterial: "Buscar material o CAS",
    sdsActionsFilterDueDateFrom: "Fecha de vencimiento desde",
    sdsActionsFilterDueDateTo: "Fecha de vencimiento hasta",
    sdsActionsColumnMaterial: "Material",
    sdsActionsColumnSection: "Sección",
    sdsActionsColumnDepartment: "Departamento",
    sdsActionsColumnAction: "Acción",
    sdsActionsColumnDueDate: "Fecha de vencimiento",
    sdsActionsColumnStatus: "Estado",
    sdsActionsMarkComplete: "Marcar como completada",
    sdsActionsMarkCompleteConfirm: "¿Desea marcar esta acción como completada?",
    sdsActionsMarkedComplete: "Acción marcada como completada",
    sdsActionsStatusOpen: "Abrir",
    sdsActionsStatusInProgress: "En curso",
    sdsActionsStatusCompleted: "Completado",
    sdsActionsStatusOverdue: "Vencido",
    sdsActionsSelected: "seleccionados",
    sdsActionsEmptyState:
      "Aún no hay acciones de cumplimiento. Las acciones se crean al revisar una comparación.",
    sdsActionsBackendNotice:
      "La lista de acciones no tiene datos del backend actualmente. Las entradas aparecerán cuando la integración de la API esté disponible.",
    sdsApproveReviewDecision: "Decisión de revisión",
    sdsApproveDocumentationProgress: "Progreso de documentación",
    sdsApproveBlockedMissingNotes: "Aprobación bloqueada, faltan notas",
    sdsApproveOpenActions: "Acciones abiertas",
    sdsApproveComparisonStarted: "Comparación iniciada",
    sdsApproveBaseline: "Línea base",
    sdsApproveIncoming: "Entrante",
    sdsApproveButton: "Aprobar",
    sdsRejectButton: "Rechazar",
    sdsApproveConfirmMessage: "¿Desea aprobar esta comparación?",
    sdsApproveConfirmMessageDetailed:
      '¿Aprobar "{incoming}" como nueva línea base para "{material}"? La línea base anterior ("{baseline}") se archivará como sustituida.',
    sdsApproveConfirmTitle: "Aprobar comparación",
    sdsApproveSuccess: "Comparación aprobada correctamente",
    sdsRejectReasonPrompt: "Indique un motivo de rechazo",
    sdsRejectTitle: "Rechazar comparación",
    sdsRejectSuccess: "Comparación rechazada",
    productComplianceWorkflowReceived: "Recibido",
    productComplianceWorkflowInProgress: "En curso",
    productComplianceWorkflowApproved: "Aprobado",
    productComplianceWorkflowObsolete: "Obsoleto",
    productComplianceMaterialTimelineSummaryPending: "Pendiente de revisión",
    productComplianceMaterialTimelineSummaryPendingDescription:
      "Versiones pendientes de publicación",
    productComplianceMaterialTimelineSummaryApproved: "Aprobado",
    productComplianceMaterialTimelineSummaryApprovedDescription:
      "Versiones con cumplimiento validado",
    productComplianceMaterialTimelineSummarySuperseded: "Sustituido",
    productComplianceMaterialTimelineSummarySupersededDescription:
      "Versiones conservadas para trazabilidad",
    productComplianceMaterialTimelineSectionTitle: "Cronología completa",
    productComplianceMaterialTimelineSectionSubtitle:
      "Versiones cronológicas de FDS, estado, importaciones y últimos cambios",
    productComplianceMaterialTimelineFamilySearchPlaceholder:
      "Buscar por CAS, proveedor o material...",
    productComplianceMaterialTimelineFamilyMaterial: "Material",
    productComplianceMaterialTimelineFamilySupplier: "Proveedor",
    productComplianceMaterialTimelineFamilyVersions: "Versions",
    productComplianceMaterialTimelineOrderAz: "A-Z",
    productComplianceMaterialTimelineOrderNewest: "Más reciente",
    productComplianceMaterialTimelineOrderOldest: "Menos reciente",
    productComplianceMaterialTimelineSearchPlaceholder:
      "Buscar por versión, proveedor o cambio...",
    productComplianceMaterialTimelineImported: "Importado",
    productComplianceMaterialTimelineLatestChanges: "Últimos cambios",
    productComplianceMaterialTimelineEmpty:
      "No se encontraron entradas en la cronología para la búsqueda actual.",
    productComplianceMaterialTimelineShortcutsTitle: "Accesos directos",
    productComplianceMaterialTimelineShortcutGenealogy:
      "Abrir genealogía recursiva",
    productComplianceMaterialTimelineShortcutEvidence:
      "Generar paquete de evidencias",
    productComplianceMaterialTimelineShortcutLabel: "Imprimir etiqueta SGA",
    productComplianceMaterialTimelineLegendTitle: "Leyenda de estados",
    productComplianceMaterialTimelineCompositionTitle: "Composición",
    productComplianceMaterialTimelineCharacteristicsTitle:
      "Características del material",
    productComplianceMaterialTimelineDocumentSignalsTitle:
      "Indicadores del documento",
    productComplianceMaterialTimelineFieldSupplier: "Proveedor",
    productComplianceMaterialTimelineFieldUfi: "UFI",
    productComplianceMaterialTimelineFieldSubstance: "Sustancia",
    productComplianceMaterialTimelineFieldConcentration: "Concentración",
    productComplianceMaterialTimelineFieldSection3Fuente:
      "Fuente de la sección 3",
    productComplianceMaterialTimelineFieldParsingStatus: "Estado de análisis",
    productComplianceMaterialTimelineFieldSectionsDetected:
      "Secciones detectadas",
    productComplianceMaterialTimelineFieldMissingSections:
      "Secciones faltantes",
    productComplianceMaterialTimelineFieldAcceptability: "Aceptabilidad",
    productComplianceMaterialTimelineFieldAdditional: "Datos adicionales",
    productComplianceMaterialTimelineNotAvailable: "No disponible",
    productComplianceMaterialTimelineAcceptabilityAccepted: "Aceptado",
    productComplianceMaterialTimelineAcceptabilityRejected: "Rechazado",
    productComplianceMaterialTimelineAcceptabilityPending: "Pendiente",
    productComplianceMaterialTimelineSection3SourceHttp: "Extractor API",
    productComplianceMaterialTimelineSection3SourceDeterministic:
      "Análisis determinista",
    productComplianceMaterialTimelineSection3SourceHttpDisabled:
      "Extractor desactivado",
    productComplianceMaterialTimelineParsingComplete: "Completo",
    productComplianceMaterialTimelineParsingIncomplete: "Incompleto",
    productComplianceStatusPendingReview: "Pendiente de revisión",
    productComplianceStatusApproved: "Aprobado",
    productComplianceStatusSuperseded: "Sustituido",
    productComplianceMaterialSodiumHydroxide: "Hidróxido de sodio al 50%",
    productComplianceMaterialSulfuricAcid: "Ácido sulfúrico al 98%",
    productComplianceSupplierChemcorp: "Proveedor: ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Proveedor: GlobalChem Ltd.",
    productComplianceMaterialTimelineChangeSodium20Sección2:
      "Sección 2: pictogramas de corrosión actualizados",
    productComplianceMaterialTimelineChangeSodium20Sección16:
      "Sección 16: referencias del CLP armonizadas",
    productComplianceMaterialTimelineChangeSodium21Sección8:
      "Sección 8: límites de exposición ajustados para la planta de Lyon",
    productComplianceMaterialTimelineChangeSodium21Sección11:
      "Sección 11: redacción toxicológica aclarada",
    productComplianceMaterialTimelineChangeSodium30Sección8:
      "Sección 8: protección personal reforzada; uso obligatorio de pantalla facial",
    productComplianceMaterialTimelineChangeSodium30Sección2:
      "Sección 2: palabra de advertencia cambiada de «Atención» a «Peligro»",
    productComplianceMaterialTimelineChangeSodium30Sección15:
      "Sección 15: referencias reglamentarias completadas",
    productComplianceMaterialTimelineChangeSodium12Sección3:
      "Sección 3: concentración nominal del 49-51 %",
    productComplianceMaterialTimelineChangeSodium12Sección8:
      "Sección 8: equivalencia funcional confirmada",
    productComplianceMaterialTimelineChangeSodium12Sección16:
      "Sección 16: anexo de transporte añadido",
    productComplianceMaterialTimelineChangeSulfuric15Sección8:
      "Sección 8: protección adicional para las manos durante el llenado en caliente",
    productComplianceMaterialTimelineChangeSulfuric15Sección14:
      "Sección 14: clasificación de transporte de la ONU precisada",
    productComplianceMaterialTimelineDeleteVersion: "Eliminar versión",
    productComplianceMaterialTimelineDeleteFamily: "Eliminar familia",
    productComplianceMaterialTimelineDeleteVersionConfirmTitle:
      "Eliminar versión",
    productComplianceMaterialTimelineDeleteVersionConfirmMessage:
      '¿Seguro que desea eliminar la versión "{version}"? Esta acción no se puede deshacer.',
    productComplianceMaterialTimelineDeleteFamilyConfirmTitle:
      "Eliminar familia de documentos",
    productComplianceMaterialTimelineDeleteFamilyConfirmMessage:
      "¿Seguro que desea eliminar esta familia de documentos con sus {count} versiones? Esta acción no se puede deshacer.",
    productComplianceMaterialTimelineDeleteVersionSuccess:
      "Versión eliminada correctamente",
    productComplianceMaterialTimelineDeleteFamilySuccess:
      "Familia de documentos eliminada correctamente ({count} versiones)",
    productComplianceMaterialTimelineDeleteError: "Error al eliminar",
    sdsTimelineBackToWorkspace: "Volver al espacio de trabajo",
    sdsTimelineExportEvidence: "Exportar evidencias",
    sdsTimelineViewComparison: "Ver comparación",
    sdsImportDialogTitle: "Importar FDS",
    sdsImportAsyncDescription:
      "El documento se almacena y se procesa en segundo plano. Puede seguir trabajando.",
    sdsImportFileSize: "Tamaño del archivo",
    sdsImportSelectMaterial: "Material",
    sdsImportSelectMaterialPlaceholder: "Seleccionar un material existente",
    sdsImportGuidance:
      "1. Seleccione o cree un material · 2. Cargue la ficha de datos de seguridad · 3. Siga la extracción en segundo plano",
    sdsImportCreateMaterial: "Crear material nuevo",
    sdsImportCreateMaterialTitle: "Crear material",
    sdsImportCreateMaterialDescription:
      "Tras guardarlo, el nuevo material se seleccionará para esta ficha de datos de seguridad.",
    sdsImportButtonStartExtraction: "Iniciar extracción",
    sdsImportAccepted: "Se ha iniciado la extracción de la FDS.",
    sdsExtractionStatusLabel: "Estado de extracción",
    sdsExtractionStatusextracting: "Extrayendo",
    sdsExtractionStatusready: "Listo",
    sdsExtractionStatusfailed: "Error",
    sdsExtractionStatusstale: "Desactualizado",
    sdsExtractionFailed: "Error al extraer la FDS.",
    sdsExtractionRetry: "Reintentar extracción",
    sdsExtractionRetryAccepted: "Se ha reiniciado la extracción de la FDS.",
    sdsImportStepValidating: "Validando archivo...",
    sdsImportStepExtractingText: "Extrayendo texto...",
    sdsImportStepParsingSections: "Analizando secciones...",
    sdsImportStepExtractingSubstances: "Extrayendo sustancias...",
    sdsImportStepResolvingSupplier: "Resolviendo proveedor...",
    sdsImportStepResolvingMaterial: "Resolviendo material...",
    sdsImportStepComplete: "Extracción completada",
    sdsImportSectionDocument: "Documento",
    sdsImportSectionMaterial: "Material",
    sdsImportSectionSupplier: "Proveedor",
    sdsImportSectionSubstances: "Sustancias",
    sdsImportSectionSections: "Secciones",
    sdsImportSectionComment: "Comentario",
    sdsImportFieldFilename: "Archivo",
    sdsPolicyContext: "Contexto de políticas",
    sdsPolicyJurisdiction: "Jurisdicción",
    sdsPolicyMarkets: "Mercados",
    sdsPolicyProductScopes: "Ámbitos de aplicación del producto",
    sdsPolicyUfiState: "Estado del UFI",
    sdsPolicyUfiStateunknown: "Desconocido",
    sdsPolicyUfiStatepresent: "Presente",
    sdsPolicyUfiStateabsent: "Ausente",
    sdsPolicyUnconfigured: "El contexto de políticas no está configurado",
    sdsPolicyContextReasonufi_state_unknown:
      "El estado del UFI aún no se ha determinado a partir de una extracción completada.",
    sdsPolicyContextReasonno_matching_regulatory_policy:
      "No se encontró ninguna versión de política reglamentaria coincidente.",
    sdsPolicyContextReasonno_matching_organization_control_profile:
      "No se encontró ningún perfil de control de la organización coincidente.",
    sdsPolicyAmbiguous: "El contexto de políticas es ambiguo",
    sdsPolicyAmbiguousDescription:
      "Un administrador de políticas autorizado debe confirmar el par coincidente.",
    sdsPolicyRegulatoryVersion: "Versión de política reglamentaria",
    sdsPolicyControlVersion: "Versión del perfil de control",
    sdsPolicyConfirmationRationale: "Justificación",
    sdsPolicyConfirm: "Confirmar aplicabilidad",
    sdsPolicyStatus: "Estado",
    sdsPolicyConfirmed: "Confirmado",
    sdsPolicyResolved: "Resuelto",
    sdsPolicyConfirmationSaved: "Se confirmó la aplicabilidad de la política.",
    sdsPolicyRegulatoryPolicies: "Políticas reglamentarias",
    sdsPolicyControlProfiles: "Perfiles de control de la organización",
    sdsPolicyVersions: "Versiones",
    sdsPolicyEmpty: "No hay políticas disponibles.",
    sdsPolicyCreateRegulatory: "Crear política reglamentaria",
    sdsPolicyCreateControl: "Crear perfil de control",
    sdsPolicyEffectiveFrom: "Vigente desde",
    sdsPolicyEffectiveUntil: "Vigente hasta",
    sdsPolicyUfiApplicability: "Aplicabilidad del UFI",
    sdsPolicyUfiRequired: "Obligatorio",
    sdsPolicyUfiOptional: "Opcional",
    sdsPolicyUfiNotApplicable: "No aplicable",
    sdsPolicyRuleSubject: "Objeto de la regla",
    sdsPolicyRuleCondition: "Condición de la regla",
    sdsPolicyEvaluationMode: "Método de evaluación",
    sdsPolicyEvaluationModeReviewerAssessed: "Evaluado por un revisor",
    sdsPolicyEvaluationModereviewer_assessed: "Evaluado por un revisor",
    sdsPolicyEvidenceRequirements: "Requisitos de evidencia",
    sdsPolicySeverity: "Gravedad",
    sdsPolicySeverityLow: "Baja",
    sdsPolicySeverityMedium: "Media",
    sdsPolicySeverityHigh: "Alta",
    sdsPolicySeverityCritical: "Crítica",
    sdsPolicyBlockingEffect: "Efecto de bloqueo",
    sdsPolicyBlockingEffectNone: "Ninguno",
    sdsPolicyBlockingEffectAssessment: "Bloquear evaluación",
    sdsPolicyBlockingEffectApproval: "Bloquear aprobación",
    sdsPolicyCitationSource: "Fuente",
    sdsPolicyCitationReference: "Referencia",
    sdsPolicyCitationUrl: "URL de la fuente",
    sdsPolicyControlRequirement: "Requisito de control",
    sdsPolicyRegulatoryRuleId: "ID de regla reglamentaria",
    sdsPolicyControlEffect: "Efecto del control",
    sdsPolicyControlEffectAdditional: "Requisito adicional",
    sdsPolicyControlEffectStrengthen: "Reforzar requisito",
    sdsImportFieldPages: "Páginas",
    sdsImportFieldLanguage: "Idioma",
    sdsImportFieldRevisionDate: "Fecha de revisión",
    sdsImportFieldMaterialName: "Nombre del material",
    sdsImportFieldMaterialNumber: "Número de material",
    sdsImportFieldTradeName: "Nombre comercial",
    sdsImportFieldUfi: "UFI",
    sdsImportConfidence: "Confianza: {value}%",
    sdsImportFieldSupplierName: "Nombre del proveedor",
    sdsImportSupplierNotFound:
      "No se encontró el proveedor en el registro. Puede vincular esta FDS a un proveedor existente o aceptar una entrada nueva.",
    sdsImportMaterialNotFound:
      "No se encontró el material en el catálogo. Puede vincular esta FDS a un material existente o aceptar una entrada nueva.",
    sdsImportLinkExistingSupplier: "Vincular proveedor existente",
    sdsImportLinkExistingMaterial: "Vincular material existente",
    sdsSupplierListTitle: "Proveedores",
    sdsSupplierAddButton: "Añadir proveedor",
    sdsMaterialCreated: "Se ha creado el material.",
    sdsSupplierEmptyState: "No hay proveedores disponibles.",
    sdsSupplierBackendNotice:
      "La gestión de proveedores requiere una actualización del backend; la lista aparecerá cuando esté disponible.",
    sdsSupplierContact: "Contacto",
    sdsSupplierMaterialsCount: "Materiales",
    sdsSupplierSdsDocuments: "Documentos FDS",
    sdsSupplierSdsEmptyState: "No hay documentos FDS disponibles.",
    sdsSupplierFieldName: "Nombre",
    sdsSupplierFieldCode: "Código",
    sdsSupplierFieldCountry: "País",
    sdsSupplierFieldAddress: "Dirección",
    sdsSupplierFieldContactName: "Nombre del contacto",
    sdsSupplierFieldContactEmail: "Correo electrónico del contacto",
    sdsSupplierFieldContact: "Contacto",
    sdsSupplierFieldStatus: "Estado",
    sdsSupplierFieldNotes: "Notas",
    sdsSupplierCodePlaceholder: "Código del proveedor",
    sdsSupplierStatusActive: "Activo",
    sdsSupplierStatusInactive: "Inactivo",
    sdsSupplierStatusUnderReview: "En revisión",
    sdsSupplierSavedSuccess: "Proveedor guardado correctamente.",
    sdsSupplierDetailTitle: "Detalles del proveedor",
    sdsSupplierNotVerified: "No verificado",
    sdsSupplierFormCrudNotice:
      "Para crear y editar proveedores se requiere una actualización del backend. Ya puede rellenar el formulario.",
    sdsImportFieldLongComment: "Nota",
    sdsImportSubstanceName: "Nombre",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Concentración",
    sdsImportSubstanceAdd: "Añadir sustancia",
    sdsImportButtonConfirm: "Confirmar importación",
    sdsImportStatusFound: "Encontrado",
    sdsImportStatusCreated: "Nueva",
    sdsImportStatusNotFound: "No encontrado",
    sdsImportStatusError: "Error",
    sdsImportConfirmSuccess: "Importación confirmada correctamente",
    sdsImportConfirmSuccessWithMaterial:
      "FDS importada correctamente: {material}",
    sdsImportAnalyzing: "Analizando...",
    sdsImportStreamError: "Error durante la extracción",
    sdsImportWarnings: "Advertencias",
    sdsImportPreviewReady: "Vista previa lista: revise los campos y confirme",
    sdsImportNoFile: "No se ha seleccionado ningún archivo",
    sdsImportUfiInvalid:
      "Formato no válido; se esperaba: XXXX-XXXX-XXXX-XXXX (por ejemplo, A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Número CAS no válido; se esperaba XXXXXXX-XX-X con un dígito de control válido",
    sdsNavApplication: "FDS",
    sdsNavDashboard: "Panel",
    sdsNavInbox: "Panel",
    sdsNotAvailable: "No disponible",
    sdsInboxTitle: "Panel",
    sdsInboxUpload: "Cargar FDS",
    sdsInboxSearchPlaceholder: "Buscar documento, producto o proveedor",
    sdsInboxExtractionFilter: "Estado de extracción",
    sdsInboxResolutionFilter: "Estado de resolución",
    sdsInboxSupplierResolutionFilter: "Resolución del emisor",
    sdsInboxMaterialResolutionFilter: "Asignación de material",
    sdsInboxReviewFilter: "Estado de revisión",
    sdsInboxValidityFilter: "Validez",
    sdsInboxSupplierFilter: "Emisor",
    sdsInboxMaterialFilter: "Material",
    sdsInboxAllStates: "Todos los estados",
    sdsInboxDocument: "Documento",
    sdsInboxVersion: "Versión {version}",
    sdsInboxRevisionDate: "Fecha de revisión",
    sdsInboxIdentity: "Identidad extraída",
    sdsInboxIssuer: "Emisor",
    sdsInboxRelatedMaterials: "Materiales relacionados",
    sdsInboxRelatedMaterialsCount: "{count} relacionados",
    sdsInboxExtraction: "Extracción",
    sdsInboxResolution: "Resolución",
    sdsInboxReview: "Estado de revisión",
    sdsInboxValidity: "Validez",
    sdsInboxLastActivity: "Última actividad",
    sdsResolutionStatusunresolved: "Sin resolver",
    sdsResolutionStatusin_progress: "En curso",
    sdsResolutionStatusresolved: "Resuelto",
    sdsSupplierResolutionStatusunresolved: "Emisor sin resolver",
    sdsSupplierResolutionStatusconfirmed: "Emisor confirmado",
    sdsSupplierResolutionStatuscorrected: "Emisor corregido",
    sdsMaterialResolutionStatusunassigned: "Sin material asignado",
    sdsMaterialResolutionStatusambiguous:
      "Decisión sobre el material pendiente",
    sdsMaterialResolutionStatusassigned: "Material asignado",
    sdsValidityStatusvalid: "Válido",
    sdsValidityStatusexpiring: "Próximo a caducar",
    sdsValidityStatusexpired: "Caducado",
    sdsValidityStatusunknown: "Validez desconocida",
    sdsWorkflowreceived: "Recibido",
    sdsWorkflowin_progress: "En curso",
    sdsWorkflowapproved: "Aprobado",
    sdsWorkflowobsolete: "Obsoleto",
    sdsDocumentTitle: "Documento FDS",
    sdsDocumentBackToInbox: "Volver al panel",
    sdsDocumentRetryExtraction: "Reintentar extracción",
    sdsDocumentExtractionFailed: "Error en la extracción",
    sdsDocumentExtractionFailedDescription:
      "No se pudo completar la extracción. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia.",
    sdsDocumentExtractionStale: "La extracción agotó el tiempo de espera",
    sdsDocumentExtractionStaleDescription:
      "La extracción superó el tiempo de espera. Vuelva a intentarlo.",
    sdsDocumentDispatchFailed: "Error al iniciar la extracción",
    sdsDocumentDispatchFailedDescription:
      "No se pudo iniciar la extracción. Vuelva a intentarlo.",
    sdsDocumentExtractionAttempt: "Intento de extracción",
    sdsDocumentExtractionStarted: "Extracción iniciada",
    sdsDocumentExtractionCompleted: "Extracción completada",
    sdsDocumentAttemptCompleted: "Completado el",
    sdsDocumentAttemptExtraction: "Método y flujo de trabajo",
    sdsDocumentAttemptProviderModel: "Proveedor: {provider} · Modelo: {model}",
    sdsDocumentAttemptConfidence: "Confianza: {semantics} · {level}",
    sdsDocumentAttemptProvenance: "Procedencia",
    sdsDocumentAttemptSourceMode: "Fuente: {sourceMode}",
    sdsDocumentAttemptNoSourceReferences:
      "No hay referencias de origen disponibles",
    sdsDocumentAttemptSourcePage: "Página {page}",
    sdsDocumentAttemptSourceSpan: "Página {page}, caracteres {start}–{end}",
    sdsDocumentAttemptCompleteProvenance: "Procedencia completa",
    sdsDocumentAttemptMissingSections: "Secciones faltantes: {sections}",
    sdsDocumentAttemptUnavailableFragments:
      "Fragmentos no disponibles: {count}",
    sdsDocumentAttemptIncompleteTableProvenance:
      "Procedencia de la tabla incompleta",
    sdsDocumentAttemptFailure: "Detalles del error",
    sdsDocumentAttemptFailureCode: "Código: {code}",
    sdsDocumentAttemptFailureField: "Campo: {field}",
    sdsDocumentAttemptFailureReason: "Motivo: {reason}",
    sdsDocumentAttemptGovernance: "Evaluación de extracción",
    sdsDocumentAttemptGovernanceDescription:
      "Evaluación guardada para este intento de extracción. El backend determina si está listo para revisión.",
    sdsDocumentAttemptTextSource: "Origen del texto",
    sdsDocumentAttemptTextSourcenative_text: "Texto incrustado",
    sdsDocumentAttemptTextSourceocr:
      "Reconocimiento óptico de caracteres (OCR)",
    sdsDocumentAttemptLanguage: "Idioma detectado",
    sdsDocumentAttemptLanguageSupportsupported: "Compatible",
    sdsDocumentAttemptLanguageSupportunsupported: "No compatible",
    sdsDocumentAttemptRequiredContent: "Contenido obligatorio",
    sdsDocumentAttemptRequiredContentcomplete: "Completo",
    sdsDocumentAttemptRequiredContentincomplete: "Incompleto",
    sdsDocumentAttemptRequiredContentinvalid: "No válido",
    sdsDocumentAttemptRequiredContentunavailable: "No disponible",
    sdsDocumentAttemptUncertainty: "Incertidumbre",
    sdsDocumentAttemptUncertaintynone: "Ninguna",
    sdsDocumentAttemptUncertaintycontradictory: "Contradictoria",
    sdsDocumentAttemptReviewReadiness: "Preparación para la revisión",
    sdsDocumentAttemptReviewreview_ready: "Listo para revisión",
    sdsDocumentAttemptReviewblocked: "Bloqueado",
    sdsDocumentAttemptMissingFields: "Faltan campos obligatorios",
    sdsDocumentAttemptInvalidFields: "Campos obligatorios no válidos",
    sdsDocumentAttemptRequiredContentIssue: "{field}: {reason}",
    sdsDocumentAttemptContradictions: "Datos contradictorios",
    sdsDocumentAttemptEvidenceIds: "ID de evidencias: {evidenceIds}",
    sdsDocumentAttemptBlockingReasons: "Motivos de bloqueo",
    sdsDocumentAttemptBlockingReasonunsupported_language:
      "Idioma no compatible",
    sdsDocumentAttemptBlockingReasonincomplete_required_content:
      "Contenido obligatorio incompleto",
    sdsDocumentAttemptBlockingReasoninvalid_required_content:
      "Contenido obligatorio no válido",
    sdsDocumentAttemptBlockingReasoncontradictory_evidence:
      "Evidencia contradictoria",
    sdsDocumentAttemptBlockingReasonmalformed_input:
      "Entrada con formato incorrecto",
    sdsDocumentAttemptBlockingReasonterminal_failure: "Error definitivo",
    sdsDocumentFailureRetryable: "Se puede reintentar",
    sdsDocumentFailureNotRetryable: "No se puede reintentar",
    sdsDocumentSelectVersion: "Seleccionar versión",
    sdsDocumentTabDocument: "Documento y versiones",
    sdsDocumentTabExtraction: "Evaluar extracción",
    sdsDocumentTabFacts: "Ficha de datos de seguridad",
    sdsDocumentTabSupplier: "Emisor",
    sdsDocumentTabMaterials: "Materiales aplicables",
    sdsDocumentTabEvidence: "Evidencia de origen",
    sdsDocumentTabAssessment: "Evaluación bajo gobernanza",
    sdsDocumentTabActivity: "Actividad",
    sdsRevisionComparisonTitle: "Comparación de revisiones",
    sdsRevisionComparisonDescription:
      "Compare esta revisión con la revisión efectiva actual de la misma ficha de datos de seguridad.",
    sdsRevisionComparisonCreate: "Crear comparación",
    sdsRevisionComparisonRefresh: "Actualizar comparación",
    sdsRevisionComparisonBaseline: "Revisión de línea base efectiva",
    sdsRevisionComparisonCandidate: "Revisión candidata",
    sdsRevisionComparisonCreated: "Creado el",
    sdsRevisionComparisonDigest: "Resumen de la comparación",
    sdsRevisionComparisonBaselineSnapshotId: "ID de instantánea de línea base",
    sdsRevisionComparisonCandidateSnapshotId: "ID de instantánea candidata",
    sdsRevisionComparisonBaselineInputDigest:
      "Resumen de entrada de línea base",
    sdsRevisionComparisonCandidateInputDigest: "Resumen de entrada candidata",
    sdsRevisionComparisonCategory: "Categoría",
    sdsRevisionComparisonAllCategories: "Todas las categorías",
    sdsRevisionComparisonFactPath: "Ruta del dato",
    sdsRevisionComparisonSection: "Sección",
    sdsRevisionComparisonApplyFilters: "Aplicar filtros",
    sdsRevisionComparisonPosition: "Posición",
    sdsRevisionComparisonFactAbsent: "Dato ausente",
    sdsRevisionComparisonNoDifferences:
      "Ningún dato coincide con los filtros seleccionados.",
    sdsRevisionComparisonNoSection: "Sin sección",
    sdsRevisionComparisonSectionNumber: "Sección {section}",
    sdsRevisionComparisonCategoryadded: "Añadido",
    sdsRevisionComparisonCategoryremoved: "Eliminado",
    sdsRevisionComparisonCategorychanged: "Modificado",
    sdsRevisionComparisonCategoryunchanged: "Sin cambios",
    sdsRevisionComparisonCategoryunknown: "Desconocido",
    sdsRevisionComparisonCategorycontradictory: "Contradictorio",
    sdsRevisionComparisonEvidenceTitle: "Evidencia de origen vinculada",
    sdsRevisionComparisonEvidenceRelation: "Relación de evidencia",
    sdsRevisionComparisonEvidenceUnavailable:
      "La evidencia de origen fijada no está disponible.",
    sdsAssessmentBlockingOutcome: "Resultado de bloqueo",
    sdsComplianceActionsTitle: "Acciones de cumplimiento",
    sdsComplianceActionsDescription:
      "Trabajo asignado para atender los hallazgos inmutables de la evaluación.",
    sdsComplianceActionsRefresh: "Actualizar acciones",
    sdsComplianceActionsEmpty: "No hay acciones de cumplimiento.",
    sdsComplianceActionCreate: "Crear acción de cumplimiento",
    sdsComplianceActionFindings: "Hallazgos",
    sdsComplianceActionOwner: "Responsable de la acción",
    sdsComplianceActionNewOwner: "Nuevo responsable de la acción",
    sdsComplianceActionContext: "Contexto de trabajo obligatorio",
    sdsComplianceActionDueAt: "Fecha límite",
    sdsComplianceActionRequired: "Obligatorio",
    sdsComplianceActionBlocking: "Bloqueante",
    sdsComplianceActionRationale: "Justificación",
    sdsComplianceActionStart: "Iniciar trabajo",
    sdsComplianceActionComplete: "Completo",
    sdsComplianceActionReassign: "Reasignar",
    sdsComplianceActionWaive: "Autorizar excepción",
    sdsComplianceActionCancel: "Cancelar",
    sdsComplianceActionDisposition: "Registrar resolución del hallazgo",
    sdsComplianceActionDispositionFinding: "Hallazgo que se resolverá",
    sdsComplianceActionOverdue: "Vencido",
    sdsComplianceActionSaved: "Se guardó la acción de cumplimiento.",
    sdsComplianceActionStatusopen: "Abrir",
    sdsComplianceActionStatusin_progress: "En curso",
    sdsComplianceActionStatuscompleted: "Completado",
    sdsComplianceActionStatuswaived: "Eximido",
    sdsComplianceActionStatuscancelled: "Cancelado",
    sdsAssessmentStatus: "Estado de evaluación",
    sdsAssessmentCreatedAt: "Creado el",
    sdsAssessmentEffectiveFrom: "Vigente desde",
    sdsAssessmentEffectiveTimeZone: "Zona horaria de vigencia",
    sdsAssessmentEffectiveStatus: "Estado de vigencia",
    sdsAssessmentSupersededAt: "Sustituido el",
    sdsAssessmentBaselineAssessment: "Evaluación de línea base",
    sdsAssessmentBaselineRevision: "Revisión de línea base efectiva",
    sdsAssessmentTerminalRationale: "Justificación final",
    sdsAssessmentRegulatoryFindings: "Hallazgos reglamentarios",
    sdsAssessmentOrganizationFindings: "Hallazgos de la organización",
    sdsAssessmentRequirement: "Requisito",
    sdsAssessmentRequirementId: "ID del requisito: {requirementId}",
    sdsAssessmentRequirementVersionId:
      "ID de versión del requisito: {requirementVersionId}",
    sdsAssessmentOutcome: "Resultado",
    sdsAssessmentRationale: "Justificación",
    sdsAssessmentComment: "Comentario",
    sdsAssessmentEvidence: "Evidencia de origen",
    sdsAssessmentEvidenceReference: "Página {page}, párrafo {paragraph}",
    sdsAssessmentEvidenceReferenceId: "Evidencia {evidenceId} ({relation})",
    sdsAssessmentEvaluation: "Evaluación",
    sdsAssessmentReviewedBy: "Revisado por",
    sdsAssessmentCreateDescription:
      "Registre un resultado, una justificación y evidencia de origen para cada requisito reglamentario y de la organización.",
    sdsAssessmentCreate: "Crear evaluación",
    sdsAssessmentCreated: "Evaluación creada.",
    sdsAssessmentDraftDescription:
      "Los borradores de hallazgos se pueden editar hasta que se envíen.",
    sdsAssessmentSaveFindingDrafts: "Guardar borradores de hallazgos",
    sdsAssessmentDraftSaved: "Borradores de hallazgos guardados.",
    sdsAssessmentSubmissionRationale: "Justificación del envío",
    sdsAssessmentSubmit: "Enviar evaluación",
    sdsAssessmentSubmitted: "Evaluación enviada para revisión.",
    sdsAssessmentCancellationRationale: "Justificación de la cancelación",
    sdsAssessmentCancel: "Cancelar evaluación",
    sdsAssessmentCancelled: "Evaluación cancelada.",
    sdsAssessmentRejectionRationale: "Justificación del rechazo",
    sdsAssessmentReject: "Rechazar evaluación",
    sdsAssessmentRejected: "Evaluación rechazada.",
    sdsAssessmentHistory: "Historial de evaluaciones",
    sdsAssessmentKind: "Tipo de evaluación",
    sdsAssessmentKindinitial_baseline: "Línea base inicial",
    sdsAssessmentKindcandidate_revision: "Revisión candidata",
    sdsAssessmentPolicyRequired:
      "La aplicabilidad de la política debe estar resuelta o confirmada.",
    sdsAssessmentReviewerRequired:
      "Se requiere el rol de revisor para crear la evaluación.",
    sdsAssessmentReadyForApproval:
      "Se cumplen todos los hallazgos bloqueantes y la evaluación está lista para su aprobación.",
    sdsAssessmentBlocked:
      "Los hallazgos bloqueantes no satisfechos o desconocidos impiden la aprobación.",
    sdsAssessmentApprovalRationale: "Justificación de la aprobación",
    sdsAssessmentInvalidEffectiveDateTime:
      "La fecha, la hora y la zona horaria IANA deben corresponder a un único instante.",
    sdsAssessmentAcceptedExceptions: "Excepciones aceptadas",
    sdsAssessmentAcceptedExceptionFinding: "Hallazgo de excepción",
    sdsAssessmentAcceptedExceptionRationale: "Justificación de la excepción",
    sdsAssessmentAcceptedAt: "Aceptado el",
    sdsAssessmentAddAcceptedException: "Añadir excepción",
    sdsAssessmentRemoveAcceptedException: "Eliminar excepción",
    sdsAssessmentApprove: "Aprobar vigencia",
    sdsAssessmentApproved: "Revisión efectiva aprobada.",
    sdsAssessmentOutcomesatisfied: "Satisfecho",
    sdsAssessmentOutcomeunsatisfied: "No satisfecho",
    sdsAssessmentOutcomeunknown: "Desconocido",
    sdsAssessmentOutcomenot_applicable: "No aplicable",
    sdsAssessmentStatuspending_approval: "Pendiente de aprobación",
    sdsAssessmentStatusscheduled: "Programado",
    sdsAssessmentStatuseffective: "Vigente",
    sdsAssessmentStatusdraft: "Borrador",
    sdsAssessmentStatusin_review: "En revisión",
    sdsAssessmentStatusawaiting_actions: "A la espera de acciones",
    sdsAssessmentStatusapproved: "Aprobado",
    sdsAssessmentStatuscancelled: "Cancelado",
    sdsAssessmentStatusrejected: "Rechazado",
    sdsAssessmentStatussuperseded: "Sustituido",
    sdsDocumentResolution: "Estado de resolución",
    sdsDocumentIssuer: "Emisor",
    sdsDocumentExtraction: "Estado de extracción",
    sdsDocumentReview: "Estado de revisión",
    sdsDocumentSections: "Secciones detectadas",
    sdsDocumentLastActivity: "Última actividad",
    sdsDocumentReceipts: "Registros de recepción",
    sdsDocumentReceiptFile: "Archivo",
    sdsDocumentReceiptSize: "{size} bytes",
    sdsDocumentReceiptReceivedAt: "Recibido el",
    sdsDocumentReceiptChecksum: "Suma de comprobación SHA-256",
    sdsDocumentAttempts: "Intentos de extracción",
    sdsDocumentAttemptNumber: "Intento",
    sdsDocumentAttemptCreated: "Creado el",
    sdsDocumentVersions: "Versiones",
    sdsDocumentVersion: "Versión {version}",
    sdsDocumentPrintDate: "Fecha de impresión",
    sdsDocumentFactsAwaitingExtraction:
      "Los datos extraídos estarán disponibles cuando finalice la extracción.",
    sdsDocumentProvenance: "Procedencia de los datos",
    sdsDocumentProvenanceDescription:
      "La confianza solo evalúa la calidad de la extracción automática. Es opcional y no indica si se extrajeron datos.",
    sdsDocumentProvenanceField: "Campo",
    sdsDocumentProvenanceSource: "Fuente",
    sdsDocumentProvenanceConfidence: "Confianza de extracción",
    sdsDocumentProvenanceExtractedAt: "Extraído el",
    sdsDocumentProvenanceUpdatedAt: "Actualizado manualmente el",
    sdsDocumentProvenanceConfidenceNotAssessed:
      "No hay una evaluación de confianza disponible",
    sdsDocumentProvenanceNotManuallyUpdated:
      "Aún no se ha actualizado manualmente",
    sdsDocumentProvenanceUnavailable:
      "No hay datos de procedencia disponibles.",
    sdsDocumentProvenanceSourceextracted: "Extraído",
    sdsDocumentProvenanceSourcemanual: "Revisado manualmente",
    sdsFactReviewTitle: "Revisar datos extraídos",
    sdsFactReviewSection: "Sección de la FDS",
    sdsFactReviewDescription:
      "Revise los datos extraídos automáticamente por sección de la FDS. Corrija los valores necesarios en el área siguiente.",
    sdsFactMaintenanceDescription:
      "Los datos se obtuvieron mediante la extracción. Ajuste la información y guarde los cambios.",
    sdsFactReviewProgress: "{reviewed} de {total} datos revisados",
    sdsFactReviewField: "Campo",
    sdsFactReviewValue: "Valor",
    sdsFactReviewCurrentValue: "Interpretación actual",
    sdsFactReviewCertainty: "Integridad",
    sdsFactReviewDecision: "Decisión",
    sdsFactReviewConclusion: "Conclusión",
    sdsFactReviewNoConclusion: "No hay una conclusión canónica",
    sdsFactReviewAccept: "Aceptar",
    sdsFactReviewReject: "Rechazar",
    sdsFactReviewCorrect: "Corregir",
    sdsFactReviewAcknowledgeUnknown: "Reconocer como desconocido",
    sdsFactReviewAcknowledgeContradictory: "Reconocer contradicción",
    sdsFactReviewSubmit: "Guardar decisión",
    sdsFactReviewDialogaccepted: "Aceptar interpretación",
    sdsFactReviewDialogrejected: "Rechazar interpretación",
    sdsFactReviewDialogcorrected: "Corregir interpretación",
    sdsFactReviewDialogacknowledged_unknown: "Reconocer conclusión desconocida",
    sdsFactReviewDialogacknowledged_contradictory:
      "Reconocer conclusión contradictoria",
    sdsFactReviewDecisionpending: "Pendiente",
    sdsFactReviewDecisionaccepted: "Aceptado",
    sdsFactReviewDecisionrejected: "Rechazado",
    sdsFactReviewDecisioncorrected: "Corregido",
    sdsFactReviewDecisionacknowledged_unknown: "Desconocido reconocido",
    sdsFactReviewDecisionacknowledged_contradictory: "Contradicción reconocida",
    sdsFactReviewConclusionknown: "Conocido",
    sdsFactReviewConclusionunknown: "Desconocido",
    sdsFactReviewConclusioncontradictory: "Contradictorio",
    sdsFactReviewCertaintycomplete: "Completo",
    sdsFactReviewCertaintymissing: "Ausente",
    sdsFactReviewCertaintymalformed: "Con formato incorrecto",
    sdsFactReviewCertaintypartial: "Parcial",
    sdsFactReviewCertaintycontradictory: "Contradictoria",
    sdsFactReviewCertaintyunknown_confidence: "Confianza desconocida",
    sdsFactReviewEvidenceTitle: "Evidencia de origen vinculada",
    sdsFactReviewEvidenceDescription:
      "Seleccione al menos un párrafo asociado al intento y su relación.",
    sdsFactReviewEvidenceMissing:
      "La evidencia de origen vinculada no está disponible",
    sdsFactReviewOpenEvidence: "Abrir evidencia de origen",
    sdsFactReviewNoEvidence:
      "No hay evidencia de origen vinculada a este dato.",
    sdsFactReviewNoEvidenceAvailable:
      "No hay evidencia de origen disponible para esta revisión.",
    sdsFactReviewSupporting: "De apoyo",
    sdsFactReviewContradicting: "Contradictoria",
    sdsFactReviewHistoryTitle: "Historial de decisiones",
    sdsFactReviewNoHistory: "No se ha guardado ninguna decisión de revisión.",
    sdsFactReviewPending: "Pendiente",
    sdsFactReviewReviewedBy: "Revisado por {reviewer}",
    sdsFactReviewCorrectionsTitle: "Auditoría de correcciones",
    sdsFactReviewAcknowledgementsTitle: "Conclusiones reconocidas",
    sdsFactReviewPreviousValue: "Valor anterior",
    sdsFactReviewCorrectedValue: "Valor corregido",
    sdsFactReviewReason: "Motivo de la corrección",
    sdsFactReviewConclusionReason: "Justificación de la conclusión",
    sdsFactReviewComment: "Comentario",
    sdsFactReviewSaved: "Decisión de revisión guardada.",
    sdsFactReviewConflictTitle: "El dato se revisó simultáneamente",
    sdsFactReviewConflictMessage:
      "Se volvió a cargar el estado actual. Revise los cambios antes de decidir de nuevo.",
    sdsFactReviewUfiValue: "UFI",
    sdsFactReviewUfiScope: "Ámbito",
    sdsFactReviewUfiScopeValue: "Valor del ámbito",
    sdsFactReviewAddUfi: "Añadir UFI",
    sdsFactReviewUfiScopeproductUuid: "Producto",
    sdsFactReviewUfiScopemixtureUuid: "Mezcla",
    sdsFactReviewUfiScopemarket: "Mercado",
    sdsFactReviewUfiScopelanguage: "Idioma",
    sdsDocumentEvidenceUnavailable:
      "La evidencia de origen estará disponible una vez guardado el resultado de extracción.",
    sdsDocumentEvidenceSource: "Fuente",
    sdsDocumentEvidencePage: "Página {page}",
    sdsDocumentEvidenceLocation: "Sección {section} de la FDS · Página {page}",
    sdsDocumentEvidenceSectionUnknown: "Desconocida",
    sdsDocumentEvidenceHeadingUnknown: "Encabezado no detectado",
    sdsDocumentFocusedEvidence: "Evidencia de origen seleccionada",
    sdsDocumentEvidenceProvenance: "Procedencia de la extracción",
    sdsDocumentEvidenceCreated: "Guardado el",
    sdsDocumentEvidenceContent: "Párrafo",
    sdsDocumentEvidenceSection: "Sección o dato vinculado",
    sdsDocumentEvidenceUnlinked: "No vinculado a ningún dato",
    sdsDocumentExtractedIdentity: "Identidad del producto extraída",
    sdsDocumentProductName: "Nombre del producto",
    sdsDocumentMaterialNumber: "Número de material",
    sdsDocumentUfi: "UFI",
    sdsFactsIssuerName: "Nombre del emisor",
    sdsDocumentExtractedSupplier: "Proveedor extraído",
    sdsFactsSelectIssuer: "Seleccionar emisor",
    sdsFactsSelectSupplier: "Seleccionar proveedor",
    sdsFactsSection1Title: "Sección 1 · Identificación",
    sdsFactsSection1Descripción:
      "Identidad y usos del producto, y datos del emisor que figuran en la ficha de datos de seguridad.",
    sdsFactsRecommendedUses: "Usos recomendados",
    sdsFactsUsesAdvisedAgainst: "Usos desaconsejados",
    sdsFactsSupplierAddress: "Dirección del emisor",
    sdsFactsSupplierEmail: "Correo electrónico del emisor",
    sdsFactsSupplierPhone: "Teléfono del emisor",
    sdsFactsEmergencyPhone: "Teléfono de emergencia",
    sdsFactsSection2Title: "Sección 2 · Identificación de peligros",
    sdsFactsSection2Descripción:
      "Clasificación, elementos de la etiqueta y otros peligros.",
    sdsFactsPictograms: "Pictogramas de peligro",
    sdsFactsPStatements: "Consejos de prudencia P",
    sdsFactsOtherHazards: "Otros peligros",
    sdsFactsSection3Title: "Sección 3 · Composición",
    sdsFactsSection3Descripción:
      "Tipo de sustancia o mezcla e ingredientes relevantes para la clasificación.",
    sdsFactsSubstanceOrMixture: "Sustancia o mezcla",
    sdsFactsAddIngredient: "Añadir ingrediente",
    sdsFactsIngredient: "Ingrediente {number}",
    sdsFactsCasNumber: "N.º CAS",
    sdsFactsEcNumber: "N.º CE",
    sdsFactsClassification: "Clasificación",
    sdsFactsNoIngredients: "No hay ingredientes registrados.",
    sdsFactsSection15Title: "Sección 15 · Información reglamentaria",
    sdsFactsSection15Descripción:
      "Normativa, restricciones y evaluaciones específicas del producto.",
    sdsFactsRegulatoryReferences: "Referencias reglamentarias",
    sdsFactsSevesoCategory: "Categoría SEVESO",
    sdsFactsWaterHazardClass: "Clase de peligro para el agua",
    sdsFactsVocValue: "Valor de COV",
    sdsFactsChemicalSafetyAssessment: "Evaluación de seguridad química",
    sdsFactsRestrictions: "Condiciones de restricción",
    sdsFactsSvhc: "SVHC",
    sdsFactsMicroplastics: "Microplásticos / partículas de polímero sintético",
    sdsDocumentFactsUnavailable: "No hay datos extraídos disponibles.",
    sdsDocumentFactsSaved: "Datos extraídos guardados.",
    sdsDocumentSupplierDecision: "Asignación del emisor",
    sdsDocumentSupplierComment: "Justificación de la asignación",
    sdsDocumentSupplierCommentPlaceholder:
      "Documente el motivo de esta corrección",
    sdsDocumentIssuerResolutionDescription:
      "Confirme el emisor solo después de revisarlo. Corrija la asignación o cree el proveedor que falta.",
    sdsIdentityResolutionTitle: "Asignación de FDS",
    sdsIdentityResolutionDescription:
      "Revise las fichas de datos de seguridad sugeridas y asigne este documento. Cada asignación se confirma y los revisores autorizados pueden corregirla.",
    sdsIdentityResolutionAmbiguous:
      "Las discrepancias cronológicas o la equivalencia de archivos impiden la asociación automática.",
    sdsIdentityResolutionCandidate: "Candidato",
    sdsIdentityResolutionReasons: "Motivos",
    sdsIdentityResolutionActions: "Acciones",
    sdsIdentityResolutionIssuer: "Emisor",
    sdsIdentityResolutionSupplier: "Proveedor",
    sdsIdentityResolutionAssociate: "Asociar",
    sdsIdentityResolutionEstablish: "Establecer identidad",
    sdsIdentityResolutionResolved: "Asignación de FDS guardada",
    sdsIdentityResolutionCanonicalDocument:
      "Ficha de datos de seguridad asignada",
    sdsIdentityResolutionCanonicalVersion: "Revisión",
    sdsIdentityRevisionDate: "Fecha de revisión",
    sdsIdentityResolutionReasonIssuerAndRevisionIdentifier:
      "Emisor e identificador de revisión",
    sdsIdentityResolutionReasonIssuerRevisionDateAndProductName:
      "Emisor, fecha de revisión y nombre del producto",
    sdsIdentityResolutionReasonIdenticalFileChecksum:
      "Suma de comprobación de archivo idéntica",
    sdsIdentityResolutionReasonConflictingChronology:
      "Cronología contradictoria",
    sdsDocumentCreateIssuer: "Crear emisor",
    sdsDocumentConfirmSupplier: "Confirmar emisor",
    sdsDocumentCorrectSupplier: "Corregir emisor",
    sdsSupplierDecisionunresolved: "Sin resolver",
    sdsSupplierDecisionconfirmed: "Confirmado",
    sdsSupplierDecisioncorrected: "Corregido",
    sdsDocumentSupplierConfirmed: "Emisor confirmado.",
    sdsDocumentSupplierCorrected: "Emisor corregido.",
    sdsIssuerCreated: "Emisor creado.",
    sdsSupplierCreated: "Proveedor creado.",
    sdsSupplierEmergencyPhone: "Teléfono de emergencia",
    sdsDocumentCandidates: "Candidatos de material",
    sdsDocumentCandidatesDescription:
      "Revise los resultados de extracción y tome una decisión explícita.",
    sdsDocumentRefreshCandidates: "Actualizar candidatos de material",
    sdsDocumentMaterial: "Material",
    sdsDocumentMatchScore: "Puntuación de coincidencia",
    sdsDocumentMatchReasons: "Motivos",
    sdsDocumentReviewedEvidence: "Evidencia revisada",
    sdsDocumentDecision: "Decisión",
    sdsCandidateDecisionpending: "Pendiente",
    sdsCandidateDecisionapproved: "Aprobado",
    sdsCandidateDecisionrejected: "Rechazado",
    sdsDocumentAccept: "Aceptar",
    sdsDocumentDismiss: "Descartar",
    sdsDocumentCandidateAccepted: "Candidato de material aceptado.",
    sdsDocumentCandidateDismissed: "Candidato de material descartado.",
    sdsDocumentLinkedMaterials: "Materiales vinculados",
    sdsDocumentLinkedMaterialsDescription:
      "Asociaciones derivadas de decisiones de revisión. No se pueden editar por separado.",
    sdsDocumentLinkMaterial: "Vincular material",
    sdsDocumentCreateAndLink: "Crear y vincular material",
    sdsDocumentSearchMaterials: "Buscar materiales",
    sdsDocumentSearchByUfi: "Buscar por UFI",
    sdsDocumentUfiSearchPlaceholder: "Introduzca el UFI",
    sdsDocumentUfiSearchNoMatches:
      "Ningún material coincide con este UFI. Vincule un material manualmente o cree uno nuevo.",
    sdsDocumentUfiSearchOneMatch:
      "Se encontró un material. Seleccione explícitamente su vínculo basado en UUID.",
    sdsDocumentUfiSearchAmbiguous:
      "Se encontraron {count} materiales. Seleccione explícitamente un vínculo basado en UUID.",
    sdsDocumentMaterialChoice:
      "{materialName} · {materialNumber} · UUID: {materialUuid}",
    sdsDocumentApplicability: "Aplicabilidad",
    sdsDocumentApplicable: "Aplicable",
    sdsDocumentNotApplicable: "No aplicable",
    sdsDocumentPreferred: "Preferida",
    sdsDocumentPreferredSelected: "Preferida",
    sdsDocumentSelectPreferred: "Seleccionar preferida",
    sdsDocumentPreferredSaved: "Versión preferida de la FDS guardada.",
    sdsDocumentMaterialLinked: "Material vinculado.",
    sdsDocumentMaterialCreated: "Material creado y vinculado.",
    sdsDocumentRetryAccepted: "Extracción reiniciada.",
    sdsDocumentActivityReceived: "Documento FDS recibido.",
    sdsMaterialSearchPlaceholder: "Buscar materiales",
    sdsMaterialPrimarySupplier: "Proveedor principal",
    sdsMaterialOpenWorkspace: "Ver FDS",
    sdsMaterialWorkspace: "FDS del material",
    sdsMaterialMasterData: "Datos maestros del material",
    sdsMaterialSaved: "Datos maestros del material guardados.",
    sdsMaterialBackToCatalog: "Volver a los materiales",
    sdsMaterialLinkedDocuments: "Documentos FDS vinculados",
    sdsMaterialLinkedDocumentsDescription:
      "Todas las versiones de FDS, los emisores y las decisiones de aplicabilidad de este material.",
    sdsMaterialNoLinkedDocuments:
      "Todavía no hay ninguna FDS vinculada a este material.",
    sdsSupplierSearchPlaceholder: "Buscar proveedores",

    sdsIdentitySourceDocument: "Documento de origen",
    sdsIdentitySourceProduct: "Producto extraído",
    sdsIdentitySourceRevision: "Revisión",
    sdsIdentityLatestRevision: "Última revisión",
    sdsIdentityCandidateDataUnavailable:
      "Los datos internos del candidato no están disponibles. Las acciones están desactivadas.",
    sdsIdentitySearchFailed: "Falló la búsqueda de candidatos",
    sdsIdentityNoCandidates:
      "No se encontraron fichas de datos de seguridad coincidentes.",
    sdsIdentityAutomaticSearchScope:
      "La comprobación automática considera suma de verificación, emisor, producto y datos de revisión disponibles. El emisor seleccionado delimita los candidatos.",
    sdsIdentityManualSearchScope:
      "La búsqueda manual cubre nombre del documento, emisor extraído y producto. El emisor seleccionado delimita los candidatos.",
    sdsIdentityDecision: "Tipo de asignación",
    sdsIdentityDecisionReviewer: "Revisor",
    sdsIdentityDecisionTimestamp: "Decidido el",
    sdsIdentityDecisionRationale: "Justificación",
    sdsIdentityOptionalComment: "Comentario adicional (opcional)",
    sdsIdentityOptionalCommentHelp:
      "La evidencia mostrada documenta esta decisión. No se requiere ningún comentario adicional.",
    sdsIdentityOptionalCommentPlaceholder:
      "Comentario opcional sobre esta decisión",
    sdsIdentityManualDecisionRationale: "Motivo de la asociación manual",
    sdsIdentityManualDecisionRationaleHelp:
      "Explique brevemente por qué esta ficha de datos de seguridad pertenece a este destino pese a la búsqueda manual.",
    sdsIdentityManualDecisionRationalePlaceholder:
      "Por ejemplo: el identificador de revisión del documento confirma la asociación.",
    sdsIdentityDecisionHistory: "Historial de decisiones",
    sdsIdentityDecisionTarget: "Destino",
    sdsIdentityNewIdentityTarget: "Nueva identidad de FDS independiente",
    sdsIdentityCorrectDecision: "Corregir asignación",
    sdsIdentityCorrectionHint:
      "Si la asignación es incorrecta, puede corregirla. La asignación anterior permanece trazable.",
    sdsIdentityReplacementDecision: "Decisión de sustitución",
    sdsIdentityCorrectionRationale: "Justificación de corrección",
    sdsIdentityCorrectionRationaleHelp:
      "Explique brevemente por qué debe sustituirse la decisión anterior. La decisión anterior seguirá siendo trazable.",
    sdsIdentityCorrectionRationalePlaceholder:
      "Por ejemplo: la revisión de destino se asignó incorrectamente.",
    sdsIdentityCorrectionUnavailable:
      "La decisión actual no se puede corregir.",
    sdsIdentityContinue: "Continuar",
    sdsIdentityConfirmDecision: "Confirmar decisión",
    sdsIdentityDecisionassociate: "Asociar con revisión existente",
    sdsIdentityDecisionadd_revision: "Añadir como nueva revisión",
    sdsIdentityDecisionestablish: "Establecer nueva identidad",
    sdsIdentityDecisionSummaryassociate: "Misma revisión de FDS",
    sdsIdentityDecisionSummaryadd_revision:
      "Nueva revisión de una ficha de datos de seguridad existente",
    sdsIdentityDecisionSummaryestablish:
      "Ficha de datos de seguridad independiente",
    sdsIdentityConsequenceassociate:
      "Este archivo se asociará con la misma revisión de FDS confirmada.",
    sdsIdentityConsequenceadd_revision:
      "Este archivo se añadirá como nueva revisión a la ficha de datos de seguridad seleccionada.",
    sdsIdentityConsequenceestablish:
      "Se creará una nueva identidad de FDS independiente para este archivo.",
  },
  fr: {
    productComplianceLogo: "AI",
    productComplianceMaterialTimeline: "Timeline",
    productComplianceSdsHubTitle: "SDS Compliance Hub",
    productComplianceSdsHubSubtitle:
      "Decisions assistees par l'IA, tracables et exportables",
    sdsNavOverview: "Apercu",
    sdsNavSuppliers: "Fournisseurs",
    sdsNavMaterials: "Matériaux",
    sdsNavPolicies: "Politiques",
    sdsNavReassessments: "Réévaluations",
    sdsReassessmentDocument: "Document FDS",
    sdsReassessmentPriority: "Priorité",
    sdsReassessmentStatus: "Statut",
    sdsReassessmentPolicyVersion: "Version de politique",
    sdsReassessmentControlVersion: "Version de profil de contrôle",
    sdsReassessmentCreated: "Créé",
    sdsReassessmentEmpty: "Aucune réévaluation disponible.",
    sdsReassessmentPrioritycritical: "Critique",
    sdsReassessmentPriorityhigh: "Élevée",
    sdsReassessmentPrioritynormal: "Normale",
    sdsReassessmentStatusqueued: "En attente",
    sdsReassessmentStatusin_progress: "En cours",
    sdsReassessmentStatuscompleted: "Terminée",
    sdsReassessmentStatussuperseded: "Remplacée",
    sdsReassessmentStatusfailed: "Échouée",
    sdsReassessmentGovernedState: "État de gouvernance",
    sdsReassessmentGovernedStatePending: "Réévaluation en attente",
    sdsReassessmentGovernedStatePendingDescription:
      "Une réévaluation de priorité {priority} est ouverte. Cette révision n’est pas présentée comme actuellement gouvernée.",
    sdsReassessmentGovernedStateStale: "Gouvernance non à jour",
    sdsReassessmentGovernedStateStaleDescription:
      "Cette révision ne dispose pas d’une gouvernance effective actuelle.",
    sdsReassessmentGovernedStateUnknown: "Gouvernance inconnue",
    sdsReassessmentGovernedStateUnknownDescription:
      "L’applicabilité de la politique est ambiguë ou non configurée.",
    sdsReassessmentGovernedStateCurrent: "Actuellement gouvernée",
    sdsReassessmentGovernedStateCurrentDescription:
      "Cette révision dispose d’une gouvernance effective et d’aucune réévaluation ouverte.",
    sdsNavActions: "Actions",
    sdsNavComparison: "Comparaison",
    sdsNavNewComparison: "Nouvelle comparaison",
    productComplianceLatency: "Latence 230ms",
    productComplianceAuditStreamingOn: "Audit streaming actif",
    productComplianceTabDashboard: "Tableau de bord par rôle",
    productComplianceTabWorkspaceDiff:
      "Diff intelligent de l'espace de travail",
    productComplianceTabTimelineEvidence: "Timeline + dossier de preuves",
    productComplianceTabSitesVariables: "Sites & variables",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Admin",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "En attente de révision",
    productComplianceDashboardSummaryPendingDescription:
      "Documents en attente de validation",
    productComplianceDashboardSummaryOverdue: "Tâches en retard",
    productComplianceDashboardSummaryOverdueDescription:
      "Actions assignees hors SLA",
    productComplianceDashboardSummaryReviewTime: "Temps moyen de révision",
    productComplianceDashboardSummaryReviewTimeDescription:
      "Sur les 30 derniers jours",
    productComplianceDashboardSummaryPrioritization: "Priorisation",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Sections pre-analysees automatiquement",
    productComplianceDashboardLibraryTitle: "Bibliothèque de matériaux",
    productComplianceDashboardLibrarySubtitle:
      "Recherche, risque et acces direct a l'espace IA",
    productComplianceDashboardUploadDrop: "Déposez un fichier SDS ici ou",
    productComplianceDashboardUploadBrowse: "cliquez pour parcourir",
    productComplianceDashboardSearchPlaceholder:
      "Rechercher par materiau ou CAS...",
    productComplianceDashboardColumnMaterial: "Matériau",
    productComplianceDashboardColumnWorkflow: "Workflow",
    productComplianceDashboardColumnRiskScore: "Score de risque",
    productComplianceDashboardOpenWorkspace: "Ouvrir l'espace IA",
    productComplianceDashboardWorkspaceNotificationTitle: "Espace de travail",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Ouvrir l'espace IA : {name}",
    productComplianceDashboardUploadComment:
      "Televersement SDS depuis le tableau de bord Product Compliance",
    productComplianceDashboardUploadSingleFileWarning:
      "Un seul fichier a la fois est autorise ({fileName}).",
    sdsMaterialListKpiAwaitingReview: "En attente de revision",
    sdsMaterialListKpiInProgress: "En cours",
    sdsMaterialListKpiParsingIncomplete: "Parsing incomplet",
    sdsMaterialListFilterAll: "Tous",
    sdsMaterialListFilterPendingReview: "En attente",
    sdsMaterialListFilterInProgress: "En cours",
    sdsMaterialListFilterApproved: "Approuve",
    sdsMaterialListFilterObsolete: "Obsolete",
    sdsMaterialListImportSds: "Importer SDS",
    sdsMaterialListReviewSds: "Verifier SDS",
    sdsMaterialListOpenMaterial: "Ouvrir le matériau",
    sdsMaterialAddButton: "Ajouter un matériau",
    sdsMaterialFieldName: "Nom commercial",
    sdsMaterialFieldNumber: "Code interne",
    sdsMaterialFieldCas: "Numero CAS",
    sdsMaterialFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsMaterialFieldUfi: "UFI",
    sdsMaterialFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsMaterialFieldDescription: "Description",
    sdsMaterialFieldPrimarySupplier: "Fournisseur principal",
    sdsFeatureRequiresBackend:
      "Cette fonctionnalite necessite une mise a jour backend et est desactivee.",
    sdsValidationRequired: "Champ obligatoire",
    sdsMaterialValidationRequired:
      "Renseignez le nom commercial et le code interne.",
    sdsMaterialListColumnMaterial: "Matériau",
    sdsMaterialListColumnSupplier: "Fournisseur",
    sdsMaterialListColumnSdsStatus: "Statut SDS",
    sdsMaterialListColumnWorkflowStatus: "État de révision",
    sdsMaterialListColumnSections: "Sections",
    sdsMaterialListColumnLastUpdated: "Derniere mise a jour",
    sdsOverviewTitle: "Apercu conformite",
    sdsOverviewAwaitingReview: "En attente de revision",
    sdsOverviewAwaitingReviewDesc: "Matériaux en attente de validation",
    sdsOverviewInProgress: "En cours",
    sdsOverviewInProgressDesc: "Revisions de conformite actives",
    sdsOverviewOverdue: "En retard",
    sdsOverviewOverdueDesc: "Matériaux avec actions de conformite en retard",
    sdsOverviewApprovedThisMonth: "Approuves ce mois",
    sdsOverviewApprovedThisMonthDesc:
      "Matériaux approuves pendant le mois en cours",
    sdsOverviewPriorityQueue: "Matériaux necessitant une attention",
    sdsOverviewNothingPending: "Aucun matériau en attente.",
    sdsOverviewQuickActions: "Actions rapides",
    sdsOverviewExportActions: "Exporter le rapport d'actions",
    sdsOverviewDaysPending: "Jours en attente",
    sdsOverviewComingSoon: "Bientot disponible",
    sdsWorkspaceImportNewVersion: "Importer une nouvelle version",
    sdsWorkspaceViewHistory: "Voir l'historique",
    sdsWorkspaceCurrentVersion: "Version actuelle",
    sdsWorkspaceSectionsDetected: "Sections detectees",
    sdsWorkspaceMissingSections: "Sections manquantes",
    sdsApprovedSourcesTitle: "Sources approuvees",
    sdsApprovedSourcesEmpty: "Aucune source approuvee disponible.",
    sdsWorkspaceCompareTitle: "Comparer les versions",
    sdsWorkspaceSelectBaseline: "Selectionner la baseline",
    sdsWorkspaceSelectIncoming: "Selectionner l'entrante",
    sdsWorkspaceSelectPlaceholder: "Selectionner une version",
    sdsWorkspaceComparingPreview: "Comparaison : {baseline} vs {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Seule la version la plus recente est affichee actuellement. L'historique complet sera disponible apres une mise a jour backend.",
    sdsWorkspaceStartComparison: "Demarrer la comparaison",
    sdsFactsTitle: "Données FDS extraites",
    sdsFactsOpen: "Vérifier les données",
    sdsFactsBack: "Retour au matériau",
    sdsFactsStatus: "État de l'extraction : {status}",
    sdsFactsMissingSections: "Sections manquantes : {sections}",
    sdsFactsDurableNotice:
      "Les modifications sont enregistrées pour cette version et tracées dans son audit.",
    sdsFactsLoadFailed: "Les données FDS extraites n'ont pas pu être chargées.",
    sdsFactsLoadFailedDescription:
      "Vérifiez la connexion et rechargez les données.",
    sdsFactsSection1: "Section 1 - Identification",
    sdsFactsSection2: "Section 2 - Identification des dangers",
    sdsFactsSection3: "Section 3 - Composition/informations sur les composants",
    sdsFactsSection8:
      "Section 8 - Contrôles de l'exposition/protection individuelle",
    sdsFactsSection14: "Section 14 - Informations relatives au transport",
    sdsFactsSection15: "Section 15 - Informations réglementaires",
    sdsFactsMaterialName: "Nom du produit",
    sdsFactsMaterialNumber: "Numéro de matériau",
    sdsFactsSupplierName: "Nom du fournisseur",
    sdsFactsHazardClasses: "Classes de danger",
    sdsFactsHStatements: "Mentions H",
    sdsFactsSignalWord: "Mention d'avertissement",
    sdsFactsSubstances: "Composants",
    sdsFactsAddSubstance: "Ajouter un composant",
    sdsFactsNoSubstances: "Aucun composant enregistré.",
    sdsFactsSubstanceName: "Nom de la substance",
    sdsFactsSubstanceCas: "Numéro CAS",
    sdsFactsConcentrationMin: "Concentration minimale",
    sdsFactsConcentrationMax: "Concentration maximale",
    sdsFactsConcentrationUnit: "Unité",
    sdsFactsSubstanceConfidence: "Confiance (0 à 1)",
    sdsFactsExposureControls: "Contrôles de l'exposition",
    sdsFactsPersonalProtection: "Protection individuelle",
    sdsFactsExposureLimits: "Valeurs limites d'exposition professionnelle",
    sdsFactsUnNumber: "Numéro ONU",
    sdsFactsShippingName: "Désignation officielle de transport",
    sdsFactsTransportClass: "Classe de danger pour le transport",
    sdsFactsPackingGroup: "Groupe d'emballage",
    sdsFactsNumberInvalid: "{field} doit être un nombre.",
    sdsFactsConfidenceInvalid: "La confiance doit être comprise entre 0 et 1.",
    sdsFactsAuditCount: "{count} modifications manuelles enregistrées",
    sdsFactsDiscard: "Annuler les modifications",
    sdsFactsSaved: "Les données FDS ont été enregistrées.",
    sdsWizardBadge: "Assistant",
    sdsWizardStep1Title: "Selectionner un matériau",
    sdsWizardStep2Title: "Selectionner les versions",
    sdsWizardStep3Title: "Configurer",
    sdsWizardSelectedMaterial: "Matériau selectionne",
    sdsWizardVersionsStubNotice:
      "Une seule version est disponible pour ce matériau. Importez d'autres versions ou attendez le point d'acces de l'historique des versions.",
    sdsWizardCrossSupplier: "Comparaison inter-fournisseurs",
    sdsWizardCrossSupplierDesc:
      "Si active, la baseline et l'entrante peuvent provenir de fournisseurs differents.",
    sdsWizardNoBaselineOptions: "Aucune version baseline disponible.",
    sdsWizardNoIncomingOptions: "Aucune version entrante disponible.",
    sdsWizardComparisonName: "Nom de la comparaison",
    sdsWizardComparisonNotes: "Notes de comparaison",
    sdsWizardBack: "Retour",
    sdsWizardNext: "Suivant",
    sdsWizardStartComparison: "Demarrer la comparaison",
    sdsComparisonToolbarViewSplit: "Split",
    sdsComparisonToolbarViewUnified: "Unifie",
    sdsComparisonToolbarShowChangesOnly: "Afficher uniquement les changements",
    sdsComparisonToolbarJumpSection: "Aller a la section",
    sdsComparisonDevelopmentModeNotice:
      "Mode developpement : affichage de donnees de comparaison mock. Connectez /api/product-compliance/comparisons/:id lorsqu'il sera disponible.",
    sdsReportExportComparison: "Exporter le rapport de comparaison SDS",
    sdsReportBrand: "SMX Product Compliance",
    sdsReportTitle: "Rapport de comparaison SDS",
    sdsReportGeneratedOn: "Genere le",
    sdsReportMaterial: "Matériau",
    sdsReportBaseline: "Baseline",
    sdsReportIncoming: "Entrante",
    sdsReportBy: "Cree par",
    sdsReportDate: "Date de comparaison",
    sdsReportExecutiveSummary: "Resume executif",
    sdsReportCriticalChanges: "Changements critiques",
    sdsReportHighChanges: "Changements eleves",
    sdsReportActionsAssigned: "Actions assignees",
    sdsReportSections: "sections",
    sdsReportSectionAnalysis: "Analyse par section",
    sdsReportNoNote: "Aucune note de conformite documentee.",
    sdsReportUnchangedSections: "Sections inchangees",
    sdsReportReviewedBy: "Relu par",
    sdsReportApprovedBy: "Approuve par",
    sdsReportSignature: "Signature",
    sdsReportEvidenceVersionsTitle: "Toutes les versions SDS",
    sdsReportEvidenceVersionLabel: "Libelle de version",
    sdsReportEvidenceRevisionDate: "Date de revision",
    sdsReportEvidenceImportDate: "Date d'import",
    sdsReportEvidenceWorkflowStatus: "Statut du workflow",
    sdsReportEvidenceSectionsDetected: "Sections detectees",
    sdsReportEvidenceComparisonsTitle: "Historique des comparaisons",
    sdsReportEvidenceNoComparisons: "Aucune comparaison finalisee enregistree.",
    sdsReportEvidenceOpenActionsTitle: "Resume des actions ouvertes",
    sdsReportEvidenceActionCount: "Nombre",
    sdsReportEvidenceNoOpenActions: "Aucune action ouverte enregistree.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "Aucun contenu disponible",
    sdsComparisonUnchangedHidden: "sections inchangees masquees",
    sdsComparisonShowAllSections: "Tout afficher",
    sdsComparisonSectionCriticalChange: "Changement critique",
    sdsComparisonSectionHighImpact: "Impact eleve",
    sdsComparisonSectionChanged: "Change",
    sdsComparisonSectionMinorChange: "Changement mineur",
    sdsComparisonSectionNoChange: "Aucun changement",
    sdsNoteComplianceImpactLabel: "Impact conformite",
    sdsNoteComplianceImpactPlaceholder:
      "Decrivez l'impact conformite pour cette section.",
    sdsNoteRequiredForCritical:
      "Une note est obligatoire pour les changements critiques/importants.",
    sdsNoteChangeSeverityLabel: "Severite du changement",
    sdsNoteChangeSeverityNone: "Aucune",
    sdsNoteChangeSeverityLow: "Faible",
    sdsNoteChangeSeverityMedium: "Moyenne",
    sdsNoteChangeSeverityHigh: "Elevee",
    sdsNoteChangeSeverityCritical: "Critique",
    sdsNoteAssignedActions: "Actions assignees",
    sdsNoteAddAction: "Ajouter une action",
    sdsNoteDepartmentLabel: "Departement",
    sdsNoteActionTypeLabel: "Type d'action",
    sdsNoteActionTypeOther: "Autre",
    sdsNoteDueDateLabel: "Date d'echeance",
    sdsDeptPlantSafety: "Securite usine",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Achats",
    sdsDeptQuality: "Qualite",
    sdsDeptLogistics: "Logistique",
    sdsDeptWarehouse: "Entrepot",
    sdsActionUpdateSops: "Mettre a jour les SOP",
    sdsActionUpdateEmergencyProcedures:
      "Mettre a jour les procedures d'urgence",
    sdsActionUpdateWorkplaceSignage: "Mettre a jour la signalisation de poste",
    sdsActionScheduleTraining: "Planifier une formation",
    sdsActionUpdateRiskAssessment: "Mettre a jour l'evaluation des risques",
    sdsActionReportToAuthority: "Notifier l'autorite",
    sdsActionVendorQuery: "Question au fournisseur",
    sdsActionSupplierQualification: "Qualification fournisseur",
    sdsActionSourceAlternative: "Sourcer une alternative",
    sdsActionUpdateSpecification: "Mettre a jour la specification",
    sdsActionUpdateMaterialDataSheet: "Mettre a jour la fiche matériau",
    sdsActionUpdateTransportDoc: "Mettre a jour le document transport",
    sdsActionUpdateHazmatDeclaration:
      "Mettre a jour la declaration matieres dangereuses",
    sdsActionUpdateStorageSop: "Mettre a jour la SOP de stockage",
    sdsActionReviewSegregation: "Revoir la segregation",
    sdsActionsTitle: "Suivi des actions",
    sdsActionsFilterStatus: "Statut",
    sdsActionsFilterDepartment: "Departement",
    sdsActionsFilterMaterial: "Rechercher matériau ou CAS",
    sdsActionsFilterDueDateFrom: "Echeance de",
    sdsActionsFilterDueDateTo: "Echeance a",
    sdsActionsColumnMaterial: "Matériau",
    sdsActionsColumnSection: "Section",
    sdsActionsColumnDepartment: "Departement",
    sdsActionsColumnAction: "Action",
    sdsActionsColumnDueDate: "Echeance",
    sdsActionsColumnStatus: "Statut",
    sdsActionsMarkComplete: "Marquer comme termine",
    sdsActionsMarkCompleteConfirm:
      "Voulez-vous marquer cette action comme terminee ?",
    sdsActionsMarkedComplete: "Action marquee comme terminee",
    sdsActionsStatusOpen: "Ouverte",
    sdsActionsStatusInProgress: "En cours",
    sdsActionsStatusCompleted: "Terminee",
    sdsActionsStatusOverdue: "En retard",
    sdsActionsSelected: "selectionnees",
    sdsActionsEmptyState:
      "Aucune action de conformite pour l'instant. Les actions sont creees lors de la revue d'une comparaison.",
    sdsActionsBackendNotice:
      "La liste d'actions ne contient actuellement aucune donnee backend. Les entrees apparaitront une fois l'integration API disponible.",
    sdsApproveReviewDecision: "Revue et decision",
    sdsApproveDocumentationProgress: "Progression de la documentation",
    sdsApproveBlockedMissingNotes: "Validation bloquee, notes manquantes",
    sdsApproveOpenActions: "Actions ouvertes",
    sdsApproveComparisonStarted: "Comparaison demarree",
    sdsApproveBaseline: "Baseline",
    sdsApproveIncoming: "Entrante",
    sdsApproveButton: "Approuver",
    sdsRejectButton: "Rejeter",
    sdsApproveConfirmMessage: "Voulez-vous approuver cette comparaison ?",
    sdsApproveConfirmMessageDetailed:
      'Approuver "{incoming}" comme nouvelle baseline pour "{material}" ? La baseline precedente ("{baseline}") sera archivee comme remplacee.',
    sdsApproveConfirmTitle: "Approuver la comparaison",
    sdsApproveSuccess: "Comparaison approuvee avec succes",
    sdsRejectReasonPrompt: "Veuillez saisir un motif de rejet",
    sdsRejectTitle: "Rejeter la comparaison",
    sdsRejectSuccess: "Comparaison rejetee",
    productComplianceWorkflowReceived: "Recu",
    productComplianceWorkflowInProgress: "En cours",
    productComplianceWorkflowApproved: "Approuvé",
    productComplianceWorkflowObsolete: "Obsolète",
    productComplianceMaterialTimelineSummaryPending: "En attente de revision",
    productComplianceMaterialTimelineSummaryPendingDescription:
      "Versions en attente de publication",
    productComplianceMaterialTimelineSummaryApproved: "Approuve",
    productComplianceMaterialTimelineSummaryApprovedDescription:
      "Versions avec conformite validee",
    productComplianceMaterialTimelineSummarySuperseded: "Remplace",
    productComplianceMaterialTimelineSummarySupersededDescription:
      "Versions conservees pour la tracabilite",
    productComplianceMaterialTimelineSectionTitle: "Timeline complete",
    productComplianceMaterialTimelineSectionSubtitle:
      "Versions SDS chronologiques, statut, imports et dernieres modifications",
    productComplianceMaterialTimelineFamilySearchPlaceholder:
      "Rechercher par CAS, fournisseur ou matériau...",
    productComplianceMaterialTimelineFamilyMaterial: "Matériau",
    productComplianceMaterialTimelineFamilySupplier: "Fournisseur",
    productComplianceMaterialTimelineFamilyVersions: "Versions",
    productComplianceMaterialTimelineOrderAz: "A-Z",
    productComplianceMaterialTimelineOrderNewest: "Plus recent",
    productComplianceMaterialTimelineOrderOldest: "Plus ancien",
    productComplianceMaterialTimelineSearchPlaceholder:
      "Rechercher par version, fournisseur ou changement...",
    productComplianceMaterialTimelineImported: "Import",
    productComplianceMaterialTimelineLatestChanges: "Dernieres modifications",
    productComplianceMaterialTimelineEmpty:
      "Aucune entree de timeline trouvee pour la recherche en cours.",
    productComplianceMaterialTimelineShortcutsTitle: "Raccourcis",
    productComplianceMaterialTimelineShortcutGenealogy:
      "Ouvrir la genealogie recursive",
    productComplianceMaterialTimelineShortcutEvidence:
      "Composer le dossier de preuves",
    productComplianceMaterialTimelineShortcutLabel: "Imprimer l'etiquette GHS",
    productComplianceMaterialTimelineLegendTitle: "Legende des statuts",
    productComplianceMaterialTimelineCompositionTitle: "Composition",
    productComplianceMaterialTimelineCharacteristicsTitle:
      "Caracteristiques matériau",
    productComplianceMaterialTimelineDocumentSignalsTitle:
      "Signaux documentaires",
    productComplianceMaterialTimelineFieldSupplier: "Fournisseur",
    productComplianceMaterialTimelineFieldUfi: "UFI",
    productComplianceMaterialTimelineFieldSubstance: "Substance",
    productComplianceMaterialTimelineFieldConcentration: "Concentration",
    productComplianceMaterialTimelineFieldSection3Source: "Source section 3",
    productComplianceMaterialTimelineFieldParsingStatus: "Statut du parsing",
    productComplianceMaterialTimelineFieldSectionsDetected:
      "Sections detectees",
    productComplianceMaterialTimelineFieldMissingSections:
      "Sections manquantes",
    productComplianceMaterialTimelineFieldAcceptability: "Acceptabilite",
    productComplianceMaterialTimelineFieldAdditional:
      "Informations complementaires",
    productComplianceMaterialTimelineNotAvailable: "Non disponible",
    productComplianceMaterialTimelineAcceptabilityAccepted: "Accepte",
    productComplianceMaterialTimelineAcceptabilityRejected: "Rejete",
    productComplianceMaterialTimelineAcceptabilityPending: "En attente",
    productComplianceMaterialTimelineSection3SourceHttp: "API extracteur",
    productComplianceMaterialTimelineSection3SourceDeterministic:
      "Analyse deterministe",
    productComplianceMaterialTimelineSection3SourceHttpDisabled:
      "Extracteur desactive",
    productComplianceMaterialTimelineParsingComplete: "Complet",
    productComplianceMaterialTimelineParsingIncomplete: "Incomplet",
    productComplianceStatusPendingReview: "En attente de revision",
    productComplianceStatusApproved: "Approuve",
    productComplianceStatusSuperseded: "Remplace",
    productComplianceMaterialSodiumHydroxide: "Hydroxyde de sodium 50%",
    productComplianceMaterialSulfuricAcid: "Acide sulfurique 98%",
    productComplianceSupplierChemcorp: "Fournisseur : ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Fournisseur : GlobalChem Ltd.",
    productComplianceMaterialTimelineChangeSodium20Section2:
      "Section 2 : pictogrammes corrosifs mis a jour",
    productComplianceMaterialTimelineChangeSodium20Section16:
      "Section 16 : references CLP harmonisees",
    productComplianceMaterialTimelineChangeSodium21Section8:
      "Section 8 : seuils d'exposition alignes pour le site de Lyon",
    productComplianceMaterialTimelineChangeSodium21Section11:
      "Section 11 : formulation toxicologique clarifiee",
    productComplianceMaterialTimelineChangeSodium30Section8:
      "Section 8 : EPI renforces, visiere obligatoire",
    productComplianceMaterialTimelineChangeSodium30Section2:
      "Section 2 : mention d'avertissement modifiee de Warning a Danger",
    productComplianceMaterialTimelineChangeSodium30Section15:
      "Section 15 : references reglementaires completees",
    productComplianceMaterialTimelineChangeSodium12Section3:
      "Section 3 : concentration nominale 49-51%",
    productComplianceMaterialTimelineChangeSodium12Section8:
      "Section 8 : equivalence fonctionnelle confirmee",
    productComplianceMaterialTimelineChangeSodium12Section16:
      "Section 16 : addendum transport ajoute",
    productComplianceMaterialTimelineChangeSulfuric15Section8:
      "Section 8 : protection supplementaire des mains pour le remplissage a chaud",
    productComplianceMaterialTimelineChangeSulfuric15Section14:
      "Section 14 : classification de transport ONU affinee",
    productComplianceMaterialTimelineDeleteVersion: "Supprimer la version",
    productComplianceMaterialTimelineDeleteFamily: "Supprimer la famille",
    productComplianceMaterialTimelineDeleteVersionConfirmTitle:
      "Supprimer la version",
    productComplianceMaterialTimelineDeleteVersionConfirmMessage:
      'Etes-vous sur de vouloir supprimer la version "{version}" ? Cette action est irreversible.',
    productComplianceMaterialTimelineDeleteFamilyConfirmTitle:
      "Supprimer la famille de documents",
    productComplianceMaterialTimelineDeleteFamilyConfirmMessage:
      "Etes-vous sur de vouloir supprimer cette famille de documents avec ses {count} version(s) ? Cette action est irreversible.",
    productComplianceMaterialTimelineDeleteVersionSuccess:
      "Version supprimee avec succes",
    productComplianceMaterialTimelineDeleteFamilySuccess:
      "Famille de documents supprimee avec succes ({count} version(s))",
    productComplianceMaterialTimelineDeleteError:
      "Erreur lors de la suppression",
    sdsTimelineBackToWorkspace: "Retour a l'espace de travail",
    sdsTimelineExportEvidence: "Exporter les preuves",
    sdsTimelineViewComparison: "Voir la comparaison",
    sdsImportDialogTitle: "Importer SDS",
    sdsImportAsyncDescription:
      "Le document est enregistré et extrait en arrière-plan. Vous pouvez continuer à travailler.",
    sdsImportFileSize: "Taille du fichier",
    sdsImportSelectMaterial: "Matériau",
    sdsImportSelectMaterialPlaceholder: "Sélectionner un matériau existant",
    sdsImportGuidance:
      "1. Sélectionner ou créer un matériau · 2. Importer la fiche de données de sécurité · 3. Suivre l'extraction en arrière-plan",
    sdsImportCreateMaterial: "Créer un matériau",
    sdsImportCreateMaterialTitle: "Créer un matériau",
    sdsImportCreateMaterialDescription:
      "Après l'enregistrement, le nouveau matériau est sélectionné pour cette fiche de données de sécurité.",
    sdsImportButtonStartExtraction: "Démarrer l'extraction",
    sdsImportAccepted: "L'extraction de la FDS a démarré.",
    sdsExtractionStatusLabel: "État de l'extraction",
    sdsExtractionStatusextracting: "Extraction en cours",
    sdsExtractionStatusready: "Prêt",
    sdsExtractionStatusfailed: "Échec",
    sdsExtractionStatusstale: "Expirée",
    sdsExtractionFailed: "L'extraction de la FDS a échoué.",
    sdsExtractionRetry: "Réessayer l'extraction",
    sdsExtractionRetryAccepted: "L'extraction de la FDS a redémarré.",
    sdsImportStepValidating: "Validation du fichier...",
    sdsImportStepExtractingText: "Extraction du texte...",
    sdsImportStepParsingSections: "Analyse des sections...",
    sdsImportStepExtractingIdentity: "Extraction de l'identité...",
    sdsImportStepExtractingSubstances: "Extraction des substances...",
    sdsImportStepResolvingSupplier: "Recherche du fournisseur...",
    sdsImportStepResolvingMaterial: "Recherche du matériau...",
    sdsImportStepComplete: "Extraction terminée",
    sdsImportSectionDocument: "Document",
    sdsImportSectionMaterial: "Matériau",
    sdsImportSectionSupplier: "Fournisseur",
    sdsImportSectionSubstances: "Substances",
    sdsImportSectionSections: "Sections",
    sdsImportSectionComment: "Commentaire",
    sdsImportFieldFilename: "Fichier",
    sdsPolicyContext: "Contexte de politique",
    sdsPolicyJurisdiction: "Juridiction",
    sdsPolicyMarkets: "Marchés",
    sdsPolicyProductScopes: "Domaines de produit",
    sdsPolicyUfiState: "État UFI",
    sdsPolicyUfiStateunknown: "Inconnu",
    sdsPolicyUfiStatepresent: "Présent",
    sdsPolicyUfiStateabsent: "Absent",
    sdsPolicyUnconfigured: "Contexte de politique non configuré",
    sdsPolicyContextReasonufi_state_unknown:
      "L’état UFI n’est pas encore déterminé par une extraction terminée.",
    sdsPolicyContextReasonno_matching_regulatory_policy:
      "Aucune version de politique réglementaire correspondante.",
    sdsPolicyContextReasonno_matching_organization_control_profile:
      "Aucun profil de contrôle organisationnel correspondant.",
    sdsPolicyAmbiguous: "Contexte de politique ambigu",
    sdsPolicyAmbiguousDescription:
      "Un administrateur de politique autorisé doit confirmer une paire correspondante.",
    sdsPolicyRegulatoryVersion: "Version de politique réglementaire",
    sdsPolicyControlVersion: "Version de profil de contrôle",
    sdsPolicyConfirmationRationale: "Justification",
    sdsPolicyConfirm: "Confirmer l’applicabilité",
    sdsPolicyStatus: "État",
    sdsPolicyConfirmed: "Confirmé",
    sdsPolicyResolved: "Résolu",
    sdsPolicyConfirmationSaved:
      "L’applicabilité de la politique a été confirmée.",
    sdsPolicyRegulatoryPolicies: "Politiques réglementaires",
    sdsPolicyControlProfiles: "Profils de contrôle organisationnels",
    sdsPolicyVersions: "Versions",
    sdsPolicyEmpty: "Aucune politique disponible.",
    sdsPolicyCreateRegulatory: "Créer une politique réglementaire",
    sdsPolicyCreateControl: "Créer un profil de contrôle",
    sdsPolicyEffectiveFrom: "Valide à partir du",
    sdsPolicyEffectiveUntil: "Valide jusqu’au",
    sdsPolicyUfiApplicability: "Applicabilité UFI",
    sdsPolicyUfiRequired: "Requis",
    sdsPolicyUfiOptional: "Optionnel",
    sdsPolicyUfiNotApplicable: "Non applicable",
    sdsPolicyRuleSubject: "Sujet de règle",
    sdsPolicyRuleCondition: "Condition de règle",
    sdsPolicyEvaluationMode: "Méthode d'évaluation",
    sdsPolicyEvaluationModeReviewerAssessed: "Évalué par un réviseur",
    sdsPolicyEvaluationModereviewer_assessed: "Évalué par un réviseur",
    sdsPolicyEvidenceRequirements: "Exigences de preuve",
    sdsPolicySeverity: "Gravité",
    sdsPolicySeverityLow: "Faible",
    sdsPolicySeverityMedium: "Moyenne",
    sdsPolicySeverityHigh: "Élevée",
    sdsPolicySeverityCritical: "Critique",
    sdsPolicyBlockingEffect: "Effet de blocage",
    sdsPolicyBlockingEffectNone: "Aucun",
    sdsPolicyBlockingEffectAssessment: "Bloquer l’évaluation",
    sdsPolicyBlockingEffectApproval: "Bloquer l’approbation",
    sdsPolicyCitationSource: "Source",
    sdsPolicyCitationReference: "Référence",
    sdsPolicyCitationUrl: "URL de source",
    sdsPolicyControlRequirement: "Exigence de contrôle",
    sdsPolicyRegulatoryRuleId: "ID de règle réglementaire",
    sdsPolicyControlEffect: "Effet de contrôle",
    sdsPolicyControlEffectAdditional: "Exigence supplémentaire",
    sdsPolicyControlEffectStrengthen: "Renforcer l’exigence",
    sdsImportFieldPages: "Pages",
    sdsImportFieldLanguage: "Langue",
    sdsImportFieldRevisionDate: "Date de révision",
    sdsImportFieldMaterialName: "Nom du matériau",
    sdsImportFieldMaterialNumber: "Numéro de matériau",
    sdsImportFieldTradeName: "Nom commercial",
    sdsImportFieldUfi: "UFI",
    sdsImportConfidence: "Confiance : {value}%",
    sdsImportFieldSupplierName: "Nom du fournisseur",
    sdsImportSupplierNotFound:
      "Fournisseur introuvable dans le registre. Vous pouvez lier ce SDS à un fournisseur existant ou accepter une nouvelle entrée.",
    sdsImportMaterialNotFound:
      "Matériau introuvable dans le catalogue. Vous pouvez lier ce SDS à un matériau existant ou accepter une nouvelle entrée.",
    sdsImportLinkExistingSupplier: "Lier un fournisseur existant",
    sdsImportLinkExistingMaterial: "Lier un matériau existant",
    sdsSupplierListTitle: "Fournisseurs",
    sdsSupplierAddButton: "Ajouter un fournisseur",
    sdsMaterialCreated: "Le matériau a été créé.",
    sdsSupplierEmptyState: "Aucun fournisseur disponible.",
    sdsSupplierBackendNotice:
      "La gestion des fournisseurs necessite une mise a jour backend — la liste apparaitra des qu'elle sera disponible.",
    sdsSupplierContact: "Contact",
    sdsSupplierMaterialsCount: "Matériaux",
    sdsSupplierSdsDocuments: "Documents SDS",
    sdsSupplierSdsEmptyState: "Aucun document SDS disponible.",
    sdsSupplierFieldName: "Nom",
    sdsSupplierFieldCode: "Code",
    sdsSupplierFieldCountry: "Pays",
    sdsSupplierFieldAddress: "Adresse",
    sdsSupplierFieldContactName: "Nom du contact",
    sdsSupplierFieldContactEmail: "Email du contact",
    sdsSupplierFieldContact: "Contact",
    sdsSupplierFieldStatus: "Statut",
    sdsSupplierFieldNotes: "Notes",
    sdsSupplierCodePlaceholder: "Code fournisseur",
    sdsSupplierStatusActive: "Actif",
    sdsSupplierStatusInactive: "Inactif",
    sdsSupplierStatusUnderReview: "En revision",
    sdsSupplierSavedSuccess: "Fournisseur enregistre avec succes.",
    sdsSupplierDetailTitle: "Details du fournisseur",
    sdsSupplierNotVerified: "Non vérifié",
    sdsSupplierFormCrudNotice:
      "La création et la modification de fournisseurs nécessitent une mise à jour du backend. Vous pouvez déjà remplir le formulaire.",
    sdsImportFieldLongComment: "Note",
    sdsImportSubstanceName: "Nom",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Concentration",
    sdsImportSubstanceAdd: "Ajouter une substance",
    sdsImportButtonConfirm: "Confirmer l'import",
    sdsImportStatusFound: "Trouvé",
    sdsImportStatusCreated: "Nouveau",
    sdsImportStatusNotFound: "Non trouvé",
    sdsImportStatusError: "Erreur",
    sdsImportConfirmSuccess: "Import confirmé avec succès",
    sdsImportConfirmSuccessWithMaterial: "SDS importé avec succès — {material}",
    sdsImportAnalyzing: "Analyse en cours...",
    sdsImportStreamError: "Erreur lors de l'extraction",
    sdsImportWarnings: "Avertissements",
    sdsImportPreviewReady: "Aperçu prêt — vérifiez les champs et confirmez",
    sdsImportNoFile: "Aucun fichier sélectionné",
    sdsImportUfiInvalid:
      "Format invalide — attendu : XXXX-XXXX-XXXX-XXXX (ex. A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Numéro CAS invalide — attendu : XXXXXXX-XX-X avec chiffre de contrôle valide",
    sdsNavApplication: "FDS",
    sdsNavDashboard: "Tableau de bord",
    sdsNavInbox: "Tableau de bord",
    sdsNotAvailable: "Non disponible",
    sdsInboxTitle: "Tableau de bord",
    sdsInboxUpload: "Téléverser une FDS",
    sdsInboxSearchPlaceholder: "Rechercher un document, produit ou fournisseur",
    sdsInboxExtractionFilter: "État de l'extraction",
    sdsInboxResolutionFilter: "État de résolution",
    sdsInboxSupplierResolutionFilter: "Résolution de l'émetteur",
    sdsInboxMaterialResolutionFilter: "Affectation du matériau",
    sdsInboxReviewFilter: "État de révision",
    sdsInboxValidityFilter: "Validité",
    sdsInboxSupplierFilter: "Émetteur",
    sdsInboxMaterialFilter: "Matériau",
    sdsInboxAllStates: "Tous les états",
    sdsInboxDocument: "Document",
    sdsInboxVersion: "Version {version}",
    sdsInboxRevisionDate: "Date de révision",
    sdsInboxIdentity: "Identité extraite",
    sdsInboxIssuer: "Émetteur",
    sdsInboxRelatedMaterials: "Matériaux associés",
    sdsInboxRelatedMaterialsCount: "{count} associés",
    sdsInboxExtraction: "Extraction",
    sdsInboxResolution: "Résolution",
    sdsInboxReview: "État de révision",
    sdsInboxValidity: "Validité",
    sdsInboxLastActivity: "Dernière activité",
    sdsResolutionStatusunresolved: "Non résolu",
    sdsResolutionStatusin_progress: "En cours",
    sdsResolutionStatusresolved: "Résolu",
    sdsSupplierResolutionStatusunresolved: "Émetteur non résolu",
    sdsSupplierResolutionStatusconfirmed: "Émetteur confirmé",
    sdsSupplierResolutionStatuscorrected: "Émetteur corrigé",
    sdsMaterialResolutionStatusunassigned: "Aucun matériau affecté",
    sdsMaterialResolutionStatusambiguous: "Décision matériau en attente",
    sdsMaterialResolutionStatusassigned: "Matériau affecté",
    sdsValidityStatusvalid: "Valide",
    sdsValidityStatusexpiring: "Expire bientôt",
    sdsValidityStatusexpired: "Expiré",
    sdsValidityStatusunknown: "Validité inconnue",
    sdsWorkflowreceived: "Reçu",
    sdsWorkflowin_progress: "En cours",
    sdsWorkflowapproved: "Approuvé",
    sdsWorkflowobsolete: "Obsolète",
    sdsDocumentTitle: "Document FDS",
    sdsDocumentBackToInbox: "Retour au tableau de bord",
    sdsDocumentRetryExtraction: "Relancer l'extraction",
    sdsDocumentExtractionFailed: "Échec de l'extraction",
    sdsDocumentExtractionFailedDescription:
      "L'extraction n'a pas pu être terminée. Relancez-la ou contactez le support.",
    sdsDocumentExtractionStale: "Extraction expirée",
    sdsDocumentExtractionStaleDescription:
      "L'extraction a dépassé son délai. Relancez l'extraction.",
    sdsDocumentDispatchFailed: "Échec de l'envoi de l'extraction",
    sdsDocumentDispatchFailedDescription:
      "L'extraction n'a pas pu démarrer. Relancez l'envoi.",
    sdsDocumentExtractionAttempt: "Tentative d'extraction",
    sdsDocumentExtractionStarted: "Extraction commencée",
    sdsDocumentExtractionCompleted: "Extraction terminée",
    sdsDocumentAttemptCompleted: "Terminé le",
    sdsDocumentAttemptExtraction: "Méthode et workflow",
    sdsDocumentAttemptProviderModel:
      "Fournisseur : {provider} · Modèle : {model}",
    sdsDocumentAttemptConfidence: "Confiance : {semantics} · {level}",
    sdsDocumentAttemptProvenance: "Provenance",
    sdsDocumentAttemptSourceMode: "Source : {sourceMode}",
    sdsDocumentAttemptNoSourceReferences: "Aucune référence source disponible",
    sdsDocumentAttemptSourcePage: "Page {page}",
    sdsDocumentAttemptSourceSpan: "Page {page}, caractères {start}–{end}",
    sdsDocumentAttemptCompleteProvenance: "Provenance complète",
    sdsDocumentAttemptMissingSections: "Sections manquantes : {sections}",
    sdsDocumentAttemptUnavailableFragments: "Fragments indisponibles : {count}",
    sdsDocumentAttemptIncompleteTableProvenance:
      "Provenance de tableau incomplète",
    sdsDocumentAttemptFailure: "Détails de l'échec",
    sdsDocumentAttemptFailureCode: "Code : {code}",
    sdsDocumentAttemptFailureField: "Champ : {field}",
    sdsDocumentAttemptFailureReason: "Motif : {reason}",
    sdsDocumentAttemptGovernance: "Évaluation de l'extraction",
    sdsDocumentAttemptGovernanceDescription:
      "Évaluation persistée de cette tentative d'extraction. Le backend détermine l'état de préparation à la révision.",
    sdsDocumentAttemptTextSource: "Source du texte",
    sdsDocumentAttemptTextSourcenative_text: "Texte intégré",
    sdsDocumentAttemptTextSourceocr:
      "Reconnaissance optique de caractères (OCR)",
    sdsDocumentAttemptLanguage: "Langue détectée",
    sdsDocumentAttemptLanguageSupportsupported: "Pris en charge",
    sdsDocumentAttemptLanguageSupportunsupported: "Non pris en charge",
    sdsDocumentAttemptRequiredContent: "Contenu obligatoire",
    sdsDocumentAttemptRequiredContentcomplete: "Complet",
    sdsDocumentAttemptRequiredContentincomplete: "Incomplet",
    sdsDocumentAttemptRequiredContentinvalid: "Invalide",
    sdsDocumentAttemptRequiredContentunavailable: "Indisponible",
    sdsDocumentAttemptUncertainty: "Incertitude",
    sdsDocumentAttemptUncertaintynone: "Aucune",
    sdsDocumentAttemptUncertaintycontradictory: "Contradictoire",
    sdsDocumentAttemptReviewReadiness: "État de révision",
    sdsDocumentAttemptReviewreview_ready: "Prêt pour révision",
    sdsDocumentAttemptReviewblocked: "Bloqué",
    sdsDocumentAttemptMissingFields: "Champs obligatoires manquants",
    sdsDocumentAttemptInvalidFields: "Champs obligatoires invalides",
    sdsDocumentAttemptRequiredContentIssue: "{field} : {reason}",
    sdsDocumentAttemptContradictions: "Informations contradictoires",
    sdsDocumentAttemptEvidenceIds: "Identifiants de preuve : {evidenceIds}",
    sdsDocumentAttemptBlockingReasons: "Motifs bloquants",
    sdsDocumentAttemptBlockingReasonunsupported_language:
      "Langue non prise en charge",
    sdsDocumentAttemptBlockingReasonincomplete_required_content:
      "Contenu obligatoire incomplet",
    sdsDocumentAttemptBlockingReasoninvalid_required_content:
      "Contenu obligatoire invalide",
    sdsDocumentAttemptBlockingReasoncontradictory_evidence:
      "Preuves contradictoires",
    sdsDocumentAttemptBlockingReasonmalformed_input: "Entrée malformée",
    sdsDocumentAttemptBlockingReasonterminal_failure: "Échec terminal",
    sdsDocumentFailureRetryable: "Nouvelle tentative possible",
    sdsDocumentFailureNotRetryable: "Nouvelle tentative indisponible",
    sdsDocumentSelectVersion: "Sélectionner une version",
    sdsDocumentTabDocument: "Document et versions",
    sdsDocumentTabExtraction: "Évaluer l'extraction",
    sdsDocumentTabFacts: "Fiche de données de sécurité",
    sdsDocumentTabSupplier: "Émetteur",
    sdsDocumentTabMaterials: "Matériaux applicables",
    sdsDocumentTabEvidence: "Preuves source",
    sdsDocumentTabAssessment: "Évaluation gouvernée",
    sdsDocumentTabActivity: "Activité",
    sdsRevisionComparisonTitle: "Comparaison de révisions",
    sdsRevisionComparisonDescription:
      "Comparez cette révision avec la révision effective actuelle de la même fiche de données de sécurité.",
    sdsRevisionComparisonCreate: "Créer la comparaison",
    sdsRevisionComparisonRefresh: "Actualiser la comparaison",
    sdsRevisionComparisonBaseline: "Révision effective de référence",
    sdsRevisionComparisonCandidate: "Révision candidate",
    sdsRevisionComparisonCreated: "Créée le",
    sdsRevisionComparisonDigest: "Empreinte de comparaison",
    sdsRevisionComparisonBaselineSnapshotId: "ID de l'instantané de référence",
    sdsRevisionComparisonCandidateSnapshotId: "ID de l'instantané candidat",
    sdsRevisionComparisonBaselineInputDigest:
      "Empreinte de l'entrée de référence",
    sdsRevisionComparisonCandidateInputDigest:
      "Empreinte de l'entrée candidate",
    sdsRevisionComparisonCategory: "Catégorie",
    sdsRevisionComparisonAllCategories: "Toutes les catégories",
    sdsRevisionComparisonFactPath: "Chemin du fait",
    sdsRevisionComparisonSection: "Section",
    sdsRevisionComparisonApplyFilters: "Appliquer les filtres",
    sdsRevisionComparisonPosition: "Position",
    sdsRevisionComparisonFactAbsent: "Fait absent",
    sdsRevisionComparisonNoDifferences:
      "Aucun fait ne correspond aux filtres sélectionnés.",
    sdsRevisionComparisonNoSection: "Sans section",
    sdsRevisionComparisonSectionNumber: "Section {section}",
    sdsRevisionComparisonCategoryadded: "Ajouté",
    sdsRevisionComparisonCategoryremoved: "Supprimé",
    sdsRevisionComparisonCategorychanged: "Modifié",
    sdsRevisionComparisonCategoryunchanged: "Inchangé",
    sdsRevisionComparisonCategoryunknown: "Inconnu",
    sdsRevisionComparisonCategorycontradictory: "Contradictoire",
    sdsRevisionComparisonEvidenceTitle: "Preuve source liée",
    sdsRevisionComparisonEvidenceRelation: "Relation de preuve",
    sdsRevisionComparisonEvidenceUnavailable:
      "La preuve source figée n'est pas disponible.",
    sdsAssessmentBlockingOutcome: "Résultat bloquant",
    sdsComplianceActionsTitle: "Actions de conformité",
    sdsComplianceActionsDescription:
      "Travail attribué pour des constatations d'évaluation immuables.",
    sdsComplianceActionsRefresh: "Actualiser les actions",
    sdsComplianceActionsEmpty: "Aucune action de conformité.",
    sdsComplianceActionCreate: "Créer une action de conformité",
    sdsComplianceActionFindings: "Constatations",
    sdsComplianceActionOwner: "Responsable de l'action",
    sdsComplianceActionNewOwner: "Nouveau responsable",
    sdsComplianceActionContext: "Contexte de travail requis",
    sdsComplianceActionDueAt: "Échéance",
    sdsComplianceActionRequired: "Obligatoire",
    sdsComplianceActionBlocking: "Bloquante",
    sdsComplianceActionRationale: "Justification",
    sdsComplianceActionStart: "Commencer le travail",
    sdsComplianceActionComplete: "Terminer",
    sdsComplianceActionReassign: "Réattribuer",
    sdsComplianceActionWaive: "Autoriser une dérogation",
    sdsComplianceActionCancel: "Annuler",
    sdsComplianceActionDisposition: "Enregistrer la disposition",
    sdsComplianceActionDispositionFinding: "Constatation à disposer",
    sdsComplianceActionOverdue: "En retard",
    sdsComplianceActionSaved: "Action de conformité enregistrée.",
    sdsComplianceActionStatusopen: "Ouverte",
    sdsComplianceActionStatusin_progress: "En cours",
    sdsComplianceActionStatuscompleted: "Terminée",
    sdsComplianceActionStatuswaived: "Dérogation accordée",
    sdsComplianceActionStatuscancelled: "Annulée",
    sdsAssessmentStatus: "État de l'évaluation",
    sdsAssessmentCreatedAt: "Créée le",
    sdsAssessmentEffectiveFrom: "Effective à partir de",
    sdsAssessmentEffectiveTimeZone: "Fuseau horaire d'effectivité",
    sdsAssessmentEffectiveStatus: "Statut d'effectivité",
    sdsAssessmentSupersededAt: "Remplacée le",
    sdsAssessmentBaselineAssessment: "Évaluation de référence",
    sdsAssessmentBaselineRevision: "Révision effective de référence",
    sdsAssessmentTerminalRationale: "Justification de clôture",
    sdsAssessmentRegulatoryFindings: "Constats réglementaires",
    sdsAssessmentOrganizationFindings: "Constats organisationnels",
    sdsAssessmentRequirement: "Exigence",
    sdsAssessmentRequirementId: "ID de l'exigence : {requirementId}",
    sdsAssessmentRequirementVersionId:
      "ID de version de l'exigence : {requirementVersionId}",
    sdsAssessmentOutcome: "Résultat",
    sdsAssessmentRationale: "Justification",
    sdsAssessmentComment: "Commentaire",
    sdsAssessmentEvidence: "Preuves source",
    sdsAssessmentEvidenceReference: "Page {page}, paragraphe {paragraph}",
    sdsAssessmentEvidenceReferenceId: "Preuve {evidenceId} ({relation})",
    sdsAssessmentEvaluation: "Évaluation",
    sdsAssessmentReviewedBy: "Révisé par",
    sdsAssessmentCreateDescription:
      "Documentez un résultat, une justification et une preuve source pour chaque exigence réglementaire et organisationnelle.",
    sdsAssessmentCreate: "Créer l'évaluation",
    sdsAssessmentCreated: "Évaluation créée.",
    sdsAssessmentDraftDescription:
      "Les brouillons de constats restent modifiables jusqu'à leur soumission.",
    sdsAssessmentSaveFindingDrafts: "Enregistrer les brouillons de constats",
    sdsAssessmentDraftSaved: "Les brouillons de constats sont enregistrés.",
    sdsAssessmentSubmissionRationale: "Justification de la soumission",
    sdsAssessmentSubmit: "Soumettre l'évaluation",
    sdsAssessmentSubmitted: "L'évaluation a été soumise pour examen.",
    sdsAssessmentCancellationRationale: "Justification de l'annulation",
    sdsAssessmentCancel: "Annuler l'évaluation",
    sdsAssessmentCancelled: "Évaluation annulée.",
    sdsAssessmentRejectionRationale: "Justification du rejet",
    sdsAssessmentReject: "Rejeter l'évaluation",
    sdsAssessmentRejected: "Évaluation rejetée.",
    sdsAssessmentHistory: "Historique des évaluations",
    sdsAssessmentKind: "Type d'évaluation",
    sdsAssessmentKindinitial_baseline: "Référence initiale",
    sdsAssessmentKindcandidate_revision: "Révision candidate",
    sdsAssessmentPolicyRequired:
      "Une applicabilité de politique résolue ou confirmée est requise.",
    sdsAssessmentReviewerRequired:
      "Un rôle de réviseur est requis pour créer l'évaluation.",
    sdsAssessmentReadyForApproval:
      "Tous les constats bloquants sont satisfaits et prêts pour l'approbation.",
    sdsAssessmentBlocked:
      "Les constats bloquants non satisfaits ou inconnus empêchent l'approbation.",
    sdsAssessmentApprovalRationale: "Justification de l'approbation",
    sdsAssessmentInvalidEffectiveDateTime:
      "La date, l'heure et le fuseau horaire IANA doivent définir un instant unique.",
    sdsAssessmentAcceptedExceptions: "Dérogations acceptées",
    sdsAssessmentAcceptedExceptionFinding: "Constat de la dérogation",
    sdsAssessmentAcceptedExceptionRationale: "Justification de la dérogation",
    sdsAssessmentAcceptedAt: "Acceptée le",
    sdsAssessmentAddAcceptedException: "Ajouter une dérogation",
    sdsAssessmentRemoveAcceptedException: "Retirer la dérogation",
    sdsAssessmentApprove: "Approuver l'effectivité",
    sdsAssessmentApproved: "Révision effective approuvée.",
    sdsAssessmentOutcomesatisfied: "Satisfait",
    sdsAssessmentOutcomeunsatisfied: "Non satisfait",
    sdsAssessmentOutcomeunknown: "Inconnu",
    sdsAssessmentOutcomenot_applicable: "Non applicable",
    sdsAssessmentStatuspending_approval: "En attente d'approbation",
    sdsAssessmentStatusscheduled: "Planifiée",
    sdsAssessmentStatuseffective: "Effective",
    sdsAssessmentStatusdraft: "Brouillon",
    sdsAssessmentStatusin_review: "En cours d'examen",
    sdsAssessmentStatusawaiting_actions: "Actions en attente",
    sdsAssessmentStatusapproved: "Approuvée",
    sdsAssessmentStatuscancelled: "Annulée",
    sdsAssessmentStatusrejected: "Rejetée",
    sdsAssessmentStatussuperseded: "Remplacée",
    sdsDocumentResolution: "État de résolution",
    sdsDocumentIssuer: "Émetteur",
    sdsDocumentExtraction: "État de l'extraction",
    sdsDocumentReview: "État de révision",
    sdsDocumentSections: "Sections détectées",
    sdsDocumentLastActivity: "Dernière activité",
    sdsDocumentReceipts: "Occurrences de réception",
    sdsDocumentReceiptFile: "Fichier",
    sdsDocumentReceiptSize: "{size} octets",
    sdsDocumentReceiptReceivedAt: "Reçu le",
    sdsDocumentReceiptChecksum: "Somme de contrôle SHA-256",
    sdsDocumentAttempts: "Tentatives d'extraction",
    sdsDocumentAttemptNumber: "Tentative",
    sdsDocumentAttemptCreated: "Créé le",
    sdsDocumentVersions: "Versions",
    sdsDocumentVersion: "Version {version}",
    sdsDocumentPrintDate: "Date d'impression",
    sdsDocumentFactsAwaitingExtraction:
      "Les données extraites seront disponibles après l'extraction.",
    sdsDocumentProvenance: "Provenance des données",
    sdsDocumentProvenanceDescription:
      "La confiance évalue uniquement la qualité de l'extraction automatisée. Elle est facultative et n'indique pas si des données ont été extraites.",
    sdsDocumentProvenanceField: "Champ",
    sdsDocumentProvenanceSource: "Origine",
    sdsDocumentProvenanceConfidence: "Confiance d'extraction",
    sdsDocumentProvenanceExtractedAt: "Extrait le",
    sdsDocumentProvenanceUpdatedAt: "Mis à jour manuellement le",
    sdsDocumentProvenanceConfidenceNotAssessed:
      "Aucune évaluation de confiance disponible",
    sdsDocumentProvenanceNotManuallyUpdated:
      "Pas encore mis à jour manuellement",
    sdsDocumentProvenanceUnavailable: "Aucune donnée de provenance disponible.",
    sdsDocumentProvenanceSourceextracted: "Extrait",
    sdsDocumentProvenanceSourcemanual: "Vérifié manuellement",
    sdsFactReviewTitle: "Vérifier les données extraites",
    sdsFactReviewSection: "Section de FDS",
    sdsFactReviewDescription:
      "Vérifiez les données extraites automatiquement par section de FDS. Corrigez les valeurs si nécessaire dans la zone suivante.",
    sdsFactMaintenanceDescription:
      "Les données proviennent de l'extraction. Ajustez les informations et enregistrez vos modifications.",
    sdsFactCarryForwardTitle: "Correction de la révision précédente",
    sdsFactCarryForwardDescription:
      "Les valeurs précédemment sélectionnées sont proposées. Vérifiez l'extraction actuelle et reprenez les corrections applicables.",
    sdsFactCarryForwardPreviousExtracted: "Extraction précédente",
    sdsFactCarryForwardPreviousSelected: "Correction précédente",
    sdsFactCarryForwardCurrentExtracted: "Extraction actuelle",
    sdsFactCarryForwardExtractionComparison: "Comparaison des extractions",
    sdsFactCarryForwardExtractionChanged:
      "Extraction modifiée depuis la révision précédente",
    sdsFactCarryForwardExtractionUnchanged: "Extraction inchangée",
    sdsFactCarryForwardAdopt: "Reprendre la correction précédente",
    sdsFactCarryForwardAdopted: "Correction précédente reprise.",
    sdsFactCarryForwardConfirmTitle: "Reprendre la correction précédente ?",
    sdsFactCarryForwardDiscardChanges:
      "Les modifications non enregistrées seront annulées. Enregistrez-les d'abord si vous souhaitez les conserver.",
    sdsFactCarryForwardConfirm: "Reprendre et annuler les modifications",
    sdsFactAuditChangedAt: "Modifié le",
    sdsFactAuditChangedBy: "Modifié par",
    sdsFactAuditSource: "Type de modification",
    sdsFactAuditSourceRevision: "Révision source",
    sdsFactAuditSourcemanual: "Modification manuelle",
    sdsFactAuditSourcecarry_forward: "Correction précédente",
    sdsFactAuditSourcecorrection: "Correction de fait",
    sdsFactAuditSourceacknowledgement: "Confirmation",
    sdsFactReviewProgress: "{reviewed} faits révisés sur {total}",
    sdsFactReviewField: "Champ",
    sdsFactReviewValue: "Valeur",
    sdsFactReviewCurrentValue: "Interprétation actuelle",
    sdsFactReviewCertainty: "Complétude",
    sdsFactReviewDecision: "Décision",
    sdsFactReviewConclusion: "Conclusion",
    sdsFactReviewNoConclusion: "Aucune conclusion canonique",
    sdsFactReviewAccept: "Accepter",
    sdsFactReviewReject: "Rejeter",
    sdsFactReviewCorrect: "Corriger",
    sdsFactReviewAcknowledgeUnknown: "Confirmer l'incertitude",
    sdsFactReviewAcknowledgeContradictory: "Confirmer la contradiction",
    sdsFactReviewSubmit: "Enregistrer la décision",
    sdsFactReviewDialogaccepted: "Accepter l'interprétation",
    sdsFactReviewDialogrejected: "Rejeter l'interprétation",
    sdsFactReviewDialogcorrected: "Corriger l'interprétation",
    sdsFactReviewDialogacknowledged_unknown:
      "Confirmer la conclusion incertaine",
    sdsFactReviewDialogacknowledged_contradictory:
      "Confirmer la conclusion contradictoire",
    sdsFactReviewDecisionpending: "En attente",
    sdsFactReviewDecisionaccepted: "Acceptée",
    sdsFactReviewDecisionrejected: "Rejetée",
    sdsFactReviewDecisioncorrected: "Corrigée",
    sdsFactReviewDecisionacknowledged_unknown: "Incertitude confirmée",
    sdsFactReviewDecisionacknowledged_contradictory: "Contradiction confirmée",
    sdsFactReviewConclusionknown: "Connu",
    sdsFactReviewConclusionunknown: "Inconnu",
    sdsFactReviewConclusioncontradictory: "Contradictoire",
    sdsFactReviewCertaintycomplete: "Complet",
    sdsFactReviewCertaintymissing: "Manquant",
    sdsFactReviewCertaintymalformed: "Incorrect",
    sdsFactReviewCertaintypartial: "Partiel",
    sdsFactReviewCertaintycontradictory: "Contradictoire",
    sdsFactReviewCertaintyunknown_confidence: "Confiance inconnue",
    sdsFactReviewEvidenceTitle: "Preuves source liées",
    sdsFactReviewEvidenceDescription:
      "Sélectionner au moins un paragraphe lié à la tentative et sa relation.",
    sdsFactReviewEvidenceMissing: "Preuve source liée indisponible",
    sdsFactReviewOpenEvidence: "Ouvrir la preuve source",
    sdsFactReviewNoEvidence: "Aucune preuve source liée à ce fait.",
    sdsFactReviewNoEvidenceAvailable:
      "Aucune preuve source disponible pour cette Révision.",
    sdsFactReviewSupporting: "À l'appui",
    sdsFactReviewContradicting: "Contradictoire",
    sdsFactReviewHistoryTitle: "Historique des décisions",
    sdsFactReviewNoHistory: "Aucune décision de révision enregistrée.",
    sdsFactReviewPending: "En attente",
    sdsFactReviewReviewedBy: "Révisé par {reviewer}",
    sdsFactReviewCorrectionsTitle: "Audit des corrections",
    sdsFactReviewAcknowledgementsTitle: "Conclusions confirmées",
    sdsFactReviewPreviousValue: "Valeur précédente",
    sdsFactReviewCorrectedValue: "Valeur corrigée",
    sdsFactReviewReason: "Motif de correction",
    sdsFactReviewConclusionReason: "Justification de la conclusion",
    sdsFactReviewComment: "Commentaire",
    sdsFactReviewSaved: "Décision de révision enregistrée.",
    sdsFactReviewConflictTitle: "Fait révisé simultanément",
    sdsFactReviewConflictMessage:
      "L'état actuel a été rechargé. Vérifiez les modifications avant une nouvelle décision.",
    sdsFactReviewUfiValue: "UFI",
    sdsFactReviewUfiScope: "Portée",
    sdsFactReviewUfiScopeValue: "Valeur de portée",
    sdsFactReviewAddUfi: "Ajouter un UFI",
    sdsFactReviewUfiScopeproductUuid: "Produit",
    sdsFactReviewUfiScopemixtureUuid: "Mélange",
    sdsFactReviewUfiScopemarket: "Marché",
    sdsFactReviewUfiScopelanguage: "Langue",
    sdsDocumentEvidenceUnavailable:
      "Les preuves source sont disponibles après l'enregistrement du résultat d'extraction.",
    sdsDocumentEvidenceSource: "Source",
    sdsDocumentEvidencePage: "Page {page}",
    sdsDocumentEvidenceLocation: "Section SDS {section} · Page {page}",
    sdsDocumentEvidenceSectionUnknown: "inconnue",
    sdsDocumentEvidenceHeadingUnknown: "Titre non détecté",
    sdsDocumentFocusedEvidence: "Preuve source sélectionnée",
    sdsPdfReviewDownload: "Télécharger le PDF",
    sdsPdfReviewPreviousPage: "Page précédente",
    sdsPdfReviewNextPage: "Page suivante",
    sdsPdfReviewPage: "Page",
    sdsPdfReviewPageOf: "sur {count}",
    sdsPdfReviewLoadFailed: "Le PDF original n'a pas pu être chargé.",
    sdsPdfReviewUnavailable:
      "La fiche de données de sécurité originale pour cette version n'est pas disponible.",
    sdsDocumentEvidenceProvenance: "Provenance d'extraction",
    sdsDocumentEvidenceCreated: "Enregistré le",
    sdsDocumentEvidenceContent: "Paragraphe",
    sdsDocumentEvidenceSection: "Section/fait lié",
    sdsDocumentEvidenceUnlinked: "Non lié à un fait",
    sdsDocumentExtractedIdentity: "Identité produit extraite",
    sdsDocumentProductName: "Nom du produit",
    sdsDocumentMaterialNumber: "Numéro du matériau",
    sdsDocumentUfi: "UFI",
    sdsFactsIssuerName: "Nom de l'émetteur",
    sdsDocumentExtractedSupplier: "Fournisseur extrait",
    sdsFactsSelectIssuer: "Sélectionner l'émetteur",
    sdsFactsSelectSupplier: "Sélectionner le fournisseur",
    sdsFactsSection1Title: "Section 1 · Identification",
    sdsFactsSection1Description:
      "Identité du produit, usages et coordonnées de l'émetteur de la fiche.",
    sdsFactsRecommendedUses: "Utilisations recommandées",
    sdsFactsUsesAdvisedAgainst: "Utilisations déconseillées",
    sdsFactsMultilineListHint:
      "Saisissez chaque élément sur une ligne distincte.",
    sdsFactsSupplierAddress: "Adresse de l'émetteur",
    sdsFactsSupplierEmail: "E-mail de l'émetteur",
    sdsFactsSupplierPhone: "Téléphone de l'émetteur",
    sdsFactsEmergencyPhone: "Numéro d'urgence",
    sdsFactsSection2Title: "Section 2 · Identification des dangers",
    sdsFactsSection2Description:
      "Classification, éléments d'étiquetage et autres dangers.",
    sdsFactsPictograms: "Pictogrammes de danger",
    sdsFactsPStatements: "Mentions P",
    sdsFactsOtherHazards: "Autres dangers",
    sdsFactsSection3Title: "Section 3 · Composition",
    sdsFactsSection3Description:
      "Type de substance ou mélange et composants pertinents.",
    sdsFactsSubstanceOrMixture: "Substance ou mélange",
    sdsFactsAddIngredient: "Ajouter un composant",
    sdsFactsIngredient: "Composant {number}",
    sdsFactsCasNumber: "N° CAS",
    sdsFactsEcNumber: "N° CE",
    sdsFactsClassification: "Classification",
    sdsFactsNoIngredients: "Aucun composant enregistré.",
    sdsFactsSection15Title: "Section 15 · Informations réglementaires",
    sdsFactsSection15Description:
      "Réglementations, restrictions et évaluations propres au produit.",
    sdsFactsRegulatoryReferences: "Références réglementaires",
    sdsFactsSevesoCategory: "Catégorie SEVESO",
    sdsFactsWaterHazardClass: "Classe de danger pour l'eau",
    sdsFactsVocValue: "Valeur COV",
    sdsFactsChemicalSafetyAssessment: "Évaluation de la sécurité chimique",
    sdsFactsRestrictions: "Conditions de restriction",
    sdsFactsSvhc: "SVHC",
    sdsFactsMicroplastics: "Microplastiques / SPM",
    sdsDocumentFactsUnavailable: "Aucune donnée extraite disponible.",
    sdsDocumentFactsSaved: "Données extraites enregistrées.",
    sdsDocumentSupplierDecision: "Affectation de l'émetteur",
    sdsDocumentSupplierComment: "Motif de l'affectation",
    sdsDocumentSupplierCommentPlaceholder:
      "Documenter la raison de cette correction",
    sdsDocumentIssuerResolutionDescription:
      "Confirmez l'émetteur après vérification. Corrigez l'affectation ou créez un fournisseur manquant.",
    sdsIssuerEvidenceTitle: "Émetteur extrait et coordonnées",
    sdsCanonicalIssuerTitle: "Émetteur",
    sdsCanonicalIssuerDescription:
      "Sélectionnez ou gérez le partenaire commercial qui a émis cette fiche.",
    sdsCanonicalSupplierTitle: "Fournisseur",
    sdsCanonicalSupplierDescription:
      "Le fournisseur correspond initialement à l'émetteur. Activez la différence uniquement si un autre partenaire fournit le produit.",
    sdsSelectBusinessPartner: "Sélectionner un partenaire commercial",
    sdsSupplierDiffersFromIssuer: "Le fournisseur diffère de l'émetteur",
    sdsDocumentCreateSupplier: "Créer un fournisseur",
    sdsBusinessPartnerEdit: "Modifier le partenaire commercial",
    sdsBusinessPartnerSaved: "Partenaire commercial enregistré.",
    sdsIdentityResolutionTitle: "Affectation de la FDS",
    sdsIdentitySearch: "Rechercher une fiche de données de sécurité existante",
    sdsIdentityAddRevision: "Ajouter comme nouvelle révision",
    sdsIdentityRevisionIdentifier: "Identifiant de révision",
    sdsIdentityReasonIssuerProduct: "Émetteur et produit correspondants",
    sdsIdentityReasonReviewerSearch: "Recherche du réviseur",
    sdsIdentityNewRevisionExplanation:
      "Confirmez l'émetteur, la fiche, le produit et les informations de révision disponibles. Les valeurs manquantes sont autorisées. Le fichier est ajouté comme nouvelle révision ; la révision effective reste inchangée. Les modifications du formulaire non enregistrées ne sont pas reprises.",
    sdsIdentityNewRevisionAdded: "Nouvelle révision ajoutée.",
    sdsIdentityNewRevisionUnresolved:
      "La nouvelle révision n'a pas été confirmée.",
    sdsIdentityResolutionDescription:
      "Examinez les fiches de données de sécurité proposées et affectez ce document. Chaque affectation est confirmée et peut être corrigée par des réviseurs autorisés.",
    sdsIdentityResolutionAmbiguous:
      "Une chronologie contradictoire ou une équivalence de fichier bloque l'association automatique.",
    sdsIdentityResolutionCandidate: "Candidat",
    sdsIdentityResolutionReasons: "Motifs",
    sdsIdentityResolutionActions: "Actions",
    sdsIdentityResolutionIssuer: "Émetteur",
    sdsIdentityResolutionSupplier: "Fournisseur",
    sdsIdentityResolutionAssociate: "Associer",
    sdsIdentityResolutionEstablish: "Établir l'identité",
    sdsIdentityResolutionResolved: "Affectation de la FDS enregistrée",
    sdsIdentityResolutionCanonicalDocument:
      "Fiche de données de sécurité affectée",
    sdsIdentityResolutionCanonicalVersion: "Révision",
    sdsIdentityRevisionDate: "Date de révision",
    sdsIdentityResolutionReasonIssuerAndRevisionIdentifier:
      "Identifiant de l'émetteur et de la révision",
    sdsIdentityResolutionReasonIssuerRevisionDateAndProductName:
      "Émetteur, date de révision et nom du produit",
    sdsIdentityResolutionReasonIdenticalFileChecksum:
      "Empreinte de fichier identique",
    sdsIdentityResolutionReasonConflictingChronology:
      "Chronologie contradictoire",
    "sdsIdentityBlockingReasonreviewed-issuer-required":
      "Sélectionnez l'émetteur pour déterminer les actions disponibles.",
    "sdsIdentityBlockingReasonissuer-mismatch":
      "Le candidat appartient à un autre émetteur.",
    "sdsIdentityBlockingReasoninsufficient-same-revision-evidence":
      "Les preuves sont insuffisantes pour associer la même révision.",
    "sdsIdentityBlockingReasonidentical-file":
      "Un fichier identique ne peut pas être ajouté comme nouvelle révision.",
    "sdsIdentityBlockingReasonnot-latest-revision":
      "Une nouvelle révision ne peut suivre que la dernière révision connue.",
    "sdsIdentityBlockingReasonrevision-date-not-later":
      "La date de révision n'est pas postérieure à la dernière révision connue.",
    "sdsIdentityBlockingReasonrevision-identifier-not-unique":
      "L'identifiant de révision est déjà utilisé.",
    sdsDocumentCreateIssuer: "Créer l'émetteur",
    sdsDocumentConfirmSupplier: "Confirmer l'émetteur",
    sdsDocumentCorrectSupplier: "Corriger l'émetteur",
    sdsSupplierDecisionunresolved: "Non résolu",
    sdsSupplierDecisionconfirmed: "Confirmé",
    sdsSupplierDecisioncorrected: "Corrigé",
    sdsDocumentSupplierConfirmed: "Émetteur confirmé.",
    sdsDocumentSupplierCorrected: "Émetteur corrigé.",
    sdsIssuerCreated: "Émetteur créé.",
    sdsSupplierCreated: "Fournisseur créé.",
    sdsSupplierEmergencyPhone: "Téléphone d’urgence",
    sdsDocumentCandidates: "Matériaux candidats",
    sdsDocumentCandidatesDescription:
      "Vérifiez les résultats d'extraction et prenez une décision explicite.",
    sdsDocumentRefreshCandidates: "Actualiser les matériaux candidats",
    sdsDocumentMaterial: "Matériau",
    sdsDocumentMatchScore: "Score de correspondance",
    sdsDocumentMatchReasons: "Motifs",
    sdsDocumentReviewedEvidence: "Preuves vérifiées",
    sdsDocumentDecision: "Décision",
    sdsCandidateDecisionpending: "En attente",
    sdsCandidateDecisionapproved: "Approuvé",
    sdsCandidateDecisionrejected: "Rejeté",
    sdsDocumentAccept: "Accepter",
    sdsDocumentDismiss: "Rejeter",
    sdsDocumentCandidateAccepted: "Matériau candidat accepté.",
    sdsDocumentCandidateDismissed: "Matériau candidat rejeté.",
    sdsDocumentLinkedMaterials: "Matériaux liés",
    sdsDocumentLinkedMaterialsDescription:
      "Associations dérivées de décisions de révision contrôlées. Elles ne peuvent pas être modifiées indépendamment.",
    sdsDocumentLinkMaterial: "Lier un matériau",
    sdsDocumentCreateAndLink: "Créer et lier un matériau",
    sdsDocumentSearchMaterials: "Rechercher des matériaux",
    sdsDocumentSearchByUfi: "Rechercher UFI",
    sdsDocumentUfiSearchPlaceholder: "Saisir UFI",
    sdsDocumentUfiSearchNoMatches:
      "Aucun matériau ne correspond à cet UFI. Liez un matériau manuellement ou créez-en un.",
    sdsDocumentUfiSearchOneMatch:
      "Un matériau trouvé. Sélectionnez explicitement son lien de matériau basé sur UUID.",
    sdsDocumentUfiSearchAmbiguous:
      "{count} matériaux trouvés. Sélectionnez explicitement un lien de matériau basé sur UUID.",
    sdsDocumentMaterialChoice:
      "{materialName} · {materialNumber} · UUID : {materialUuid}",
    sdsDocumentApplicability: "Applicabilité",
    sdsDocumentApplicable: "Applicable",
    sdsDocumentNotApplicable: "Non applicable",
    sdsDocumentPreferred: "Préférée",
    sdsDocumentPreferredSelected: "Préférée",
    sdsDocumentSelectPreferred: "Définir comme préférée",
    sdsDocumentPreferredSaved: "Version FDS préférée enregistrée.",
    sdsDocumentMaterialLinked: "Matériau lié.",
    sdsDocumentMaterialCreated: "Matériau créé et lié.",
    sdsDocumentRetryAccepted: "Extraction relancée.",
    sdsDocumentActivityReceived: "Document FDS reçu.",
    sdsMaterialSearchPlaceholder: "Rechercher des matériaux",
    sdsMaterialPrimarySupplier: "Fournisseur principal",
    sdsMaterialOpenWorkspace: "Afficher les FDS",
    sdsMaterialWorkspace: "FDS du matériau",
    sdsMaterialMasterData: "Données de base du matériau",
    sdsMaterialSaved: "Données de base du matériau enregistrées.",
    sdsMaterialBackToCatalog: "Retour aux matériaux",
    sdsMaterialLinkedDocuments: "Documents FDS liés",
    sdsMaterialLinkedDocumentsDescription:
      "Toutes les versions FDS, les émetteurs et les décisions d'applicabilité de ce matériau.",
    sdsMaterialNoLinkedDocuments: "Aucune FDS n'est encore liée à ce matériau.",
    sdsSupplierSearchPlaceholder: "Rechercher des fournisseurs",
    sdsIdentityDecision: "Type d'affectation",
    sdsIdentityDecisionTimestamp: "Décidé le",
    sdsIdentityCorrectDecision: "Corriger l'affectation",
    sdsIdentityCorrectionHint:
      "Si l'affectation est incorrecte, vous pouvez la corriger. L'affectation précédente reste traçable.",
    sdsIdentityDecisionSummaryassociate: "Même révision de FDS",
    sdsIdentityDecisionSummaryadd_revision:
      "Nouvelle révision d'une fiche de données de sécurité existante",
    sdsIdentityDecisionSummaryestablish:
      "Fiche de données de sécurité indépendante",
  },
};
